import {
  countryListDE,
  countryListEN,
  countryListES,
  countryListFR,
  countryListIT,
} from "./countriesData";

const translationData = [
  {
    FIELD1: "signup.helmet.title",
    English: "colla Sign-Up",
    French: "Inscription à colla",
    German: "colla anmelden",
    Spanish: "Registro en colla",
    Italian: "Registrazione colla",
  },
  {
    FIELD1: "signup.helmet.desc",
    English:
      "Sign up to colla to register and activate your trackers and get full access to our platform.",
    French:
      "Inscrivez-vous à colla pour enregistrer et activer vos traceurs et obtenir un accès complet à notre plateforme.",
    German:
      "Melden Sie sich bei colla an, um Ihre Tracker zu registrieren und zu aktivieren und vollen Zugriff auf unsere Plattform zu erhalten.",
    Spanish:
      "Regístrese en colla para registrar y activar sus rastreadores y obtener acceso completo a nuestra plataforma.",
    Italian:
      "Registrati su colla per attivare i tuoi dispositivi e ottenere l'accesso completo alla nostra piattaforma.",
  },
  {
    FIELD1: "signup.main.title",
    English: "Welcome to the pack!",
    French: "Bienvenue dans la meute !",
    German: "Willkommen im Rudel!",
    Spanish: "¡Bienvenido a la manada!",
    Italian: "Benvenuto nel branco!",
  },
  {
    FIELD1: "signup.main.login_statement",
    English: "Already have an account?",
    French: "Vous avez déjà un compte ?",
    German: "Sie haben bereits ein Konto?",
    Spanish: "¿Ya tiene una cuenta?",
    Italian: "Hai già un account?",
  },
  {
    FIELD1: "signup.main.login_btn",
    English: "Sign in",
    French: "Se connecter",
    German: "Anmelden",
    Spanish: "Iniciar sesión",
    Italian: "Accedi",
  },
  {
    FIELD1: "signup.main.placeholder_name",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
  },
  {
    FIELD1: "signup.main.placeholder_email",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
  },
  {
    FIELD1: "signup.main.placeholder_password",
    English: "Password",
    French: "Mot de passe",
    German: "Passwort",
    Spanish: "Contraseña",
    Italian: "Password",
  },
  {
    FIELD1: "signup.main.placeholder_confirm",
    English: "Confirm Password",
    French: "Confirmer le mot de passe",
    German: "Passwort bestätigen",
    Spanish: "Confirmar contraseña",
    Italian: "Confirm Password",
  },
  {
    FIELD1: "signup.main.select_country",
    English: "Select your country...",
    French: "Sélectionner votre pays...",
    German: "Wählen Sie ihr Land aus...",
    Spanish: "Seleccione su país...",
    Italian: "Seleziona il tuo paese...",
  },
  {
    FIELD1: "signup.main.char8",
    English: "8 characters or longer",
    French: "8 caractères ou plus",
    German: "8 Charackter oder mehr",
    Spanish: "8 caracteres o más",
    Italian: "8 caratteri o più",
  },
  {
    FIELD1: "signup.main.combine",
    English: "Combine",
    French: "Combiner",
    German: "Kombinieren",
    Spanish: "Combine",
    Italian: "Combina",
  },
  {
    FIELD1: "signup.main.uppercase",
    English: "uppercase letters",
    French: "lettres majuscules",
    German: "großbuchstaben",
    Spanish: "letras mayúsculas",
    Italian: "lettere maiuscole",
  },
  {
    FIELD1: "signup.main.lowercase",
    English: "lowercase letters",
    French: "lettres minuscules",
    German: "Kleinbuchstaben",
    Spanish: "letras minúsculas",
    Italian: "lettere minuscole",
  },
  {
    FIELD1: "signup.main.and",
    English: "and",
    French: "et",
    German: "und",
    Spanish: "y",
    Italian: "e",
  },
  {
    FIELD1: "signup.main.numbers",
    English: "numbers",
    French: "chiffres",
    German: "Zahlen",
    Spanish: "números",
    Italian: "numeri",
  },
  {
    FIELD1: "signup.main.match",
    English: "Passwords match",
    French: "Les mots de passe correspondent",
    German: "Passwörter stimmen überein",
    Spanish: "Las contraseñas coinciden",
    Italian: "Le password coincidono",
  },
  {
    FIELD1: "signup.main.promotions",
    English:
      "Keep me in the loop with Colla updates! I don’t want to miss out on service news, special offers, rewards, and more.",
    French:
      "Tenez-moi au courant des mises à jour de Colla ! Je ne veux pas manquer les nouvelles du service, les offres spéciales, les récompenses et bien plus encore.",
    German:
      "Halten Sie mich über Colla-Updates auf dem Laufenden! Ich möchte keine Service-News, Sonderangebote, Belohnungen und mehr verpassen.",
    Spanish:
      "¡Manténgame informado sobre las actualizaciones de Colla! No quiero perderme las noticias del servicio, ofertas especiales, recompensas y más.",
    Italian:
      "Tienimi aggiornato sulle novità di Colla! Non voglio perdermi le notizie del servizio, le offerte speciali, i premi e altro ancora.",
  },
  {
    FIELD1: "signup.main.terms_and_services_accept",
    English: "I accept the ",
    French: "J'accepte les ",
    German: "Ich akzeptiere die ",
    Spanish: "Acepto las",
    Italian: "I accept the ",
  },
  {
    FIELD1: "signup.main.terms_and_services_link",
    English: "Terms of Service",
    French: "Conditions d'utilisation.",
    German: "Nutzungsbedingungen",
    Spanish: "Condiciones del servicio",
    Italian: "Terms of Service",
  },
  {
    FIELD1: "signup.main.button",
    English: "Create Account",
    French: "Créer un compte",
    German: "Konto erstellen",
    Spanish: "Crear cuenta",
    Italian: "Crea un account",
  },
  {
    FIELD1: "signup.main.error_general",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen ",
    Spanish: "Algo ha ido mal, por favor inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto, riprova più tardi.",
  },
  {
    FIELD1: "signup.main.error_empty_fields",
    English: "Fields can't be empty",
    French: "Les champs ne doivent pas être vides",
    German: "Die Felder könen nicht leer gelassen werden",
    Spanish: "Los campos no pueden estar vacíos",
    Italian: "Questi campi non possono essere vuoti",
  },
  {
    FIELD1: "signup.main.error_name_length",
    English: "Name length must be min 1 and max 100 letters",
    French: "La longueur du nom doit être comprise entre 1 et 100 lettres.",
    German:
      "Die Länge des Namens muss mindestens 1 und max 100 Buchstaben habe",
    Spanish: "La longitud del nombre debe ser mínimo 1 y máximo 100 letras",
    Italian: "La lunghezza del nome deve essere compresa tra 1 e 100 lettere.",
  },
  {
    FIELD1: "signup.main.error_email_invalid",
    English: "Please enter a valid email address.",
    French: "Veuillez saisir une adresse e-mail valide.",
    German: "Bitte geben Sie eine gültige E-Mail Adresse ein",
    Spanish: "Introduzca una dirección de correo electrónico válida.",
    Italian: "Sei pregato di inserire un indirizzo e-mail valido.",
  },
  {
    FIELD1: "signup.main.error_email_exists",
    English:
      "This email is associated with an existing account. Please login by clicking the link below.",
    French:
      "Cet e-mail est lié à un compte existant. Veuillez vous connecter en cliquant sur le lien ci-dessous.",
    German:
      "Diese E-Mail ist mit einem bestehenden Konto verknüpft. Bitte loggen Sie sich ein, indem Sie auf den unten stehenden Link klicken",
    Spanish:
      "Este correo electrónico está asociado a una cuenta existente. Inicie sesión haciendo clic en el siguiente enlace.",
    Italian:
      "Questa e-mail è associata a un account esistente. Effettua il login facendo clic sul link sottostante.",
  },
  {
    FIELD1: "signup.main.error_password_short",
    English: "Passwords should be at least 8 characters long.",
    French: "Les mots de passe doivent comporter au moins 8 caractères.",
    German: "Passwörter sollten mindestens 8 Charackter lang sein. ",
    Spanish: "Las contraseñas deben tener al menos 8 caracteres.",
    Italian: "Le password devono essere lunghe almeno 8 caratteri.",
  },
  {
    FIELD1: "signup.main.error_password_invalid",
    English:
      "Passwords should contain at least one uppercase letter, one lower case letter and one number.",
    French:
      "Les mots de passe doivent contenir au moins une lettre majuscule, une lettre minuscule et un chiffre.",
    German:
      "Passwörter sollten mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten.",
    Spanish:
      "Las contraseñas deben contener al menos una letra mayúscula, una letra minúscula y un número.",
    Italian:
      "Le password devono contenere almeno una lettera maiuscola, una lettera minuscola e un numero.",
  },
  {
    FIELD1: "signup.main.error_passwords_not_matched",
    English: "Passwords do not match.",
    French: "Les mots de passe ne correspondent pas.",
    German: "Die Passwörter stimmen nicht überein",
    Spanish: "Las contraseñas no coinciden.",
    Italian: "Le password non coincidono.",
  },
  {
    FIELD1: "signup.main.error_tos",
    English: "Please accept the terms of service to complete registration",
    French:
      "Veuillez accepter les conditions d'utilisation pour terminer l'inscription",
    German:
      "Bitte akzeptiere die Geschäftsbedingungen ge , um die Anmeldung zu beenden",
    Spanish: "Acepte las condiciones del servicio para completar el registro.",
    Italian: "Accetta i termini di servizio per completare la registrazione",
  },
  {
    FIELD1: "signup.main.error_captcha",
    English: "Please complete the captcha",
    French: "Veuillez compléter le captcha",
    German: "Bitte beende die Captcha",
    Spanish: "Complete el captcha",
    Italian: "Sei pregato di completare il captcha",
  },
  {
    FIELD1: "signup.main.error_confirm",
    English:
      "Something went wrong with your signup, can you try again? Or please send us a message we can get you on board!",
    French:
      "Un problème est survenu lors de votre inscription, pouvez-vous réessayer ? Ou envoyez-nous un message et nous vous aiderons à vous inscrire !",
    German:
      "Bei Ihrer Anmeldung ist ein Fehler aufgetreten. Können Sie es noch einmal versuchen? Oder senden Sie uns eine Nachricht, damit wir Sie an Bord holen können!",
    Spanish:
      "Algo salió mal con tu registro, ¿puedes intentarlo de nuevo? O envíanos un mensaje y te ayudaremos a unirte!",
    Italian:
      "Qualcosa è andato storto con la tua iscrizione, puoi riprovare? O inviaci un messaggio e ti aiuteremo a salire a bordo!",
  },
  {
    FIELD1: "signup.main.error_send_code_failed",
    English:
      "Sorry, we had a problem sending the code to your email. Please send us a message and we'll get you up and running!",
    French:
      "Désolé, nous avons rencontré un problème lors de l'envoi du code à votre adresse e-mail. Veuillez nous envoyer un message et nous vous aiderons à démarrer !",
    German:
      "Entschuldigung, es gab ein Problem beim Senden des Codes an Ihre E-Mail-Adresse. Bitte senden Sie uns eine Nachricht, und wir bringen Sie zum Laufen!",
    Spanish:
      "Lo sentimos, tuvimos un problema al enviar el código a tu correo electrónico. ¡Envíanos un mensaje y te pondremos en funcionamiento!",
    Italian:
      "Ci dispiace, abbiamo avuto un problema nell'invio del codice al tuo indirizzo email. Inviaci un messaggio e ti aiuteremo a iniziare!",
  },
  {
    FIELD1: "login.helmet.title",
    English: "colla Login",
    French: "Connexion à colla",
    German: "colla Login",
    Spanish: "Inicio de sesión en colla",
    Italian: "Accesso a colla",
  },
  {
    FIELD1: "login.helmet.desc",
    English: "Login to your colla account to monitor and manage your trackers.",
    French:
      "Connectez-vous à votre compte colla pour surveiller et gérer vos traceurs.",
    German:
      "Melden Sie sich in Ihrem colla-Konto an, um Ihre Tracker zu überwachen und zu verwalten.",
    Spanish:
      "Inicie sesión en su cuenta colla para supervisar y gestionar sus rastreadores.",
    Italian:
      "Accedi al tuo account colla per monitorare e gestire i dispositivi.",
  },
  {
    FIELD1: "login.main.title",
    English: "Welcome back to colla",
    French: "Bienvenue à nouveau à colla",
    German: "Willkommen zurück bei colla",
    Spanish: "Bienvenido de nuevo a colla",
    Italian: "Bentornato a colla",
  },
  {
    FIELD1: "login.main.tagline",
    English: "Track. Protect. Love. Manage your pets safety effortlessly.",
    French:
      "Suivre. Protéger. Aimer. Gérez la sécurité de vos animaux de compagnie sans effort.",
    German:
      "Verfolgen. Schützen. Lieben. Verwalten Sie die Sicherheit Ihrer Haustiere mühelos.",
    Spanish:
      "Rastrear. Proteger. Amar. Gestiona la seguridad de tus mascotas sin esfuerzo.",
    Italian:
      "Traccia. Proteggi. Ama. Gestisci la sicurezza dei tuoi animali domestici senza sforzo.",
  },
  {
    FIELD1: "login.main.signup_statement",
    English: "Don't have an account?",
    French: "Vous n'avez pas de compte?",
    German: "Haben Sie kein Konto?",
    Spanish: "¿No tienes una cuenta?",
    Italian: "Non hai un account?",
  },
  {
    FIELD1: "login.main.signup_button",
    English: "Sign up",
    French: "S'inscrire",
    German: "Anmelden",
    Spanish: "Registrarse",
    Italian: "Iscriviti",
  },
  {
    FIELD1: "login.main.placeholder_email",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
  },
  {
    FIELD1: "login.main.placeholder_password",
    English: "Password",
    French: "Mot de passe",
    German: "Passwort",
    Spanish: "Contraseña",
    Italian: "Password",
  },
  {
    FIELD1: "login.main.forget_statement",
    English: "Forgot your password?",
    French: "Vous avez oublié votre mot de passe ?",
    German: "Haben Sie Ihr Passwort vergessen?",
    Spanish: "¿Olvidó su contraseña?",
    Italian: "Hai dimenticato la password?",
  },
  {
    FIELD1: "login.main.stay_signed",
    English: "Stay signed in",
    French: "Rester connecté",
    German: "Eingeloggt bleiben",
    Spanish: "Mantener sesión iniciada",
    Italian: "Rimani connesso",
  },
  {
    FIELD1: "login.main.button",
    English: "Log in",
    French: "S'inscrire",
    German: "Anmeldung",
    Spanish: "Iniciar sesión",
    Italian: "Accedi",
  },
  {
    FIELD1: "login.main.button_loading",
    English: "Logging in",
    French: "S'identifier",
    German: "Anmelden",
    Spanish: "Iniciando sesión",
    Italian: "Accesso",
  },
  {
    FIELD1: "login.main.error_disabled",
    English: "Your account has been suspended, please contact support.",
    French: "Votre compte a été suspendu, veuillez contacter le support.",
    German: "Ihr Konto wurde gesperrt, bitte kontaktieren Sie den Support.",
    Spanish: "Su cuenta ha sido suspendida, por favor contacte con soporte.",
    Italian: "Il tuo account è stato sospeso, contatta il supporto.",
  },
  {
    FIELD1: "login.main.error_general",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, versuchen Sie es bitte später erneut",
    Spanish: "Algo salió mal, por favor inténtelo más tarde.",
    Italian: "Qualcosa è andato storto, riprova più tardi.",
  },
  {
    FIELD1: "login.main.error_incorrect",
    English: "Incorrect username or password.",
    French: "Nom d'utilisateur ou mot de passe incorrect.",
    German: "Falscher Nutzername oder Passwort.",
    Spanish: "Nombre de usuario o contraseña incorrectos.",
    Italian: "Nome utente o password errati.",
  },
  {
    FIELD1: "login.main.error_attempts",
    English:
      "Password attempt limit exceeded, please try again later or reset your password.",
    French:
      "Limite de tentatives de mot de passe dépassée, veuillez réessayer plus tard ou réinitialiser votre mot de passe.",
    German:
      "Limit für Passwortversuche überschritten, bitte versuchen Sie es später erneut oder setzen Sie Ihr Passwort zurück.",
    Spanish:
      "Se ha superado el límite de intentos de contraseña, inténtelo de nuevo más tarde o restablezca su contraseña.",
    Italian:
      "Password attempt limit exceeded, please try again later or reset your password.",
  },
  {
    FIELD1: "login.main.error_not_exist",
    English: "Account could not be found.",
    French: "Le compte n'a pas pu être trouvé.",
    German: "Konto konnte nicht gefunden werden.",
    Spanish: "No se ha encontrado la cuenta.",
    Italian: "L'account non è stato trovato.",
  },
  {
    FIELD1: "mua.main.login_statement",
    English: "Already accepted your account?",
    French: "Vous avez déjà accepté votre compte ?",
    German: "Haben Sie schon Ihr Konto akzeptiert?",
    Spanish: "¿Ya ha aceptado su cuenta?",
    Italian: "Il tuo account è stato già accettato?",
  },
  {
    FIELD1: "mua.main.title",
    English: "Join a colla family!",
    French: "Rejoindre un compte colla existant",
    German:
      "Schließen Sie sich eine einen bereits existierenden colla Konto an",
    Spanish: "Unirse a una cuenta existente de colla",
    Italian: "Aggiungere un account colla esistente",
  },
  {
    FIELD1: "mua.main.subheading",
    English:
      "It takes a pack! Give access to family and friends, so they can help keep your furry friends safe too!",
    French:
      "Access your colla account seamlessly and stay connected to your team, tools, and resources.",
    German:
      "Access your colla account seamlessly and stay connected to your team, tools, and resources.",
    Spanish:
      "Access your colla account seamlessly and stay connected to your team, tools, and resources.",
    Italian:
      "Access your colla account seamlessly and stay connected to your team, tools, and resources.",
  },
  {
    FIELD1: "mua.main.label_account",
    English: "Account Email (Joining Account)",
    French: "E-mail du compte (rejoindre un compte)",
    German: "Konto E-Mail( Konto beitreten)",
    Spanish: "Correo electrónico de la cuenta (Uniéndose a la cuenta)",
    Italian: "Email dell'account (account condiviso)",
  },
  {
    FIELD1: "mua.main.button",
    English: "Join Account",
    French: "Rejoindre un compte",
    German: "Konto beitreten",
    Spanish: "Unirse a la cuenta",
    Italian: "Condividi account",
  },
  {
    FIELD1: "mua.main.signin_label",
    English: "Already accepted your account",
    French: "Déjà accepté votre compte",
    German: "Ihr Konto wurde bereits akzeptiert",
    Spanish: "Ya se ha aceptado su cuenta",
    Italian: "Il tuo account è già stato accettato",
  },
  {
    FIELD1: "mua.main.signin",
    English: "Sign In",
    French: "Se Connecter",
    German: "Anmelden",
    Spanish: "Iniciar Sesión",
    Italian: "Accedi",
  },
  {
    FIELD1: "mua.main.success",
    English:
      "Successfully accepted invitation, please verify your email address",
    French:
      "Invitation acceptée avec succès, veuillez vérifier votre adresse e-mail",
    German:
      "Die Einladung wurde erfolgreich akzeptiert, bitte verifizieren Sie Ihre E-Mail Adresse",
    Spanish:
      "Invitación aceptada con éxito, por favor verifique su dirección de correo electrónico",
    Italian:
      "Invito accettato con successo, si prega di verificare l'indirizzo e-mail",
  },
  {
    FIELD1: "mua.main.error",
    English: "Something went wrong, please contact your account owner",
    French:
      "Un problème s'est produit, veuillez contacter le propriétaire de votre compte",
    German:
      "Etwas ist schiefgelaufen, bitte verifizieren Sie ihre E-mail Adresse",
    Spanish: "Algo salió mal, por favor contacte al propietario de su cuenta",
    Italian:
      "Qualcosa è andato storto, contattare il proprietario dell'account",
  },
  {
    FIELD1: "mua.main.error1",
    English: "Invite already accepted",
    French: "Invitation déjà acceptée",
    German: "Die Einladung wurde bereits akzeptiert",
    Spanish: "Invitación ya aceptada",
    Italian: "Invito già accettato",
  },
  {
    FIELD1: "mua.main.error2",
    English: "No invites found for this email address",
    French: "Aucune invitation n'a été trouvée pour cette adresse e-mail",
    German: "es wurde keine Einladung für diese E-Mail gefunden",
    Spanish:
      "No se encontraron invitaciones para esta dirección de correo electrónico",
    Italian: "Nessun invito trovato per questo indirizzo e-mail",
  },
  {
    FIELD1: "confirm_email.helmet.title",
    English: "colla Account Confirmation",
    French: "Confirmation du compte colla",
    German: "colla Kontobestätigung",
    Spanish: "Confirmación de cuenta colla",
    Italian: "Conferma dell'account colla",
  },
  {
    FIELD1: "confirm_email.main.title",
    English: "Confirm your email",
    French: "Confirmez votre adresse e-mail",
    German: "Bestätigen Sie Ihre E-Mail",
    Spanish: "Confirmar su correo electrónico",
    Italian: "Conferma la tua email",
  },
  {
    FIELD1: "confirm_email.main.desc",
    English:
      "We've sent a 6 digit verification code to your email. If you can't find it, please check that the email is correct, and check your spam/junk folder.",
    French:
      "Nous avons envoyé un code de vérification à 6 chiffres à votre adresse électronique. Si vous ne le trouvez pas, vérifiez que l'email est correct et vérifiez votre dossier spam/junk.",
    German:
      "Wir haben einen 6 stelligen Code an Ihre E-mail Adresse geschickt. Wenn Sie diesen nicht finden können, überleven Sie, ob die Email richtig ist und überprüfen Sie ihren Spam/Junk Ordner.",
    Spanish:
      "Hemos enviado un código de verificación de 6 dígitos a su correo electrónico. Si no lo encuentra, compruebe que el correo electrónico es correcto y revise su carpeta de correo no deseado.",
    Italian:
      "Abbiamo inviato un codice di verifica di 6 cifre al tuo indirizzo e-mail. Se non lo trovi, verifica che l'e-mail sia corretta e controlla la cartella spam/posta indesiderata.",
  },
  {
    FIELD1: "confirm_email.main.placeholder_email",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
  },
  {
    FIELD1: "confirm_email.main.placeholder_code",
    English: "Confirmation Code",
    French: "Code de confirmation",
    German: "Bestätigungscode",
    Spanish: "Código de confirmación",
    Italian: "Codice di conferma",
  },
  {
    FIELD1: "confirm_email.main.not_arrived",
    English: "Not arrived after a few minutes? Please check your spam folder.",
    French:
      "Pas reçu après quelques minutes ? Veuillez vérifier votre dossier spam.",
    German:
      "Nach ein paar Minuten nicht angekommen? Bitte überprüfen Sie Ihren Spam-Ordner.",
    Spanish:
      "¿No ha llegado después de unos minutos? Compruebe su carpeta de correo no deseado.",
    Italian: "Non è arrivato dopo pochi minuti? Controlla la cartella spam.",
  },
  {
    FIELD1: "confirm_email.main.resend",
    English: "Resend",
    French: "Renvoyer",
    German: "Erneut senden",
    Spanish: "Reenviar",
    Italian: "Reinvia",
  },
  {
    FIELD1: "confirm_email.main.button_confirm",
    English: "Confirm Email",
    French: "Confirmer l'e-mail",
    German: "E-Mail bestätigen",
    Spanish: "Confirmar correo electrónico",
    Italian: "Conferma la tua email",
  },
  {
    FIELD1: "confirm_email.main.button_confirming",
    English: "Confirming",
    French: "Confirmation",
    German: "Bestätigung",
    Spanish: "Confirmando",
    Italian: "In attesa di conferma",
  },
  {
    FIELD1: "confirm_email.main.error_invalid_code",
    English: "Invalid verification code provided, please try again.",
    French: "Le code de vérification fourni est invalide, veuillez réessayer.",
    German:
      "Ungültiger Bestätigungscode angegeben, bitte versuchen Sie es erneut.",
    Spanish: "Código de verificación no válido, inténtelo de nuevo.",
    Italian: "Codice di verifica non valido, riprovare.",
  },
  {
    FIELD1: "confirm_email.main.error_invalid_code2",
    English: "This code is invalid, a new one has been sent to your inbox.",
    French:
      "Ce code est incorrect, un nouveau code a été envoyé à votre adresse électronique.",
    German:
      "Dieser Code ist ungültig, ein neuer Code wurde in deinen Posteingang geschickt",
    Spanish:
      "Este código no es válido, se ha enviado uno nuevo a su bandeja de entrada.",
    Italian:
      "Questo codice non è valido, ne è stato inviato uno nuovo alla tua casella di posta.",
  },
  {
    FIELD1: "confirm_email.main.error_not_found",
    English: "Account Not Found",
    French: "Compte introuvable",
    German: "Konto wurde nicht gefunden",
    Spanish: "Cuenta no encontrada",
    Italian: "Account non trovato",
  },
  {
    FIELD1: "confirm_email.main.error_empty_fields",
    English: "Fields can't be empty",
    French: "Les champs ne peuvent pas être vides",
    German: "Die Felder könen nicht leer gelassen werden",
    Spanish: "Los campos no pueden estar vacíos",
    Italian: "Questi campi non possono essere vuoti",
  },
  {
    FIELD1: "confirm_email.main.error_general",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, versuchen Sie es bitte später erneut.",
    Spanish: "Algo ha ido mal, por favor inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto, riprova più tardi.",
  },
  {
    FIELD1: "confirm_email.main.no_code",
    English: "Didn't receive a code?",
    French: "Vous n'avez pas reçu de code ?",
    German: "Sie haben keinen Code erhalten?",
    Spanish: "¿No ha recibido el código?",
    Italian: "Non hai ricevuto il codice?",
  },
  {
    FIELD1: "confirm_email.main.resend",
    English: "Resend",
    French: "Renvoyer",
    German: "Erneut senden",
    Spanish: "Reenviar",
    Italian: "Reinvia",
  },
  {
    FIELD1: "confirm_email.main.contact",
    English: "Contact Us",
    French: "Contactez-nous",
    German: "Kontaktieren Sie uns",
    Spanish: "Contáctenos",
    Italian: "Contattaci",
  },
  {
    FIELD1: "confirm_email.validation.email_required",
    English: "Please enter an email address",
    French: "Veuillez saisir une adresse électronique",
    German: "Bitte geben Sie eine E-Mail-Adresse ein",
    Spanish: "Por favor, introduzca una dirección de correo electrónico",
    Italian: "Inserisci un indirizzo email",
  },
  {
    FIELD1: "confirm_email.validation.email_invalid",
    English: "Please check you have entered your email address correctly",
    French:
      "Veuillez vérifier que vous avez saisi correctement votre adresse électronique",
    German:
      "Bitte überprüfen Sie, ob Sie Ihre E-Mail-Adresse korrekt eingegeben haben.",
    Spanish:
      "Por favor, verifique que ha introducido correctamente su dirección de correo electrónico",
    Italian: "Verifica di aver inserito correttamente il tuo indirizzo email",
  },
  {
    FIELD1: "confirm_email.validation.code_required",
    English: "Please enter your verification code",
    French: "Veuillez saisir votre code de vérification",
    German: "Bitte geben Sie Ihren Verifizierungscode ein",
    Spanish: "Por favor, introduzca su código de verificación",
    Italian: "Sei pregato di inserire il tuo codice di verifica",
  },
  {
    FIELD1: "confirm_email.validation.code_invalid",
    English: "Your verification code should be 6 digits long",
    French: "Le code de vérification doit être composé de 6 chiffres",
    German: "Der Verifizierungscode sollte 6 Ziffern lang sein",
    Spanish: "El código de verificación debe tener 6 dígitos",
    Italian: "Il codice di verifica deve essere di 6 cifre",
  },
  {
    FIELD1: "confirm_email.success.line1",
    English: "You've successfully verified your account!",
    French: "Vous avez vérifié votre compte avec succès !",
    German: "Sie haben Ihr Konto erfolgreich verifiziert!",
    Spanish: "¡Usted ha verificado con éxito su cuenta!",
    Italian: "Hai verificato con successo il tuo account!",
  },
  {
    FIELD1: "confirm_email.success.line2",
    English:
      "To continue with the activation process of your colla tracker, please click the button below and log in to the activation portal.",
    French:
      "Pour continuer le processus d'activation de votre colla tracker, veuillez cliquer sur le bouton ci-dessous et vous connecter au portail d'activation.",
    German:
      "Um den Aktivierungsprozess Ihres colla Trackers fortzusetzen, klicken Sie bitte auf die Schaltfläche unten und melden Sie sich beim Aktivierungsportal an.",
    Spanish:
      "Para continuar con el proceso de activación de su colla tracker, haga clic en el botón de abajo e inicie sesión en el portal de activación.",
    Italian:
      "Per continuare con il processo di attivazione del tuo colla tracker, fai clic sul pulsante qui sotto e accedi al portale di attivazione.",
  },
  {
    FIELD1: "confirm_email.success.btn",
    English: "Log in to Activation Portal",
    French: "Se connecter au portail d'activation",
    German: "Melden Sie sich beim Aktivierungsportal an",
    Spanish: "Iniciar sesión en el portal de activación",
    Italian: "Accedi al portale di attivazione",
  },
  {
    FIELD1: "confirm_email.success_wv.btn",
    English: "Log into the App",
    French: "Connectez-vous à l'application",
    German: "Melden Sie sich in der App an",
    Spanish: "Inicie sesión en la aplicación",
    Italian: "Accedi all'app",
  },
  {
    FIELD1: "confirm_email.resend.confirmed",
    English: "Your account is already confirmed, redirecting to login...",
    French: "Votre compte est déjà confirmé, redirection vers la connexion...",
    German:
      "Ihr Konto ist bereits bestätigt, Sie werden zum Login weitergeleitet...",
    Spanish: "Su cuenta ya está confirmada, redirigiendo a inicio de sesión...",
    Italian: "Il tuo account è già confermato, reindirizza al login...",
  },
  {
    FIELD1: "forget_password.helmet.title",
    English: "colla Password Reset",
    French: "Réinitialisation du mot de passe colla",
    German: "colla Passwort zurücksetzen",
    Spanish: "Restablecer contraseña colla",
    Italian: "Ripristino della password colla",
  },
  {
    FIELD1: "forget_password.helmet.desc",
    English: "Reset your colla password.",
    French: "Réinitialiser votre mot de passe colla.",
    German: "setzten Sie ihr colla Passswort zurück.",
    Spanish: "Restablezca su contraseña colla.",
    Italian: "Ripristina la tua password colla",
  },
  {
    FIELD1: "forget_password.main.title",
    English: "Forgot password?",
    French: "Réinitialiser votre mot de passe",
    German: "Setzen Sie Ihr Passwort zurück",
    Spanish: "Restablecer su contraseña",
    Italian: "Reimposta la password",
  },
  {
    FIELD1: "forget_password.main.title_confirm",
    English: "Set new password",
    French: "Entrez votre code de vérification",
    German: "Geben Sie Ihren Verifizierungscode ein",
    Spanish: "Ingrese su código de verificación",
    Italian: "Inserisci il tuo codice di verifica",
  },
  {
    FIELD1: "forget_password.main.title_success",
    English: "Password Reset",
    French: "Entrez votre code de vérification",
    German: "Geben Sie Ihren Verifizierungscode ein",
    Spanish: "Ingrese su código de verificación",
    Italian: "Inserisci il tuo codice di verifica",
  },
  {
    FIELD1: "forget_password.main.subheading",
    English: "No worries, we’ll send you a reset code to change your password.",
    French:
      "Saisissez l'adresse électronique associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    German:
      "Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein und wir senden Ihnen einen Link, um Ihr Passwort zurückzusetzen.",
    Spanish:
      "Ingrese la dirección de correo electrónico asociada a su cuenta y le enviaremos un enlace para restablecer su contraseña",
    Italian:
      "Inserisci l'indirizzo e-mail associato al tuo account e ti invieremo un link per reimpostare la password.",
  },
  {
    FIELD1: "forget_password.main.subheading_confirm",
    English:
      "Your new password must be different to previously used passwords.",
    French:
      "Nous vous avons envoyé un e-mail contenant le code de réinitialisation de votre mot de passe.",
    German:
      "Wir haben Ihnen eine E-Mail mit dem Code zum Zurücksetzen Ihres Passworts geschickt.",
    Spanish:
      "Hemos enviado un correo electrónico con el código para restablecer su contraseña",
    Italian:
      "Ti abbiamo inviato un'e-mail con il codice per reimpostare la tua password.",
  },
  {
    FIELD1: "forget_password.main.subheading_success",
    English:
      "Your password has been successfully reset. Click below to go to log in.",
    French:
      "Nous vous avons envoyé un e-mail contenant le code de réinitialisation de votre mot de passe.",
    German:
      "Wir haben Ihnen eine E-Mail mit dem Code zum Zurücksetzen Ihres Passworts geschickt.",
    Spanish:
      "Hemos enviado un correo electrónico con el código para restablecer su contraseña",
    Italian:
      "Ti abbiamo inviato un'e-mail con il codice per reimpostare la tua password.",
  },
  {
    FIELD1: "forget_password.main.verification_code",
    English: "Verification code",
    French: "Code de vérification",
    German: "Überprüfungscode",
    Spanish: "Código de verificación",
    Italian: "Codice di verifica",
  },
  {
    FIELD1: "forget_password.main.button_send_code",
    English: "Send verification code",
    French: "Envoyer le code de vérification",
    German: "Verifizierungscode senden",
    Spanish: "Enviar código de verificación",
    Italian: "Invia il codice di verifica",
  },
  {
    FIELD1: "forget_password.main.button_reset_password",
    English: "Reset Password",
    French: "Envoyer le code de vérification",
    German: "Verifizierungscode senden",
    Spanish: "Enviar código de verificación",
    Italian: "Invia il codice di verifica",
  },
  {
    FIELD1: "forget_password.main.button_continue",
    English: "Continue",
    French: "Envoyer le code de vérification",
    German: "Verifizierungscode senden",
    Spanish: "Enviar código de verificación",
    Italian: "Invia il codice di verifica",
  },
  {
    FIELD1: "forget_password.main.placeholder_email",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
  },
  {
    FIELD1: "forget_password.main.placeholder_code",
    English: "Confirmation Code",
    French: "Code de confirmation",
    German: "Bestätigungscode",
    Spanish: "Código de confirmación",
    Italian: "Codice di conferma",
  },
  {
    FIELD1: "forget_password.main.placeholder_new_pass",
    English: "New Password",
    French: "Nouveau mot de passe",
    German: "Neues Passwort",
    Spanish: "Nueva Contraseña",
    Italian: "Nuova password",
  },
  {
    FIELD1: "forget_password.main.placeholder_confirm",
    English: "Confirm Password",
    French: "Confirmer le mot de passe",
    German: "Passwort bestätigen ",
    Spanish: "Confirmar contraseña",
    Italian: "Conferma la password",
  },
  {
    FIELD1: "forget_password.main.label_password",
    English:
      "8 characters or longer. Combine upper and lowercase letters and numbers.",
    French:
      "8 caractères ou plus. Combinez les lettres majuscules et minuscules et les chiffres.",
    German:
      "8 Zeichen oder länger. Kombinieren Sie Groß- und Kleinbuchstaben und Zahlen.",
    Spanish: "8 caracteres o más. Combine mayúsculas, minúsculas y números.",
    Italian:
      "8 caratteri o più. Combina lettere maiuscole, minuscole e numeri.",
  },
  {
    FIELD1: "forget_password.main.button_sending_code",
    English: "Sending Code",
    French: "Envoi du code",
    German: "Code schicken",
    Spanish: "Enviar Código",
    Italian: "Inviando il codice",
  },
  {
    FIELD1: "forget_password.main.button_update_password",
    English: "Update Password",
    French: "Mettre à jour le mot de passe",
    German: "Passwort aktualisieren",
    Spanish: "Actualizar contraseña",
    Italian: "Aggiorna la tua password",
  },
  {
    FIELD1: "forget_password.main.button_signup",
    English: "Sign Up",
    French: "S'inscrire",
    German: "Anmelden",
    Spanish: "Registrarse",
    Italian: "Iscriviti",
  },
  {
    FIELD1: "forget_password.main.button_updating_password",
    English: "Updating Password",
    French: "Mise à jour du mot de passe",
    German: "Passwort aktualisieren",
    Spanish: "Actualizar contraseña",
    Italian: "Aggiornamento della password",
  },
  {
    FIELD1: "forget_password.main.error_general",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, versuchen Sie es bitte später erneut.",
    Spanish: "Algo salió mal, por favor inténtelo más tarde.",
    Italian: "Qualcosa è andato storto, riprova più tardi.",
  },
  {
    FIELD1: "forget_password.main.error_send_code_failed",
    English:
      "Couldn't send your reset code, please try again later, then contact support.",
    French:
      "Impossible d'envoyer votre code de réinitialisation, veuillez réessayer plus tard, puis contactez l'assistance.",
    German:
      "Der Reset-Code konnte nicht gesendet werden. Bitte versuchen Sie es später erneut und wenden Sie sich dann an den Support.",
    Spanish:
      "No se ha podido enviar el código de recuperación. Inténtelo más tarde y póngase en contacto con el servicio de soporte.",
    Italian:
      "Non è stato possibile inviare il codice di ripristino, riprova più tardi. Se il problema persiste, contatta l'assistenza.",
  },
  {
    FIELD1: "forget_password.main.error_email_invalid",
    English: "Please enter a valid email address.",
    French: "Veuillez saisir une adresse e-mail valide.",
    German: "Bitte geben Sie eine gültige E-Mail Adresse ein.",
    Spanish: "Introduzca una dirección de correo electrónico válida.",
    Italian: "Sei pregato di inserire un indirizzo e-mail valido.",
  },
  {
    FIELD1: "forget_password.main.error_request_limit",
    English: "Too many verification codes requested, please try again later.",
    French:
      "Un trop grand nombre de codes de vérification a été demandé, veuillez réessayer plus tard.",
    German:
      "Zu viele  Bestätigungscodes Anfragen, bitte versuchen Sie es später nochmal.",
    Spanish:
      "Se han solicitado demasiados códigos de verificación, inténtelo más tarde.",
    Italian:
      "Sono stati richiesti troppi codici di verifica, riprova più tardi.",
  },
  {
    FIELD1: "forget_password.main.error_invalid_code",
    English:
      "Invalid code provided, please press send confirmation code to request a code again.",
    French:
      "Le code fourni n'est pas valide, veuillez appuyer sur le bouton envoyer le code de confirmation pour demander un nouveau code.",
    German:
      "Ungültiger Code angegeben, drücken Sie bitte auf Bestätigungscode senden, um erneut einen Code anzufordern.",
    Spanish:
      "Código no válido proporcionado, por favor presione enviar código de confirmación para solicitar un código de nuevo.",
    Italian:
      "Codice non valido, seleziona Invia codice di conferma per richiedere nuovamente un codice.",
  },
  {
    FIELD1: "forget_password.main.error_confirm",
    English:
      "You need to confirm your email to reset the password, please wait while you are redirected to the email confirmation page.",
    French:
      "Vous devez confirmer votre email pour réinitialiser le mot de passe, veuillez patienter pendant que vous êtes redirigé vers la page de confirmation de l'email.",
    German:
      "Sie müssen Ihre E-Mail bestätigen, um das Passwort zurückzusetzen. Bitte warten Sie, während Sie zur E-Mail-Bestätigungsseite weitergeleitet werden.",
    Spanish:
      "Debe confirmar su correo electrónico para restablecer la contraseña, espere mientras se le redirige a la página de confirmación de correo electrónico.",
    Italian:
      "Per reimpostare la password è necessario confermare l'e-mail; aspetta di essere reindirizzato alla pagina di conferma dell'e-mail.",
  },
  {
    FIELD1: "forget_password.main.error_code_resent",
    English:
      "Sorry, we had a problem sending the code to your email. Please send us a message and we'll get you up and running!",
    French:
      "Désolé, nous avons rencontré un problème lors de l'envoi du code à votre adresse e-mail. Veuillez nous envoyer un message et nous vous aiderons à démarrer !",
    German:
      "Es tut uns leid, aber es gab ein Problem beim Senden des Codes an Ihre E-Mail-Adresse. Bitte senden Sie uns eine Nachricht und wir helfen Ihnen beim Start !",
    Spanish:
      "Lo sentimos, tuvimos un problema al enviar el código a tu correo electrónico. Por favor, envíanos un mensaje y te ayudaremos a comenzar.",
    Italian:
      "Ci dispiace, abbiamo avuto un problema nell'invio del codice al tuo indirizzo email. Per favore, inviaci un messaggio e ti aiuteremo a iniziare!",
  },
  {
    FIELD1: "forget_password.main.error_no_account",
    English:
      "We couldn't find this account. Please check you entered your email address correctly.",
    French:
      "Nous n'avons pas pu trouver ce compte. Veuillez vérifier que vous avez saisi votre email correctement.",
    German:
      "Wir konnten dieses Konto nicht finden. Bitte überprüfen Sie, ob Sie Ihre E-Mail-Adresse korrekt eingegeben haben.",
    Spanish:
      "No hemos podido encontrar esta cuenta. Compruebe que ha introducido correctamente su dirección de correo electrónico.",
    Italian:
      "Non siamo riusciti a trovare questo account. Verifica di aver inserito correttamente il tuo indirizzo e-mail.",
  },
  {
    FIELD1: "forget_password.main.error_password_short",
    English: "Passwords should be at least 8 characters long.",
    French: "Les mots de passe doivent comporter au moins 8 caractères.",
    German: "Passwörter sollten mindestens 8 Zeichen lang sein.",
    Spanish: "Las contraseñas deben tener al menos 8 caracteres.",
    Italian: "Le password devono essere lunghe almeno 8 caratteri.",
  },
  {
    FIELD1: "forget_password.main.error_password_invalid",
    English:
      "Passwords should contain at least one uppercase letter, one lower case letter and one number.",
    French:
      "Les mots de passe doivent contenir au moins une lettre majuscule, une lettre minuscule et un chiffre.",
    German:
      "Passwörter sollten mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten.",
    Spanish:
      "Las contraseñas deben contener al menos una letra mayúscula, una letra minúscula y un número.",
    Italian:
      "Le password devono contenere almeno una lettera maiuscola, una lettera minuscola e un numero.",
  },
  {
    FIELD1: "forget_password.main.error_password_not_matched",
    English: "Passwords do not match.",
    French: "Les mots de passe ne correspondent pas.",
    German: "Die Passwörter stimmen nicht überein.",
    Spanish: "Las contraseñas no coinciden.",
    Italian: "Le password non coincidono.",
  },
  {
    FIELD1: "forget_password.main.password_updated",
    English: "Password updated successfully, redirecting to login...",
    French: "Mot de passe mis à jour avec succès, redirection vers le login...",
    German:
      "Das Passwort wurde erfolgreich hochgeladen, umleiten zur Anmeldung...",
    Spanish:
      "Contraseña actualizada con éxito, redirigiendo al inicio de sesión...",
    Italian: "Password aggiornata con successo, reindirizzamento al login...",
  },
  {
    FIELD1: "forget_password.main.login",
    English: "Back to Login",
    French: "Retour à la connexion",
    German: "Zurück zur Anmeldung",
    Spanish: "Volver al inicio de sesión",
    Italian: "Torna al login",
  },
  {
    FIELD1: "success.helmet.title",
    English: "Activation Successful!",
    French: "Activation réussie!",
    German: "Aktivierung war erfolgreich!",
    Spanish: "¡Activación exitosa!",
    Italian: "Attivazione riuscita!",
  },
  {
    FIELD1: "success.main.title",
    English: "Your colla has been <span>successfully</span> activated.",
    French: "Votre colla a été activé avec succès.",
    German: "Ihre Collab wurde erfolgreich aktiviert.",
    Spanish: "Su collab se ha activado con éxito.",
    Italian: "Il tuo collab è stato attivato con successo.",
  },
  {
    FIELD1: "success.main.subheading",
    English: "You're all set! Let's get you started with your new pet monitor!",
    French: "Vous êtes prêt! Commençons avec votre nouveau moniteur d'animaux!",
    German:
      "Sie sind bereit! Lassen Sie uns mit Ihrem neuen Haustier-Monitor beginnen!",
    Spanish: "¡Estás listo! ¡Comencemos con tu nuevo monitor de mascotas!",
    Italian:
      "Sei pronto! Iniziamo con il tuo nuovo monitor per animali domestici!",
  },
  {
    FIELD1: "success.main.step",
    English: "Step",
    French: "Étape",
    German: "Schritt",
    Spanish: "Paso",
    Italian: "Passo",
  },
  {
    FIELD1: "success.main.step1_line1",
    English: "Attach your tracker securely to your pet's collar",
    French: "Attachez solidement votre traceur au collier de votre animal.",
    German: "Befestigen Sie Ihren Tracker sicher am Halsband Ihres Haustieres.",
    Spanish: "Asegure su rastreador firmemente al collar de su mascota.",
    Italian:
      "Fissare il tracker in modo sicuro al collare del tuo animale domestico.",
  },
  {
    FIELD1: "success.main.step1_line2",
    English:
      "Once charged and switched on, please allow 15-20 minutes for your tracker to come online.",
    French:
      "Une fois chargé et mis sous tension, veuillez patienter 15 à 20 minutes pour que votre tracker se connecte.",
    German:
      "Sobald der Tracker aufgeladen und eingeschaltet ist, warten Sie bitte 15-20 Minuten, bis er online geht.",
    Spanish:
      "Una vez cargado y encendido, espere de 15 a 20 minutos para que su localizador se conecte.",
    Italian:
      "Una volta caricato e acceso, attendere 15-20 minuti per consentire al tracker di connettersi.",
  },
  {
    FIELD1: "success.main.step1_btn",
    English: "View Manual",
    French: "Voir Manuel",
    German: "Handbuch ansehen",
    Spanish: "Ver Manual",
    Italian: "Visualizza Manuale",
  },
  {
    FIELD1: "success.main.step2_line1",
    English: "Install our app",
    French: "Installez notre application",
    German: "Installieren Sie unsere App",
    Spanish: "Instale nuestra aplicación",
    Italian: "Installa la nostra app",
  },
  {
    FIELD1: "success.main.step2_line2",
    English:
      "Install the app and <b> log in with the same login details you registered online </b> to monitor your furry friend! Scan the QR code to download.",
    French:
      "Installez l'application et connectez-vous avec les mêmes identifiants que vous avez enregistrés en ligne pour surveiller votre ami à fourrure ! Analysez le code QR pour télécharger.",
    German:
      "Installieren Sie die App und melden Sie sich mit denselben Login-Daten an, mit denen Sie sich online registriert haben, um Ihren pelzigen Freund zu überwachen! Scannen Sie den QR-Code, um ihn herunterzuladen.",
    Spanish:
      "¡Instala la aplicación e inicia sesión con los mismos datos de inicio de sesión con los que te registraste en línea para monitorear a tu amigo peludo! Escanea el código QR para descargar.",
    Italian:
      "Installa l'app e accedi con gli stessi dati di accesso con cui ti sei registrato online per monitorare il tuo amico peloso! Scansiona il codice QR per scaricare.",
  },
  {
    FIELD1: "success.main.wait_message",
    English:
      "Please allow 15-20 minutes for your tracker to come online after it's been charged/installed.",
    French:
      "Comptez 15 à 20 minutes pour que votre traceur se mette en ligne une fois qu'il a été chargé/installé.",
    German:
      "Bitte geben Sie Ihrem Tracker 15-20 Minuten Zeit, um online zu gehen, nachdem er aufgeladen/ installiert wurde.",
    Spanish:
      "Por favor, espere 15-20 minutos para que su rastreador se conecte después de haber sido cargado/instalado.",
    Italian:
      "Si prega di attendere 15-20 minuti affinché il tracker sia online dopo essere stato caricato/installato.",
  },
  {
    FIELD1: "success.wv.title",
    English: "Go back to the app",
    French: "Retournez à l'application",
    German: "Kehren Sie zur App zurück",
    Spanish: "Vuelve a la aplicación",
    Italian: "Torna all'app",
  },
  {
    FIELD1: "success.wv.desc",
    English:
      "If you've finished activating your trackers, you can go back to the app (you may then be prompted to login), or you can add another tracker if you have one",
    French:
      "Si vous avez terminé d'activer vos traqueurs, vous pouvez retourner à l'application (vous pourrez alors être invité à vous connecter), ou vous pouvez ajouter un autre traqueur si vous en avez un.",
    German:
      "Wenn Sie die Aktivierung Ihrer Tracker abgeschlossen haben, können Sie zur App zurückkehren (möglicherweise werden Sie dann aufgefordert, sich anzumelden), oder Sie können einen weiteren Tracker hinzufügen, falls Sie einen haben.",
    Spanish:
      "Si has terminado de activar tus rastreadores, puedes volver a la aplicación (es posible que se te pida iniciar sesión), o puedes añadir otro rastreador si tienes uno.",
    Italian:
      "Se hai finito di attivare i tuoi tracker, puoi tornare all'app (potrebbe quindi esserti richiesto di effettuare il login), oppure puoi aggiungere un altro tracker se ne hai uno.",
  },
  {
    FIELD1: "success.wv.btn1",
    English: "Go back to the app",
    French: "Retournez à l'application",
    German: "Kehren Sie zur App zurück",
    Spanish: "Vuelve a la aplicación",
    Italian: "Torna all'app",
  },
  {
    FIELD1: "success.wv.btn2",
    English: "Activate another",
    French: "Activez un autre",
    German: "Aktivieren Sie einen anderen",
    Spanish: "Active otro",
    Italian: "Attiva un altro",
  },
  {
    FIELD1: "success.main.read",
    English: "Please take a look at the product manual for more information.",
    French: "Veuillez consulter le manuel du produit pour plus d'informations.",
    German:
      "Bitte sehen Sie sich die Bedienungsanleitung für weitere Informationen an.",
    Spanish: "Consulte el manual del producto para obtener más información.",
    Italian: "Per ulteriori informazioni, consultare il manuale del prodotto.",
  },
  {
    FIELD1: "success.main.payment_tip",
    English:
      "Please note, payments from colla may appear as 'DownRiver' on your bank statement.",
    French:
      'Veuillez noter que les paiement de colla pourraient apparaitre sous le nom de "DownRiver" sur votre relevé de banque.',
    German:
      "Bitte beachten Sie, dass Zahlungen von colla auf Ihrem Kontoauszug als 'DownRiver' erscheinen können.",
    Spanish:
      'Los pagos de colla pueden aparecer como "DownRiver" en su resumen bancario.',
    Italian:
      'Ricorda che i pagamenti effettuati da colla possono apparire come "DownRiver" sull\'estratto conto bancario.',
  },
  {
    FIELD1: "error404.main.title",
    English: "Hmmm, this page doesn't exist..",
    French: "Hmmm, this page doesn't exist.",
    German: "Hmmm, this page doesn't exist.",
    Spanish: "Hmmm, this page doesn't exist.",
    Italian: "Hmmm, this page doesn't exist.",
  },
  {
    FIELD1: "error404.main.desc1",
    English:
      "Looks like this page took a wrong turn. Don’t worry, we’ll help you get back on track!",
    French:
      "Il semble que cette page ait pris un mauvais tournant. Ne vous inquiétez pas, nous vous aiderons à retrouver votre chemin !",
    German:
      "Es sieht so aus, als hätte diese Seite einen falschen Weg eingeschlagen. Keine Sorge, wir helfen Ihnen, wieder auf den richtigen Kurs zu kommen!",
    Spanish:
      "Parece que esta página tomó un mal camino. No te preocupes, ¡te ayudaremos a volver al buen camino!",
    Italian:
      "Sembra che questa pagina abbia preso una direzione sbagliata. Non preoccuparti, ti aiuteremo a tornare sulla giusta strada!",
  },
  {
    FIELD1: "error404.main.desc2",
    English:
      "Or, use the nav bar at the top of the screen to find the page you need.",
    French:
      "Ou utilisez la barre de navigation en haut de l'écran pour trouver la page dont vous avez besoin.",
    German:
      "Oder verwenden Sie die Navigationsleiste oben auf dem Bildschirm, um die benötigte Seite zu finden.",
    Spanish:
      "O, use la barra de navegación en la parte superior de la pantalla para encontrar la página que necesita.",
    Italian:
      "Oppure, usa la barra di navigazione in alto sullo schermo per trovare la pagina di cui hai bisogno.",
  },
  {
    FIELD1: "error404.main.desc2_sm",
    English: "Use the menu to find what you need.",
    French: "Utilisez le menu pour trouver ce dont vous avez besoin.",
    German: "Verwenden Sie das Menü, um zu finden, was Sie brauchen.",
    Spanish: "Utiliza el menú para encontrar lo que necesitas.",
    Italian: "Usa il menu per trovare ciò di cui hai bisogno.",
  },
  {
    FIELD1: "error404.main.button",
    English: "Go back to Home",
    French: "Retourner à la page d'accueil",
    German: "Zurück zur Startseite",
    Spanish: "Volver a la página de inicio",
    Italian: "Torna alla home page",
  },
  {
    FIELD1: "error_boundary.main.image",
    English: "We've hit an Error",
    French: "Nous avons rencontré une erreur",
    German: "Wir sind auf einen Fehler gestoßen",
    Spanish: "Se ha producido un error",
    Italian: "Abbiamo riscontrato un errore",
  },
  {
    FIELD1: "error_boundary.main.title",
    English: "Sorry! Looks like we hit an error",
    French: "Désolé ! Il semble que nous ayons rencontré une erreur",
    German: "Entschuldigung! Anscheinend sind wir auf einen Fehler gestoßen",
    Spanish: "¡Lo siento! Parece que hemos encontrado un error",
    Italian: "Scusa! Sembra che abbiamo riscontrato un errore",
  },
  {
    FIELD1: "error_boundary.main.desc",
    English:
      "Please click the button below to reload the site, and if you could use the help widget to let us know what happened, we’d really appreciate it!",
    French:
      "Veuillez cliquer sur le bouton ci-dessous pour recharger le site, et si vous pouviez utiliser le widget d'aide pour nous informer de ce qui s'est passé, nous vous en serions très reconnaissants !",
    German:
      "Bitte klicken Sie auf die Schaltfläche unten, um die Website neu zu laden, und wenn Sie das Hilfe-Widget verwenden könnten, um uns mitzuteilen, was passiert ist, wären wir Ihnen sehr dankbar!",
    Spanish:
      "Por favor, haga clic en el botón de abajo para recargar el sitio, y si pudiera utilizar el widget de ayuda para hacernos saber lo que sucedió, ¡se lo agradeceríamos mucho!",
    Italian:
      "Si prega di fare clic sul pulsante qui sotto per ricaricare il sito, e se potesse utilizzare la widget di aiuto per farci sapere cosa è successo, lo apprezzeremmo molto!",
  },
  {
    FIELD1: "error_boundary.main.desc1",
    English:
      "Sorry, we encountered an error with the site. Please hit reload below to get back up and running again.",
    French:
      "Désolé, nous avons rencontré une erreur avec le site. Veuillez cliquer sur recharger ci-dessous pour le remettre en service.",
    German:
      'Leider ist ein Fehler auf der Website aufgetreten. Bitte klicken Sie unten auf "Neu laden", um die Seite wieder zum Laufen zu bringen.',
    Spanish:
      'Lo sentimos, se ha producido un error en el sitio. Por favor, presione "recargar" a continuación para volver a funcionar.',
    Italian:
      "Siamo spiacenti, si è verificato un errore nel sito. Sei pregato di eseguire il reload qui sotto.",
  },
  {
    FIELD1: "error_boundary.main.desc2",
    English: "If that doesn’t work, please let us know using the help widget!",
    French:
      "Si cela ne fonctionne pas, veuillez nous en informer en utilisant le widget d'aide !",
    German:
      "Wenn das nicht funktioniert, lassen Sie es uns bitte über das Hilfe-Widget wissen!",
    Spanish:
      "Si no funciona, por favor, infórmenos utilizando el widget de ayuda.",
    Italian:
      "Se continua a non funzionare, faccelo sapere contattando l'assistenza clienti!",
  },
  {
    FIELD1: "error_boundary.main.button",
    English: "Reload the site",
    French: "Recharger le site",
    German: "Lade die Seite neu",
    Spanish: "Recargar el sitio",
    Italian: "Ricaricare il sito",
  },
  {
    FIELD1: "error_boundary.main.report",
    English: "Report an issue",
    French: "Signaler un problème",
    German: "Ein Problem melden",
    Spanish: "Informar sobre un problema",
    Italian: "Segnala un problema",
  },
  {
    FIELD1: "track.helmet.title",
    English: "colla Live Tracking",
    French: "Localisation en temps réel",
    German: "colla Live Tracking",
    Spanish: "colla Seguimiento en vivo",
    Italian: "Tracciamento in tempo reale colla",
  },
  {
    FIELD1: "track.sidebar.title",
    English: "My Trackers",
    French: "Mes traceurs",
    German: "Meine Trackers",
    Spanish: "Mis rastreadores",
    Italian: "I Miei Dispositivi",
  },
  {
    FIELD1: "track.sidebar.search",
    English: "Search by name or IMEI",
    French: "Recherche par nom ou IMEI",
    German: "Nach Namen oder IMEI suchen",
    Spanish: "Búsqueda por nombre o IMEI",
    Italian: "Ricerca per nome o imei",
  },
  {
    FIELD1: "track.sidebar.tooltip_map",
    English: "Export to Google Maps",
    French: "Exporter vers Google Maps",
    German: "Zu Google Maps exportieren",
    Spanish: "Exportar a Google Maps",
    Italian: "Esporta su Google Maps",
  },
  {
    FIELD1: "track.sidebar.tooltip_alerts",
    English: "See Alerts",
    French: "Voir les alertes",
    German: "Siehe Alerts",
    Spanish: "Ver Alertas",
    Italian: "Visualizza le notifiche",
  },
  {
    FIELD1: "track.sidebar.tooltip_history",
    English: "See History",
    French: "Voir l'historique",
    German: "Siehe Geschichte",
    Spanish: "Ver Historial",
    Italian: "Visualizza la cronologia",
  },
  {
    FIELD1: "track.sidebar.tooltip_settings",
    English: "Edit Settings",
    French: "Modifier les paramètres",
    German: "Einstellungen bearbeiten",
    Spanish: "Editar ajustes",
    Italian: "Modifica le impostazioni",
  },
  {
    FIELD1: "track.settings.tamper",
    English: "Tamper",
    French: "Trafiquer",
    German: "Sabotage",
    Spanish: "Manipulación",
    Italian: "Manomissione",
  },
  {
    FIELD1: "track.settings.turning",
    English: "Sharp Turning",
    French: "Virage brusque",
    German: "Scharfes Wenden",
    Spanish: "Giro Brusco",
    Italian: "Curva stretta",
  },
  {
    FIELD1: "track.settings.collision",
    English: "Collision",
    French: "Collision",
    German: "Kollision",
    Spanish: "Colisión",
    Italian: "Collisione",
  },
  {
    FIELD1: "track.settings.sos",
    English: "SOS",
    Spanish: "SOS",
    Italian: "SOS",
  },
  {
    FIELD1: "track.settings.speed",
    English: "Speed",
    French: "Vitesse",
    German: "Geschwindigkeit",
    Spanish: "Velocidad",
    Italian: "Velocità",
  },
  {
    FIELD1: "track.settings.movement",
    English: "Movement",
    French: "Déplacement",
    German: "Bewegen",
    Spanish: "En movimiento",
    Italian: "Movement",
  },
  {
    FIELD1: "track.settings.activated",
    English: "Account",
    French: "Compte",
    German: "Konto",
    Spanish: "Cuenta",
    Italian: "Account",
  },
  {
    FIELD1: "track.settings.geofence",
    English: "Geofences",
    French: "Géofences",
    German: "Geofences",
    Spanish: "Geocercas",
    Italian: "Geofence",
  },
  {
    FIELD1: "track.settings.geofence_link",
    English: "Go to Geofences Settings",
    French: "Aller aux paramètres des géofences",
    German: "Gehen Sie zu Geofences Einstellungen",
    Spanish: "Ir a Configuración de Geocercas",
    Italian: "Vai a Impostazioni di geofence",
  },
  {
    FIELD1: "track.settings.geofence_link2",
    English: "Create your first geofences",
    French: "Créez vos premières géofences",
    German: "Erstellen Sie Ihre ersten Geofences",
    Spanish: "Cree su primera geocerca",
    Italian: "Crea le tue prime geofence",
  },
  {
    FIELD1: "track.settings.battery",
    English: "Battery",
    French: "Batterie",
    German: "Batterie",
    Spanish: "Batería",
    Italian: "Batteria",
  },
  {
    FIELD1: "track.settings.acc",
    English: "Ignition",
    French: "Démarrage",
    German: "Zündung",
    Spanish: "Encendido",
    Italian: "Accensione",
  },
  {
    FIELD1: "track.settings.submitError",
    English:
      "Settings could not be saved, please try again later or contact support.",
    French:
      "Les paramètres n'ont pas pu être enregistrés, veuillez réessayer plus tard ou contacter l’assistance.",
    German:
      "Die Einstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Support.",
    Spanish:
      "No se ha podido guardar la configuración, inténtelo más tarde o póngase en contacto con el servicio de asistencia.",
    Italian:
      "Non è stato possibile salvare le impostazioni, riprovare più tardi o contattare l'assistenza.",
  },
  {
    FIELD1: "track.settings.name",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
  },
  {
    FIELD1: "track.settings.nameError",
    English: "Tracker names must be between 2 to 16 characters long.",
    French: "Tracker names must be between 2 to 16 characters long.",
    German: "Les noms des traceurs doivent comporter entre 2 et 16 caractères.",
    Spanish:
      "Los nombres de los rastreadores deben tener entre 2 y 16 caracteres.",
    Italian:
      "I nomi dei dispositivi devono avere una lunghezza compresa tra 2 e 16 caratteri.",
  },
  {
    FIELD1: "track.settings.remove",
    English: "Remove",
    French: "Retirer",
    German: "Entfernen",
    Spanish: "Eliminar",
    Italian: "Rimuovi",
  },
  {
    FIELD1: "track.settings.set",
    English: "Set",
    French: "Set",
    German: "Définir",
    Spanish: "Configurar",
    Italian: "Imposta",
  },
  {
    FIELD1: "track.settings.geofenceLabel",
    English: "Enter geofence size",
    French: "Saisir la taille du Géorepérage",
    German: "Geofence Größe eingeben",
    Spanish: "Introduzca el tamaño de la geocerca",
    Italian: "Inserisci le dimensioni del geofence",
  },
  {
    FIELD1: "track.settings.miles",
    English: "Miles",
    French: "Miles",
    German: "Meilen",
    Spanish: "Millas",
    Italian: "Miglia",
  },
  {
    FIELD1: "track.settings.kilometers",
    English: "Kilometers",
    French: "Kilomètres",
    German: "Kilometer",
    Spanish: "Kilómetros",
    Italian: "Chilometri",
  },
  {
    FIELD1: "track.settings.geofenceError",
    English: "Please set a valid Geofence Size.",
    French: "Veuillez définir une taille de Géorepérage valide.",
    German: "Bitte geben Sie eine gültige Geofence Größe ein.",
    Spanish: "Introduzca un tamaño de geocerca válido.",
    Italian: "Impostare una dimensione di geofence valida.",
  },
  {
    FIELD1: "track.settings.speedLimitTitle",
    English: "Speed Limit",
    French: "Limite de vitesse",
    German: "Geschwindigkeitslimit",
    Spanish: "Límite de velocidad",
    Italian: "Limite di velocità",
  },
  {
    FIELD1: "track.settings.geofence_desc",
    English: "Update Geofence preferences for this tracker",
    French: "Mettre à jour les préférences de Geofence pour ce traceur",
    German: "Geofence-Einstellungen für diesen Tracker aktualisieren",
    Spanish: "Actualice las preferencias de la geocerca para este rastreador",
    Italian: "Aggiorna le preferenze di Geofence per questo dispositivo",
  },
  {
    FIELD1: "track.settings.speedLimitLabel",
    English: "Enter Speed Limit",
    French: "Saisir la limite de vitesse",
    German: "Geben Sie den Geschwindigkeitslimit ein",
    Spanish: "Introduzca el límite de velocidad",
    Italian: "Inserisci il limite di velocità",
  },
  {
    FIELD1: "track.settings.mph",
    English: "Miles per hour",
    French: "Miles par heure",
    German: "Meilen pro Stunde",
    Spanish: "Millas por hora",
    Italian: "Miglia all'ora",
  },
  {
    FIELD1: "track.settings.kph",
    English: "Kilometers per hour",
    French: "Kilomètres par heure",
    German: "Kilometer pro Stunde",
    Spanish: "Kilómetros por hora",
    Italian: "Chilometri all'ora",
  },
  {
    FIELD1: "track.settings.speedLimitError",
    English: "Speed Limits must be above 0 and below",
    French:
      "Les limites de vitesse doivent être supérieures à 0 et inférieures à",
    German: "Die Geschwindigkeitsbegrenzung, muss über 0 sein",
    Spanish: "Los límites de velocidad deben ser superiores a 0 e inferiores a",
    Italian: "I limiti di velocità devono essere superiori e inferiori a 0",
  },
  {
    FIELD1: "track.settings.icons",
    English: "Select an Icon",
    French: "Sélectionner une icône",
    German: "Wählen Sie ein Icon",
    Spanish: "Seleccione un icono",
    Italian: "Seleziona un'icona",
  },
  {
    FIELD1: "track.settings.markers",
    English: "Select a Marker",
    French: "Sélectionner un marqueur",
    German: "Wählen Sie eine Markierung",
    Spanish: "Seleccione un marcador",
    Italian: "Seleziona un marcatore",
  },
  {
    FIELD1: "track.settings.alerts",
    English: "Alerts",
    French: "Alertes",
    German: "Benachrichtigungen",
    Spanish: "Alertas",
    Italian: "Notifiche",
  },
  {
    FIELD1: "track.settings.saveBtn",
    English: "Save Changes",
    French: "Enregistrer les modifications",
    German: "Änderungen speichern",
    Spanish: "Guardar cambios",
    Italian: "Salva le modifiche",
  },
  {
    FIELD1: "track.settings.back",
    English: "Back to My Trackers",
    French: "Retour à Mes traceurs",
    German: "Zurück zu Meine Tracker",
    Spanish: "Volver a Mis Rastreadores",
    Italian: "Torna a i miei dispositivi",
  },
  {
    FIELD1: "track.settings.editing",
    English: "Editing",
    French: "Édition",
    German: "Bearbeitung",
    Spanish: "Edición",
    Italian: "Editing",
  },
  {
    FIELD1: "track.settings.mileage",
    English: "Mileage",
    French: "Kilométrage",
    German: "Kilometerstand",
    Spanish: "Kilometraje",
    Italian: "Chilometraggio",
  },
  {
    FIELD1: "track.settings.acc",
    English: "Ignition",
    French: "Démarrage",
    German: "Zündung",
    Spanish: "Encendido",
    Italian: "Accensione",
  },
  {
    FIELD1: "track.settings.accel",
    English: "Rapid Acceleration",
    French: "Accélération rapide",
    German: "Schnelle Beschleunigung",
    Spanish: "Aceleración rápida",
    Italian: "Rapida accellerazione",
  },
  {
    FIELD1: "track.settings.deccel",
    English: "Harsh Braking",
    French: "Freinage brutal",
    German: "Hartes Bremsen",
    Spanish: "Frenada brusca",
    Italian: "Frenata brusca",
  },
  {
    FIELD1: "track.settings.tilt",
    English: "Tilt",
    French: "Inclinaison",
    German: "Neigung",
    Spanish: "Inclinación",
    Italian: "Inclinazione",
  },
  {
    FIELD1: "track.settings.impact",
    English: "Impact",
    French: "Impact",
    German: "Auswirkungen",
    Spanish: "Impacto",
    Italian: "Impatto",
  },
  {
    FIELD1: "track.sidebar.demo",
    English: "Demo",
    French: "Démo",
    German: "Demo",
    Spanish: "Demo",
    Italian: "Dimostrazione",
  },
  {
    FIELD1: "track.sidebar.error_no_tracker_title",
    English: "You don't have any trackers",
    French: "Vous n'avez pas de traceurs",
    German: "Sie haben keine Tracker",
    Spanish: "Usted no tiene rastreadores",
    Italian: "Non hai nessun dispositivo",
  },
  {
    FIELD1: "track.sidebar.error_no_tracker",
    English:
      "Looks like you don’t have any active trackers associated with your account. Please press <b>“Activate Tracker”</b> below to get started.",
    French:
      'Il semble que vous n\'ayez pas de traceurs actifs associés à votre compte. Veuillez cliquer sur <b>"Activer le traceur"</b> ci-dessous pour commencer.',
    German:
      'Sieht so aus, als hätten Sie keine aktiven Tracker mit Ihrem Konto verknüpft. Bitte klicken Sie unten auf <b>"Tracker aktivieren"</b>, um zu beginnen.',
    Spanish:
      'Parece que no tiene ningún rastreador activo asociado a su cuenta. Pulse <b>"Activar rastreador"</b> a continuación para empezar.',
    Italian:
      'Sembra che non ci siano tracker attivi associati al tuo account. Per iniziare, premere <b>"Attiva il tracker"</b> qui sotto.',
  },
  {
    FIELD1: "track.sidebar.error_no_tracker_search",
    English: "No Trackers Found",
    French: "Aucun traceur n'a été trouvé",
    German: "Es wurden keine Tracker gefunden",
    Spanish: "No se han encontrado rastreadores",
    Italian: "Nessun dispositivo trovato",
  },
  {
    FIELD1: "track.sidebar.button_add_tracker",
    English: "Activate Tracker",
    French: "Activer le traceur",
    German: "Tracker aktivieren",
    Spanish: "Activar rastreador",
    Italian: "Attiva il tracker",
  },
  {
    FIELD1: "track.sidebar.error_calibration",
    English:
      "It looks like your tracker is still awaititng calibration. Please follow the instructions in your activation guide to complete this.",
    French:
      "Il semble que votre traceur soit toujours en attente de calibration. Veuillez suivre les instructions dans votre guide d'activation pour compléter cette opération.",
    German:
      "Es sieht so aus, als ob Ihr Tracker immer noch auf die Kalibrierung wartet. Bitte folgen Sie den Anweisungen in Ihrem Aktivierungshandbuch, um dies zu vervollständigen.",
    Spanish:
      "Parece que su rastreador está pendiente de calibración. Por favor, siga las instrucciones de su guía de activación para completarla.",
    Italian:
      "Sembra che il tracker sia ancora in attesa di calibrazione. Seguire le istruzioni della guida all'attivazione per completare l'operazione.",
  },
  {
    FIELD1: "track.sidebar.online",
    English: "Online",
    French: "En ligne",
    German: "Online",
    Spanish: "Online",
    Italian: "Online",
  },
  {
    FIELD1: "track.sidebar.offline",
    English: "Offline",
    French: "Hors ligne",
    German: "Offline",
    Spanish: "Offline",
    Italian: "Offline",
  },
  {
    FIELD1: "track.sidebar.id_not_found",
    English: "This Tracker ID could not be found.",
    French: "Cet identifiant de traceur n'a pas pu être trouvé.",
    German: "Diese Tracker ID konnte nicht gefunden werden. ",
    Spanish: "No se ha podido encontrar este ID de rastreador.",
    Italian: "Non è stato possibile trovare l'ID di questo dispositivo.",
  },
  {
    FIELD1: "track.sidebar.deactivated",
    English: "Deactivated",
    French: "Désactivé",
    German: "Wurde deaktiviert.",
    Spanish: "Desactivado",
    Italian: "Disattivato",
  },
  {
    FIELD1: "track.sidebar.awaiting_calibration",
    English: "Awaiting Calibration",
    French: "En attente de calibrage",
    German: "Kalibrierung ausstehend",
    Spanish: "En espera de calibración",
    Italian: "In attesa di calibrazione",
  },
  {
    FIELD1: "track.sidebar.tracker_management",
    English: "This button would take you to your tracker management page.",
    French: "Ce bouton vous conduira à la page de gestion de votre traceur.",
    German:
      "Mit dieser Schaltfläche gelangen Sie zu Ihrer Tracker-Verwaltungsseite.",
    Spanish:
      "Este botón lo llevará a la página de administración de su rastreador.",
    Italian: "Questo pulsante porta alla pagina di gestione del dispositivo.",
  },
  {
    FIELD1: "track.sidebar.unavailable",
    English: "Unavailable",
    French: "Non disponible",
    German: "Nicht verfügbar",
    Spanish: "No disponible",
    Italian: "Non disponibile",
  },
  {
    FIELD1: "track.sidebar.inside",
    English: "Inside Geofence",
    French: "À l'intérieur Geofence",
    German: "Innen Geofence",
    Spanish: "Adentro",
    Italian: "Dentro",
  },
  {
    FIELD1: "track.sidebar.outside",
    English: "Outside Geofence",
    French: "À l'extérieur Geofence",
    German: "Außen Geofence",
    Spanish: "Afuera",
    Italian: "Fuori",
  },
  {
    FIELD1: "track.sidebar.filter",
    English: "Filter",
    French: "Filtre",
    German: "Filter",
    Spanish: "Filtrar",
    Italian: "Filtro",
  },
  {
    FIELD1: "track.sidebar.sort",
    English: "Sort",
    French: "Trier",
    German: "Sortieren",
    Spanish: "Ordenar",
    Italian: "Ordina",
  },
  {
    FIELD1: "track.filter.inside",
    English: "Inside Geofence",
    French: "Intérieur de la géofence",
    German: "Innerhalb von Geofence",
    Spanish: "Geocerca interior",
    Italian: "All'interno del Geofence",
  },
  {
    FIELD1: "track.filter.outside",
    English: "Outside Geofence",
    French: "En dehors de la géofence",
    German: "Außerhalb des Geofence",
    Spanish: "Geocerca exterior",
    Italian: "Fuori dal Geofence",
  },
  {
    FIELD1: "track.filter.color",
    English: "Marker Color",
    French: "Couleur du marqueur",
    German: "Marker Farbe",
    Spanish: "Color del marcador",
    Italian: "Colore del marcatore",
  },
  {
    FIELD1: "track.filter.type",
    English: "Icon Type",
    French: "Type d'icône",
    German: "Icon Typ",
    Spanish: "Tipo de icono",
    Italian: "Tipo di icona",
  },
  {
    FIELD1: "track.filter.reset",
    English: "Reset",
    French: "Réinitialisation",
    German: "Zurücksetzen",
    Spanish: "Restablecer",
    Italian: "Reset",
  },
  {
    FIELD1: "track.filter.apply",
    English: "Apply",
    French: "Appliquer",
    German: "Anwenden",
    Spanish: "Aplicar",
    Italian: "Applica",
  },
  {
    FIELD1: "track.sort.default",
    English: "Default",
    French: "Défaut",
    German: "Standard",
    Spanish: "Predeterminado",
    Italian: "Predefinito",
  },
  {
    FIELD1: "track.sort.last_connected",
    English: "Last Connected",
    French: "Dernière connexion",
    German: "Zuletzt verbunden",
    Spanish: "Última conexión",
    Italian: "Ultimo collegamento",
  },
  {
    FIELD1: "track.sort.last_movement",
    English: "Last Movement",
    French: "Dernier mouvement",
    German: "Letzte Bewegung",
    Spanish: "Último movimiento",
    Italian: "Ultimo movimento",
  },
  {
    FIELD1: "track.map.tooltip_journey",
    English: "Trace journeys in real time",
    French: "Tracer les parcours en temps réel",
    German: "Verfolgen Sie Fahrten in Echtzeit",
    Spanish: "Rastrear viajes en tiempo real",
    Italian: "Traccia i percorsi in tempo reale",
  },
  {
    FIELD1: "track.map.tooltip_geofence",
    English: "Show geofences",
    French: "Afficher les géofences",
    German: "Geofences anzeigen",
    Spanish: "Mostrar geocercas",
    Italian: "Mostra geofence",
  },
  {
    FIELD1: "track.map.tooltip_navigation",
    English: "Follow Tracker",
    French: "Suivre le traceur",
    German: "Tracker folgen",
    Spanish: "Seguimiento del Rastreador",
    Italian: "Segui i dispositivi",
  },
  {
    FIELD1: "track.map.tooltip_free",
    English: "Freely pan/zoom",
    French: "Panoramique/zoom libre",
    German: "Freies Schwenken/Zoomen",
    Spanish: "Desplazarse libremente",
    Italian: "Panoramica/zoom libero",
  },
  {
    FIELD1: "track.map.tooltip_trackers",
    English: "Show all Trackers",
    French: "Afficher tous les traceurs",
    German: "Alle Tracker anzeigen",
    Spanish: "Mostrar todos los Rastreadores",
    Italian: "Mostra tutti i dispositivi",
  },
  {
    FIELD1: "track.mobile.sorry",
    English: "Sorry, web tracking is unavailable on mobile devices.",
    French:
      "Désolé, la localisation web n'est pas disponible sur les appareils mobiles.",
    German:
      "Es tut uns leid, die web tracking is auf Handys nicht erhältlich. ",
    Spanish:
      "Lo sentimos, el seguimiento web no está disponible en dispositivos móviles.",
    Italian:
      "Siamo spiacenti, il tracciamento web non è disponibile sui dispositivi mobili.",
  },
  {
    FIELD1: "track.mobile.download",
    English: "Please download the colla App",
    French: "Merci de télécharger l'application colla",
    German: "Bitte laden Sie die colla App herunter",
    Spanish: "Descargue la aplicación colla",
    Italian: "Scarica l'applicazione colla",
  },
  {
    FIELD1: "track.mobile.ios_button",
    English: "Download for IOS",
    French: "Téléchargement pour IOS",
    German: "Für IOS herunterladen",
    Spanish: "Descargar para IOS",
    Italian: "Scarica per IOS",
  },
  {
    FIELD1: "track.mobile.android_button",
    English: "Download for Android",
    French: "Téléchargement pour Android",
    German: "Für Android herunterladen",
    Spanish: "Descargar para Android",
    Italian: "Scarica per Android",
  },
  {
    FIELD1: "track.popup.button",
    English: "Load Address",
    French: "Recherche d'adresse",
    German: "Adressen nachsehen",
    Spanish: "Buscar dirección",
    Italian: "Cerca indirizzo",
  },
  {
    FIELD1: "track.popup.loading",
    English: "Loading",
    French: "Chargement",
    German: "Laden",
    Spanish: "Cargando",
    Italian: "Loading",
  },
  {
    FIELD1: "track.popup.error",
    English: "Couldn't Retrieve Address, please Try Again Later",
    French: "Impossible de récupérer l'adresse, veuillez réessayer plus tard.",
    German:
      "Adresse konnte nicht abgerufen werden, bitte versuchen Sie es später erneut.",
    Spanish:
      "No se pudo recuperar la dirección, por favor inténtelo más tarde.",
    Italian: "Couldn't Retrieve Address, please Try Again Later",
  },
  {
    FIELD1: "track.popup.demo",
    English:
      "This button will load your trackers current full address or location name.",
    French: "Ce bouton vous conduira à la page de gestion de votre traceur.",
    German:
      "Mit dieser Schaltfläche gelangen Sie zu Ihrer Tracker-Verwaltungsseite.",
    Spanish:
      "Este botón cargará la dirección completa actual de su rastreador o el nombre de la ubicación.",
    Italian:
      "Questo pulsante carica l'indirizzo completo o il nome della località del dispositivo.",
  },
  {
    FIELD1: "track.alerts.title",
    English: "Alerts",
    French: "Alertes",
    German: "Benachrichtigungen",
    Spanish: "Alertas",
    Italian: "Notifiche",
  },
  {
    FIELD1: "track.alerts.empty1",
    English: "No Alerts Found",
    French: "Aucune alerte trouvée",
    German: "Es wurden keine Benachrichtigungen gefunden",
    Spanish: "No se han encontrado alertas",
    Italian: "Nessun avviso trovato",
  },
  {
    FIELD1: "track.alerts.empty2",
    English: "You're all caught up.",
    French: "Vous êtes à jour.",
    German: "Sie haben alles aufgeholt",
    Spanish: "Ya está al día.",
    Italian: "Sei aggiornato.",
  },
  {
    FIELD1: "track.alerts.no_location",
    English: "No Location Found",
    French: "Aucune localisation trouvée",
    German: "Kein Standort gefunden",
    Spanish: "No se ha encontrado ninguna ubicación",
    Italian: "Nessuna posizione trovata",
  },
  {
    FIELD1: "track.alerts.sent",
    English: "Sent at",
    French: "Envoyé à",
    German: "Gesendet um",
    Spanish: "Enviado a",
    Italian: "Inviato a",
  },
  {
    FIELD1: "track.alerts.bottom",
    English: "Alerts are stored in the cloud and retained for 30 days.",
    French:
      "Les alertes sont stockées dans le cloud et conservées pendant 30 jours.",
    German:
      "Warnungen werden in der Cloud gespeichert und 30 Tage lang aufbewahrt.",
    Spanish:
      "Las alertas se almacenan en la nube y se conservan durante 30 días.",
    Italian:
      "Gli avvisi vengono archiviati nel cloud e conservati per 30 giorni.",
  },
  {
    FIELD1: "track.alerts.supressed",
    English: "Alert supressed due to your quiet hour settings",
    French: "Alerte supprimée en raison des réglages de l'heure de repos",
    German: "Alarm unterdrückt aufgrund Ihrer Ruhezeit-Einstellungen",
    Spanish: "Alerta suprimida debido a su configuración de hora de silencio",
    Italian:
      "Segnalazione disattivata a causa delle impostazioni dell'ora di silenzio",
  },
  {
    FIELD1: "history.helmet.title",
    English: "colla Location History",
    French: "Historique des localisations colla",
    German: "colla Orstverlauf",
    Spanish: "Historial de localizaciones de colla",
    Italian: "Cronologia della posizione colla",
  },
  {
    FIELD1: "history.sidebar.title",
    English: "Location History",
    French: "Historique des localisations",
    German: "Standortverlauf",
    Spanish: "Historial de ubicaciones",
    Italian: "Cronologia della posizione",
  },
  {
    FIELD1: "history.sidebar.error_no_location",
    English: "No Location Data Found",
    French: "Aucune donnée de localisation trouvée",
    German: "Keine Ortsdaten wurden gefunden",
    Spanish: "No se han encontrado datos de ubicación",
    Italian: "Non sono stati trovati dati sulla posizione",
  },
  {
    FIELD1: "history.sidebar.error_no_location_desc",
    English: "Try selecting another tracker.",
    French: "Essayez de sélectionner un autre traceur.",
    German: "Versuchen Sie, einen anderen Tracker auszuwählen.",
    Spanish: "Intente seleccionar otro rastreador.",
    Italian: "Prova a selezionare un altro dispositivo",
  },
  {
    FIELD1: "history.demo.note1",
    English:
      "DEMO NOTE: Please note there may be small discrepancies with distance / speed & time travelled compared to the route shown on the map due to the randomly generated demo data.",
    French:
      "NOTE POUR LA DÉMO : Veuillez noter qu'il peut y avoir de légères différences entre la distance, la vitesse et la durée du trajet par rapport à l'itinéraire indiqué sur la carte, en raison des données de démonstration générées de manière aléatoire.",
    German:
      "DEMO-HINWEIS: Bitte beachten Sie, dass es aufgrund der zufällig generierten Demodaten zu kleinen Abweichungen bei der zurückgelegten Strecke/ Geschwindigkeit und Zeit im Vergleich zu der auf der Karte angezeigten Route kommen kann",
    Spanish:
      "NOTA DEMO: Tenga en cuenta que puede haber pequeñas discrepancias con la distancia / velocidad y tiempo de viaje en comparación con la ruta que se muestra en el mapa debido a los datos de demostración generados en forma aleatoria.",
    Italian:
      "NOTA DEMO: si prega di notare che potrebbero esserci piccole discrepanze con la distanza, la velocità e il tempo di percorrenza rispetto al percorso mostrato sulla mappa, a causa dei dati demo generati casualmente.",
  },
  {
    FIELD1: "history.demo.note2",
    English:
      "In your live account, the map & summary view will correspond 1:1 with your tracker's information.",
    French:
      "Dans votre compte en ligne, la carte et la synthèse vont correspondre 1:1 avec les informations de votre traceur.",
    German:
      "In Ihrem Live-Konto entspricht die Karten- und Übersichtsansicht 1:1 den Informationen Ihres Trackers.",
    Spanish:
      "En su cuenta real, el mapa y la vista de resumen se corresponderán 1:1 con la información de su rastreador.",
    Italian:
      "Nell'account live, la mappa e il riepilogo corrispondono alle informazioni del dispositivo con rapporto 1:1",
  },
  {
    FIELD1: "history.mobile.sorry",
    English:
      "Sorry, seeing your tracker's location history on our website is only accessible on a laptop or desktop.",
    French:
      "Désolé, la consultation de l'historique de localisation de votre traceur sur notre site web n'est accessible que sur un ordinateur portable ou de bureau.",
    German:
      "Leider kann der Standortverlauf Ihres Trackers auf unserer Website nur auf einem Laptop oder Desktop-Computer abgerufen werden.",
    Spanish:
      "Lo sentimos, pero el historial de localización de su rastreador en nuestro sitio web sólo es accesible desde un ordenador portátil o de escritorio.",
    Italian:
      "Siamo spiacenti, la cronologia della posizione del dispositivo sul nostro sito web è accessibile solo su un computer portatile o fisso.",
  },
  {
    FIELD1: "history.mobile.download",
    English: "Please download the colla App",
    French: "Merci de télécharger l'application colla",
    German: "Bitte laden Sie die colla App herunter",
    Spanish: "Descargue la aplicación colla",
    Italian: "Scarica l'applicazione colla",
  },
  {
    FIELD1: "history.mobile.ios_button",
    English: "Download for IOS",
    French: "Téléchargement pour IOS",
    German: "Download für IOS",
    Spanish: "Descargar para IOS",
    Italian: "Scarica per IOS",
  },
  {
    FIELD1: "history.mobile.android_button",
    English: "Download for Android",
    French: "Téléchargement pour Android",
    German: "Download für Android",
    Spanish: "Descargar para Android",
    Italian: "Scarica per Android",
  },
  {
    FIELD1: "history.button.show_all_journeys",
    English: "Show all Journeys",
    French: "Afficher tous les trajets",
    German: "Alle Reisen anzeigen",
    Spanish: "Mostrar todos los viajes",
    Italian: "Visualizza tutti i viaggi",
  },
  {
    FIELD1: "history.map.speed_limit",
    English: "Speed Limit Exceeded",
    French: "Dépassement de la limite de vitesse",
    German: "Geschwindigkeitsüberschreitung",
    Spanish: "Límite de velocidad superado",
    Italian: "Limite di velocità superato",
  },
  {
    FIELD1: "tutorial.main.title",
    English: "Web Tracking Tutorial",
    French: "Tutoriel pour la localisation sur le web",
    German: "Web Tracking Tutorial",
    Spanish: "Tutorial de seguimiento web",
    Italian: "Tutorial sul tracciamento web",
  },
  {
    FIELD1: "tutorial.main.skip",
    English: "Skip",
    French: "Passer",
    German: "Überspringen",
    Spanish: "Omitir",
    Italian: "Salta",
  },
  {
    FIELD1: "tutorial.main.next",
    English: "Next",
    French: "Suivant",
    German: "Nächstes",
    Spanish: "Siguiente",
    Italian: "Prossimo",
  },
  {
    FIELD1: "tutorial.main.done",
    English: "Done",
    French: "Terminé",
    German: "Fertig",
    Spanish: "Listo",
    Italian: "Fatto",
  },
  {
    FIELD1: "footer.social.title",
    English: "Social Media",
    French: "Médias sociaux",
    German: "Soziale Medien",
    Spanish: "Redes sociales",
    Italian: "Social media",
  },
  {
    FIELD1: "footer.shop.title",
    English: "Shop colla",
    French: "Boutique",
    German: "Shop",
    Spanish: "Tienda",
    Italian: "Catalogo",
  },
  {
    FIELD1: "footer.shop.our_shop",
    English: "Our Shop",
    French: "Notre Boutique",
    German: "Unser Shop ",
    Spanish: "Nuestra Tienda",
    Italian: "Il nostro negozio",
  },
  {
    FIELD1: "footer.shop.wired",
    English: "Shop Wired",
    French: "Acheter filaires",
    German: "Geschäft verkabelt",
    Spanish: "Comprar con cable",
    Italian: "Acquista Wired",
  },
  {
    FIELD1: "footer.shop.wireless",
    English: "Shop Wireless",
    French: "Acheter sans fil",
    German: "Drahtlos einkaufen",
    Spanish: "Tienda inalámbrica",
    Italian: "Acquista Wireless",
  },
  {
    FIELD1: "footer.legal.title",
    English: "Legal",
    French: "Légal",
    German: "Rechtlich",
    Spanish: "Legal",
    Italian: "Legale",
  },
  {
    FIELD1: "footer.app.title",
    English: "Get the app",
    French: "Obtenez l'application",
    German: "Holen Sie sich die App",
    Spanish: "Obtén la aplicación",
    Italian: "Scarica l'app",
  },
  {
    FIELD1: "footer.help.title",
    English: "Help",
    French: "Aide",
    German: "Hilfe & Center",
    Spanish: "Ayuda",
    Italian: "Aiuto",
  },
  {
    FIELD1: "footer.help.faqs",
    English: "Help Center",
    French: "Centre d'aide",
    German: "Hilfe-Center",
    Spanish: "Centro de Ayuda",
    Italian: "Centro assistenza",
  },
  {
    FIELD1: "footer.help.contact",
    English: "Contact Us",
    French: "Nous contacter",
    German: "Kontaktieren Sie uns",
    Spanish: "Contacto",
    Italian: "Contattaci",
  },
  {
    FIELD1: "footer.help.privacy",
    English: "Privacy",
    French: "Confidentialité",
    German: "Privatsphäre",
    Spanish: "Privacidad",
    Italian: "Privacy",
  },
  {
    FIELD1: "footer.help.terms",
    English: "Terms",
    French: "Conditions d'utilisation",
    German: "Bestimmungen",
    Spanish: "Términos",
    Italian: "Termini",
  },
  {
    FIELD1: "footer.connect.title",
    English: "Connect with Us",
    French: "Restons connectés",
    German: "Verbinden Sie sich  mit uns",
    Spanish: "Contáctenos",
    Italian: "Mettiti in contatto con noi",
  },
  {
    FIELD1: "footer.connect.about",
    English: "About Us",
    French: "À propos de nous",
    German: "Über uns",
    Spanish: "Quiénes somos",
    Italian: "Chi siamo",
  },
  {
    FIELD1: "footer.contact.sales",
    English: "Contact Sales",
    French: "Contact de vente",
    German: "Kontakt Vertrieb",
    Spanish: "Contacto de ventas",
    Italian: "Contatta il dipartimento vendite",
  },
  {
    FIELD1: "footer.connect.contact_form",
    English: "Contact Form",
    French: "Formulaire de contact",
    German: "Kontaktform",
    Spanish: "Formulario de contacto",
    Italian: "Modulo di contatto",
  },
  {
    FIELD1: "footer.connect.email",
    English: "Email Support",
    French: "Support par e-mail",
    German: "E-Mail Support",
    Spanish: "Soporte por correo electrónico",
    Italian: "Assistenza via e-mail",
  },
  {
    FIELD1: "footer.connect.email_sales",
    English: "Email Sales",
    French: "Ventes par e-mail",
    German: "E-Mail Verkäufe",
    Spanish: "Ventas por correo electrónico",
    Italian: "Vendite via e-mail",
  },
  {
    FIELD1: "footer.connect.referral",
    English: "Referral Scheme",
    French: "Programme de parrainage",
    German: "Empfehlungsschema",
    Spanish: "Esquema de Referencias",
    Italian: "Programma di referenza.",
  },
  {
    FIELD1: "footer.copyright.text",
    English: "© 2025 colla Limited, colla LLC, All Rights Reserved.",
    French: "© 2025 colla Limited, colla LLC, Tous droits réservés.",
    German: "© 2025 colla Limited, colla LLC, Alle Rechte vorbehalten.",
    Spanish: "© 2025 colla Limited, colla LLC, Todos los derechos reservados.",
    Italian: "© 2025 colla Limited, colla LLC, Tutti i diritti riservati.",
  },
  {
    FIELD1: "footer.address.line1",
    English: "2nd Floor, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    French: "2e étage, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    German: "2. Stock, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    Spanish: "2º Piso, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
    Italian: "2° piano, Grabex Business Centre, Murray Rd, Orpington, BR5 3QY",
  },
  {
    FIELD1: "footer.address.line2",
    English: "30 N Gould St Ste N  Sheridan, WY, 82801",
    French: "30 N Gould St Ste N Sheridan, WY, 82801",
    German: "30 N Gould St Ste N  Sheridan, WY, 82801",
    Spanish: "30 N Gould St Ste N Sheridan, WY, 82801",
    Italian: "30 N Gould St Ste N Sheridan, WY, 82801",
  },
  {
    FIELD1: "footer.sidebar_footer.support",
    English: "Support",
    French: "Support",
    German: "Support",
    Spanish: "Ayuda",
    Italian: "Supporto",
  },
  {
    FIELD1: "footer.sidebar_footer.privacy",
    English: "Privacy",
    French: "Confidentialité",
    German: "Privatsphäre",
    Spanish: "Privacidad",
    Italian: "Privacy",
  },
  {
    FIELD1: "footer.sidebar_footer.terms",
    English: "Terms",
    French: "Conditions d'utilisation",
    German: "Bestimmungen",
    Spanish: "Términos",
    Italian: "Termini",
  },
  {
    FIELD1: "footer.sidebar_footer.registration",
    English: "© 2025 colla Limited, All Rights Reserved.",
    French: "© 2025 colla Limited, tous droits réservés.",
    German: "© 2025 colla Limited, Alle Rechte vorbehalten.",
    Spanish: "© 2025 colla Limited, Todos los derechos reservados.",
    Italian: "© 2025 colla Limited, Tutti i diritti riservati.",
  },
  {
    FIELD1: "account.helmet.title",
    English: "colla Account",
    French: "Compte colla",
    German: "Colla-Konto",
    Spanish: "Cuenta colla",
    Italian: "Account colla",
  },
  {
    FIELD1: "account.buttons.billing",
    English: "Go to Billings Settings",
    French: "Accéder aux paramètres de facturation",
    German: "Gehen Sie zu Abrechnungseinstellungen",
    Spanish: "Ir a Configuración de Facturación",
    Italian: "Vai alle Impostazioni di fatturazione",
  },
  {
    FIELD1: "account.billing.message",
    English: "Update your payment method, view past invoices and more.",
    French:
      "Mettez à jour votre mode de paiement, consultez les factures antérieures et bien plus encore.",
    German:
      "Aktualisieren Sie Ihre Zahlungsmethode, sehen Sie sich frühere Rechnungen an und mehr.",
    Spanish: "Actualice su método de pago, vea facturas anteriores y más.",
    Italian:
      "Aggiorna il tuo metodo di pagamento, visualizza le fatture passate e altro ancora.",
  },
  {
    FIELD1: "account.buttons.edit",
    English: "Edit",
    French: "Modifier",
    German: "Bearbeiten",
    Spanish: "Editar",
    Italian: "Modifica",
  },
  {
    FIELD1: "account.buttons.cancel",
    English: "Cancel",
    French: "Annuler",
    German: "Abbrechen",
    Spanish: "Cancelar",
    Italian: "Annulla",
  },
  {
    FIELD1: "account.buttons.success",
    English: "Success",
    French: "Succès",
    German: "Erfolgreich",
    Spanish: "Éxito",
    Italian: "Riuscito",
  },
  {
    FIELD1: "account.buttons.redirecting",
    English: "Redirecting",
    French: "Rediriger",
    German: "Umleitung",
    Spanish: "Redireccionando",
    Italian: "Reindirizzamento",
  },
  {
    FIELD1: "account.buttons.updating",
    English: "Updating",
    French: "Actualisation",
    German: "Updating",
    Spanish: "Actualizando",
    Italian: "Aggiornamento",
  },
  {
    FIELD1: "account.buttons.delete",
    English: "Delete ",
    French: "Supprimer",
    German: "Löschen",
    Spanish: "Eliminar",
    Italian: "Elimina",
  },
  {
    FIELD1: "account.buttons.save",
    English: "Save ",
    French: "Save",
    German: "Save",
    Spanish: "Save",
    Italian: "Save",
  },
  {
    FIELD1: "account.buttons.delete",
    English: "Delete",
    French: "Supprimer",
    German: "Löschen",
    Spanish: "Borrar",
    Italian: "Elimina",
  },
  {
    FIELD1: "account.buttons.deleting",
    English: "Deleting",
    French: "Suppression",
    German: "Löschen",
    Spanish: "Borrando",
    Italian: "Eliminando",
  },
  {
    FIELD1: "account.buttons.cancel",
    English: "Cancel",
    French: "Annuler",
    German: "Abbrechen",
    Spanish: "Cancelar",
    Italian: "Annulla",
  },
  {
    FIELD1: "account.billing.title",
    English: "Billing",
    French: "Facturation",
    German: "Rechnungsstellung",
    Spanish: "Facturación",
    Italian: "Fatturazione",
  },
  {
    FIELD1: "account.location.delete_history",
    English: "Delete All History",
    French: "Supprimer tout l’historique",
    German: "Lösche den gesamten Verlauf.",
    Spanish: "Borrar todo el historial",
    Italian: "Elimina tutta la cronologia",
  },
  {
    FIELD1: "account.location.download",
    English: "Download",
    French: "Télécharger",
    German: "Herunterladen",
    Spanish: "Descargar",
    Italian: "Download",
  },
  {
    FIELD1: "account.tab.general",
    English: "General",
    French: "Général",
    German: "Allgemein",
    Spanish: "General",
    Italian: "Generale",
  },
  {
    FIELD1: "account.tab.billing",
    English: "Billing",
    French: "Facturation",
    German: "Rechnungsstellung",
    Spanish: "Facturación",
    Italian: "Fatturazione",
  },
  {
    FIELD1: "account.tab.developer",
    English: "Developer Tools",
    French: "Outils du développeur",
    German: "Entwickler-Tools",
    Spanish: "Herramientas para Desarrolladores",
    Italian: "Strumenti",
  },
  {
    FIELD1: "account.tab.users",
    English: "Account Sharing",
    French: "Partage de compte",
    German: "Gemeinsame Nutzung eines Kontos",
    Spanish: "Compartir Cuenta",
    Italian: "Condivisione dell'account",
  },
  {
    FIELD1: "account.tab.referrals",
    English: "Referrals",
    French: "Références",
    German: "Referenzen",
    Spanish: "Referencias",
    Italian: "Referenze",
  },
  {
    FIELD1: "account.delete.title",
    English: "Delete your Account",
    French: "Supprimer votre compte",
    German: "Löschen Sie Ihr Konto",
    Spanish: "Eliminar su Cuenta",
    Italian: "Cancellare l'account",
  },
  {
    FIELD1: "account.settings.title",
    English: "Account Settings",
    French: "Paramètres du compte",
    German: "Kontoeinstellungen",
    Spanish: "Configuración de la cuenta",
    Italian: "Impostazioni dell'account",
  },
  {
    FIELD1: "account.settings.subheading",
    English: "Update your personal details here.",
    French: "Mettez à jour vos coordonnées personnelles ici.",
    German: "Aktualisieren Sie hier Ihre persönlichen Daten.",
    Spanish: "Actualice sus datos personales aquí.",
    Italian: "Aggiorna i tuoi dati personali qui.",
  },
  {
    FIELD1: "account.schedule.title",
    English: "Alert Schedules",
    French: "Calendrier des alertes",
    German: "Zeitpläne für Alarme",
    Spanish: "Horarios de alertas",
    Italian: "Programmi di avviso",
  },
  {
    FIELD1: "account.schedule.schedule",
    English: "Schedule",
    French: "Calendrier",
    German: "Zeitplan",
    Spanish: "Horario",
    Italian: "Programma",
  },
  {
    FIELD1: "account.schedule.subheading",
    English:
      "Set times when you want to pause all alerts for this account, on every device logged in.",
    French:
      "Définissez les heures auxquelles vous souhaitez mettre en pause toutes les alertes pour ce compte, sur chaque appareil connecté.",
    German:
      "Legen Sie Zeiten fest, zu denen Sie alle Benachrichtigungen für dieses Konto auf jedem angemeldeten Gerät unterbrechen möchten.",
    Spanish:
      "Establezca horarios en los que desee pausar todas las alertas para esta cuenta, en todos los dispositivos conectados.",
    Italian:
      "Impostare gli orari in cui si desidera mettere in pausa tutti gli avvisi per questo account, su ogni dispositivo connesso.",
  },
  {
    FIELD1: "account.schedule.add",
    English: "Add New",
    French: "Nouveau",
    German: "Neu hinzufügen",
    Spanish: "Agregar nuevo",
    Italian: "Aggiungi nuovo",
  },
  {
    FIELD1: "account.schedule.success",
    English: "Schedule Saved!",
    French: "Calendrier sauvegardé !",
    German: "Zeitplan gespeichert!",
    Spanish: "¡Horario guardado!",
    Italian: "Programma salvato!",
  },
  {
    FIELD1: "account.schedule.success_delete",
    English: "Schedule Deleted!",
    French: "Calendrier supprimé !",
    German: "Zeitplan gelöscht!",
    Spanish: "Horario eliminado!",
    Italian: "Programma eliminato!",
  },
  {
    FIELD1: "account.schedule.error",
    English: "Your schedule can't be saved, please contact support",
    French:
      "Votre calendrier ne peut pas être sauvegardé, veuillez contacter le support",
    German:
      "Ihr Zeitplan kann nicht gespeichert werden, bitte kontaktieren Sie den Support",
    Spanish: "Su horario no se puede guardar, por favor contacte con soporte",
    Italian: "Non è possibile salvare il programma, contattare l'assistenza.",
  },
  {
    FIELD1: "account.schedule.max",
    English: "You can only have 5 alert schedules saved",
    French: "Vous ne pouvez enregistrer que 5 calendriers d'alerte",
    German: "Sie können nur 5 Alarmzeitpläne speichern",
    Spanish: "Solo puede tener 5 horarios de alertas guardados",
    Italian: "È possibile salvare solo 5 programmi di avviso",
  },
  {
    FIELD1: "account.schedule.empty",
    English: "No schedule data found",
    French: "Aucune donnée de calendrier n'a été trouvée",
    German: "Keine Zeitplandaten gefunden",
    Spanish: "No se encontraron datos de horario",
    Italian: "Non sono stati trovati dati di pianificazione",
  },
  {
    FIELD1: "account.schedule_modal.title",
    English: "Set Quiet Schedule",
    French: "Définir un calendrier de repos",
    German: "Zeitplan für Stille einstellen",
    Spanish: "Establecer horario silencioso",
    Italian: "Impostare un programma silenzioso",
  },
  {
    FIELD1: "account.delete_schedule.title",
    English: "Delete Alarm Schedule",
    French: "Supprimer un calendrier d'alarme",
    German: "Alarmzeitplan löschen",
    Spanish: "Eliminar horario de alarma",
    Italian: "Cancellare la pianificazione degli allarmi",
  },
  {
    FIELD1: "account.delete_schedule.message",
    English: "Are you sure you want to remove this schedule?",
    French: "Êtes-vous sûr de vouloir supprimer cet horaire ?",
    German: "Wollen Sie wirklich diesen Plan entefernen?",
    Spanish: "¿Está seguro de que desea eliminar este horario?",
    Italian: "Sei sicuro di voler rimuovere questo programma?",
  },
  {
    FIELD1: "account.schedule_modal.from",
    English: "From",
    French: "De",
    German: "Von",
    Spanish: "De",
    Italian: "Da",
  },
  {
    FIELD1: "account.schedule_modal.to",
    English: "To",
    French: "Au",
    German: "Bis",
    Spanish: "Para",
    Italian: "a",
  },
  {
    FIELD1: "account.schedule_modal.days",
    English: "Select days",
    French: "Sélectionner les jours",
    German: "Tage auswählen",
    Spanish: "Seleccionar días",
    Italian: "Giorni selezionati",
  },
  {
    FIELD1: "account.schedule_modal.repeat",
    English: "Repeat Everyday",
    French: "Répéter tous les jours",
    German: "Täglich wiederholen",
    Spanish: "Repetir todos los días",
    Italian: "Ripeti ogni giorno",
  },
  {
    FIELD1: "account.schedule_modal.set",
    English: "Set Schedule",
    French: "Définir le calendrier",
    German: "Zeitplan festlegen",
    Spanish: "Establecer horario",
    Italian: "Imposta programma",
  },
  {
    FIELD1: "account.schedule.invalid",
    English: "End time cannot be before the start time",
    French: "L'heure de fin ne peut pas être antérieure à l'heure de début",
    German: "Das Enddatum kann nicht vor dem Startdatum liegen.",
    Spanish:
      "La hora de finalización no puede ser anterior a la hora de inicio.",
    Italian: "L'ora di arrivo non può essere precedente all'ora di partenza",
  },
  {
    FIELD1: "account.delete.message",
    English:
      "Deleting your account will remove your login credentials and user data from our systems. This account will also unpair your trackers from your account, cancel associated subscriptions and delete associated data.",
    French:
      "En supprimant votre compte, vous supprimez vos identifiants de connexion et vos données d'utilisateur de nos systèmes. Ce compte permettra également de dissocier vos traceurs de votre compte, d'annuler les abonnements associés et de supprimer les données associées.",
    German:
      "Wenn Sie Ihr Konto löschen, werden Ihre Anmeldedaten und Benutzerdaten aus unseren Systemen entfernt. Dieses Konto hebt auch die Kopplung Ihrer Tracker mit Ihrem Konto auf, kündigt die damit verbundenen Abonnements und löscht die damit verbundenen Daten.",
    Spanish:
      "Eliminar su cuenta eliminará sus credenciales de inicio de sesión y datos de usuario de nuestros sistemas. Esta cuenta también desvinculará sus rastreadores de su cuenta, cancelará suscripciones asociadas y eliminará datos asociados.",
    Italian:
      "L'eliminazione dell'account rimuoverà le credenziali di accesso e i dati dell'utente dai nostri sistemi. Inoltre, l'eliminazione dell'account disaccoppierà i dispositivi di tracciamento dal proprio account, annullerà gli abbonamenti associati e cancellerà i dati associati.",
  },
  {
    FIELD1: "account.delete.warning",
    English:
      "Deleting your account will remove all of your content and data associated with your Colla profile.",
    French:
      "La suppression de votre compte supprimera tout votre contenu et vos données associés à votre profil Colla.",
    German:
      "Durch das Löschen Ihres Kontos werden alle Ihre Inhalte und Daten entfernt, die mit Ihrem Colla-Profil verknüpft sind.",
    Spanish:
      "Eliminar tu cuenta eliminará todo tu contenido y datos asociados con tu perfil de Colla.",
    Italian:
      "L'eliminazione del tuo account rimuoverà tutto il tuo contenuto e i dati associati al tuo profilo Colla.",
  },
  {
    FIELD1: "account.delete.success_title",
    English: "Account Deleted",
    French: "Compte supprimé",
    German: "Konto gelöscht",
    Spanish: "Cuenta eliminada",
    Italian: "Account cancellato",
  },
  {
    FIELD1: "account.delete.success_subheading",
    English: "Your account has been removed",
    French: "Votre compte a été supprimé",
    German: "Ihr Konto wurde entfernt",
    Spanish: "Su cuenta ha sido eliminada",
    Italian: "Il tuo account è stato rimosso",
  },
  {
    FIELD1: "account.delete.confirm",
    English: "Confirm the deletion of your account",
    French: "Confirmez la suppression de votre compte",
    German: "Bestätigen Sie die Löschung Ihres Kontos",
    Spanish: "Confirme la eliminación de su cuenta",
    Italian: "Confermare l'eliminazione del tuo account",
  },
  {
    FIELD1: "account.delete.warning_title",
    English: "Delete user account",
    French: "Supprimer le compte de l'utilisateur",
    German: "Benutzerkonto löschen",
    Spanish: "Eliminar la cuenta de usuario",
    Italian: "Eliminare l'account utente",
  },
  {
    FIELD1: "account.delete.warning_subheading",
    English: "This action can not be undone, proceed with caution.",
    French: "Cette action ne peut pas être annulée, procédez avec prudence.",
    German:
      "Diese Aktion kann nicht rückgängig gemacht werden, gehen Sie vorsichtig vor.",
    Spanish: "Esta acción no se puede deshacer, proceda con precaución.",
    Italian: "Questa azione non può essere annullata, procedi con cautela.",
  },
  {
    FIELD1: "account.delete.warning_para1",
    English:
      "This action is irreversible and will permanently delete your account. All of your data, including your profile, posts, and personal information, will be <b>permanently removed.</b>",
    French:
      "Cette action est irréversible et supprimera définitivement votre compte. Toutes vos données, y compris votre profil, vos publications et vos informations personnelles, seront <b>supprimées de manière permanente.</b>",
    German:
      "Diese Aktion ist irreversibel und löscht Ihr Konto dauerhaft. Alle Ihre Daten, einschließlich Ihres Profils, Ihrer Beiträge und persönlichen Informationen, werden <b>endgültig entfernt.</b>",
    Spanish:
      "Esta acción es irreversible y eliminará permanentemente su cuenta. Todos sus datos, incluyendo su perfil, publicaciones e información personal, serán <b>eliminados permanentemente.</b>",
    Italian:
      "Questa azione è irreversibile e cancellerà permanentemente il tuo account. Tutti i tuoi dati, inclusi il profilo, i post e le informazioni personali, saranno <b>rimossi in modo permanente.</b>",
  },
  {
    FIELD1: "account.delete.warning_para2",
    English:
      "By entering your password, you confirm that you understand and accept the consequences of deleting your account.",
    French:
      "En saisissant votre mot de passe, vous confirmez que vous comprenez et acceptez les conséquences de la suppression de votre compte.",
    German:
      "Durch die Eingabe Ihres Passworts bestätigen Sie, dass Sie die Konsequenzen der Löschung Ihres Kontos verstehen und akzeptieren.",
    Spanish:
      "Al introducir tu contraseña, confirmas que comprendes y aceptas las consecuencias de eliminar tu cuenta.",
    Italian:
      "Immettendo la tua password, confermi di aver compreso e accettato le conseguenze della cancellazione del tuo account.",
  },
  {
    FIELD1: "account.buttons.deleting",
    English: "Deleting Account",
    French: "Suppression du compte",
    German: "Konto löschen",
    Spanish: "Eliminar cuenta",
    Italian: "Eliminazione dell'account in corso",
  },
  {
    FIELD1: "account.buttons.phrase",
    English: "Please enter the phrase correctly.",
    French: "Veuillez saisir correctement la phrase.",
    German: "Bitte geben Sie den Satz richtig ein.",
    Spanish: "Por favor, introduzca la frase correctamente.",
    Italian: "Inserire correttamente la frase.",
  },
  {
    FIELD1: "account.buttons.cancel",
    English: "Cancel",
    French: "Annuler",
    German: "Abbrechen",
    Spanish: "Cancelar",
    Italian: "Annulla",
  },
  {
    FIELD1: "account.errors.general",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, bitte versuchen Sie es später nochmal.",
    Spanish: "Algo ha ido mal, por favor inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto, riprovare più tardi.",
  },
  {
    FIELD1: "account.errors.success",
    English: "Updated Successfully",
    French: "Mise à jour réussie",
    German: "Es wurde erfolgreich aktualisiert",
    Spanish: "Actualizado correctamente",
    Italian: "Aggiornamento riuscito",
  },
  {
    FIELD1: "account.errors.not_found",
    English: "Account could not be found.",
    French: "Le compte n'a pas pu être trouvé.",
    German: "Das Konto konnte nicht gefunden werden.",
    Spanish: "No se pudo encontrar la cuenta.",
    Italian: "L'account non è stato trovato.",
  },
  {
    FIELD1: "account.errors.incorrect",
    English: "Incorrect username or password.",
    French: "Nom d'utilisateur ou mot de passe incorrect.",
    German: "Falscher Nutzername oder Passwort.",
    Spanish: "Nombre de usuario o contraseña incorrectos.",
    Italian: "Nome utente o password errati.",
  },
  {
    FIELD1: "account.location.title",
    English: "History Management",
    French: "Gestion de l'historique",
    German: "Geschichte Management",
    Spanish: "Gestión del historial",
    Italian: "Gestione della cronologia",
  },
  {
    FIELD1: "account.location.export_title",
    English: "Location Data Export",
    French: "Exportation des données de localisation",
    German: "Standortdatenexport",
    Spanish: "Exportación de datos de ubicación",
    Italian: "Esportazione dei dati di localizzazione",
  },
  {
    FIELD1: "account.location_delete.title",
    English: "Delete All Location Data",
    French: "Supprimer toutes les données de localisation",
    German: "Alle Standortdaten löschen",
    Spanish: "Eliminar todos los datos de ubicación",
    Italian: "Elimina tutti i dati di localizzazione",
  },
  {
    FIELD1: "account.errors.history",
    English: "No location data found.",
    French: "Aucune donnée de localisation n'a été trouvée.",
    German: "Es wurden keine Standortdaten gefunden.",
    Spanish: "No se encontraron datos de ubicación.",
    Italian: "Non sono stati trovati dati sulla posizione.",
  },
  {
    FIELD1: "account.errors.noDevices",
    English: "No trackers found.",
    French: "Aucun appareil n'a été trouvé.",
    German: "Es wurden keine Geräte gefunden",
    Spanish: "No se encontraron dispositivos.",
    Italian: "Nessun dispositivo trovato",
  },
  {
    FIELD1: "account.errors.noHistory",
    English: "Failed to retrieve data. Please contact support.",
    French:
      "Échec de la récupération des données. Veuillez contacter l'assistance.",
    German:
      "Fehler beim Abrufen der Daten. Bitte wenden Sie sich an den Support.",
    Spanish:
      "No se pudieron recuperar los datos. Por favor, póngase en contacto con soporte.",
    Italian: "Impossibile recuperare i dati. Contattare l'assistenza.",
  },
  {
    FIELD1: "account.errors.historyWarn",
    English:
      "Please confirm you would like to delete all location history of your tracker. This action is irreversable.",
    French:
      "Veuillez confirmer que vous souhaitez supprimer tout l'historique de localisation de votre traceur. Cette action est irréversible.",
    German:
      "Bitte bestätigen Sie, dass Sie den gesamten Standortverlauf Ihres Trackers löschen möchten. Diese Aktion ist unumkehrbar.",
    Spanish:
      "Por favor, confirme que desea eliminar todo el historial de localización de su rastreador. Esta acción es irreversible.",
    Italian:
      "Confermare che si desidera eliminare tutta la cronologia delle posizioni del dispositivo. Questa azione è irreversibile.",
  },
  {
    FIELD1: "account.errors.historyDelete",
    English:
      "Sorry we encountered an error while deleting your history. Please contact support.",
    French:
      "Désolé, nous rencontrons une erreur lors de la suppression de votre historique. Veuillez contacter l'assistance.",
    German:
      "Es tut uns leid, es gibt einen Fehlee bei der Löschung deines Verlaufs.",
    Spanish:
      "Lo sentimos, hemos encontrado un error al eliminar su historial. Póngase en contacto con soporte.",
    Italian:
      "Sorry we encountered an error while deleting your history. Please contact support.",
  },
  {
    FIELD1: "account.errors.unauthorized",
    English: "Unauthorized",
    French: "Non autorisé",
    German: "Nicht authoriziert",
    Spanish: "No autorizado",
    Italian: "Non autorizzato",
  },
  {
    FIELD1: "account.main.title",
    English: "My Account",
    French: "Mon compte",
    German: "Mein Konto",
    Spanish: "Mi cuenta",
    Italian: "Il mio account",
  },
  {
    FIELD1: "account.main.label_name",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
  },
  {
    FIELD1: "account.main.label_language",
    English: "Global Language",
    French: "Langue mondiale",
    German: "Weltsprache",
    Spanish: "Idioma global",
    Italian: "Lingua generale",
  },
  {
    FIELD1: "account.main.language_tooltip",
    English:
      "Your global language is used to display your chosen language in notifications, emails, and billing.",
    French:
      "Votre langue globale est utilisée pour afficher votre langue choisie dans les notifications, les e-mails et la facturation.",
    German:
      "Ihre globale Sprache wird verwendet, um Ihre gewählte Sprache in Benachrichtigungen, E-Mails und Rechnungen anzuzeigen.",
    Spanish:
      "Tu idioma global se utiliza para mostrar tu idioma elegido en notificaciones, correos electrónicos y facturación.",
    Italian:
      "La tua lingua globale viene utilizzata per visualizzare la lingua scelta nelle notifiche, nelle email e nella fatturazione.",
  },
  {
    FIELD1: "account.main.label_email",
    English: "Email",
    French: "Email",
    German: "E-Mail",
    Spanish: "Correo electrónico",
    Italian: "Email",
  },
  {
    FIELD1: "account.main.label_country",
    English: "Country",
    French: "Pays",
    German: "Land",
    Spanish: "País",
    Italian: "Paese",
  },
  {
    FIELD1: "account.main.label_contact",
    English: "Contact me with offers and updates",
    French: "Contact",
    German: "Kontakt",
    Spanish: "Contacto",
    Italian: "Contatto",
  },
  {
    FIELD1: "account.main.label_notifyEmail",
    English: "Send tracker notifications to my email",
    French: "Envoyer les notifications du traceur sur mon adresse e-mail",
    German: "Senden Sie Tracker Nachrichten an meine E-Mail",
    Spanish: "Enviar notificaciones de seguimiento a mi correo electrónico.",
    Italian: "Invia le notifiche del dispositivo al mio indirizzo e-mail.",
  },
  {
    FIELD1: "account.main.label_password",
    English: "Password",
    French: "Mot de passe",
    German: "Passwort",
    Spanish: "Nombre",
    Italian: "Nome",
  },
  {
    FIELD1: "account.main.label_phone",
    English: "Phone Number",
    French: "Numéro de téléphone",
    German: "Telefonnummer",
    Spanish: "Número de teléfono",
    Italian: "Numero di telefono",
  },
  {
    FIELD1: "account.main.phone_placeholder",
    English: "e.g. +44 7700 900123 or +1 202 555 0147",
    French: "ex. +33 6 12 34 56 78",
    German: "z. B. +49 1512 3456789",
    Spanish: "p. ej. +34 612 34 56 78",
    Italian: "es. +39 312 345 6789",
  },
  {
    FIELD1: "account.main.error_phone",
    English: "Please enter a valid phone number",
    French: "Veuillez entrer un numéro de téléphone valide",
    German: "Bitte geben Sie eine gültige Telefonnummer ein",
    Spanish: "Por favor, introduzca un número de teléfono válido",
    Italian: "Inserisci un numero di telefono valido",
  },
  {
    FIELD1: "account.main.label_contact_if_found",
    English: "Allow us to provide your phone number if your pet is found?",
    French:
      "Autorisez-nous à fournir votre numéro de téléphone si votre animal de compagnie est retrouvé ?",
    German:
      "Erlauben Sie uns, Ihre Telefonnummer bereitzustellen, wenn Ihr Haustier gefunden wird?",
    Spanish:
      "¿Nos permite proporcionar su número de teléfono si su mascota es encontrada?",
    Italian:
      "Ci consente di fornire il tuo numero di telefono se il tuo animale domestico viene trovato?",
  },
  {
    FIELD1: "account.location.label_startTime",
    English: "Start Time",
    French: "Heure de début",
    German: "Startzeit",
    Spanish: "Hora de inicio",
    Italian: "Orario di inizio",
  },
  {
    FIELD1: "account.location.label_endTime",
    English: "End Time",
    French: "Heure de fin",
    German: "Endzeit",
    Spanish: "Hora de finalización",
    Italian: "Orario di fine",
  },
  {
    FIELD1: "account.main.type",
    English: "Please type “delete my account”:",
    French: 'Veuillez saisir "supprimer mon compte" :',
    German: 'Bitte geben Sie ein " mein Konto löschen',
    Spanish: 'Por favor escriba "eliminar mi cuenta":',
    Italian: 'Sei pregato di digitare "cancella il mio account":',
  },
  {
    FIELD1: "account.main.delete_fail",
    English:
      "Sorry we encountered an error while deleting your account. Please contact support.",
    French:
      "Désolé, nous avons rencontré une erreur lors de la suppression de votre compte. Veuillez contacter le service d’assistance.",
    German:
      "Beim Löschen Ihres Kontos ist leider ein Fehler aufgetreten. Bitte wenden Sie sich an den Support.",
    Spanish:
      "Lo sentimos, hemos encontrado un error al eliminar su cuenta. Por favor, póngase en contacto con soporte.",
    Italian:
      "Siamo spiacenti. Abbiamo riscontrato un errore durante la cancellazione del suo account. Si prega di contattare l'assistenza.",
  },
  {
    FIELD1: "account.main.warning",
    English:
      "Deleting your account will remove your login credentials and user data from our systems. This action will also unpair your trackers from your account, cancel associated subscriptions and delete associated data. <br /> <b>This action is irreversable.</b>",
    French:
      "La suppression de votre compte entraînera la perte de vos identifiants de connexion et de vos données utilisateur dans nos systèmes. Cette action entraînera également la dissociation de vos traceurs de votre compte, l'annulation des abonnements associés et la suppression des données associées. <br /> <b>Cette action est irréversible.</b>",
    German:
      "Wenn Sie Ihr Konto löschen, werden Ihre Anmeldedaten und Benutzerdaten aus unseren Systemen entfernt. Durch diese Aktion werden auch Ihre Tracker von Ihrem Konto getrennt, zugehörige Abonnements gekündigt und zugehörige Daten gelöscht. <br /> <b>Diese Aktion ist unumkehrbar.</b>",
    Spanish:
      "Eliminar su cuenta eliminará sus credenciales de inicio de sesión y datos de usuario de nuestros sistemas. Esta acción también desvinculará sus rastreadores de su cuenta, cancelará las suscripciones asociadas y eliminará los datos asociados. <br /> <b>Esta acción es irreversible.</b>",
    Italian:
      "L'eliminazione dell'account rimuoverà anche le credenziali di accesso e i dati utente dal nostro sistema. Quest'azione disaccoppierà anche i dispositivi dall'account, annullerà gli abbonamenti associati e cancellerà i dati associati. Questa azione è irreversibile.",
  },
  {
    FIELD1: "account.main.reset",
    English:
      "Looking to reset your password? Log out and go to the login page to find the link.",
    French:
      "Vous souhaitez réinitialiser votre mot de passe ? Déconnectez-vous et allez à la page de connexion pour trouver le lien.",
    German:
      "Möchtest du dein Passwort zurücksetzen? Melde ab und gehe zur Anmeldeseite, um den entsprechenden Link zu finden.",
    Spanish:
      "¿Desea restablecer su contraseña? Cierre sesión y vaya a la página de inicio de sesión para encontrar el enlace.",
    Italian:
      "Vuoi reimpostare la tua password? Esci e vai alla pagina di login per trovare il link.",
  },
  {
    FIELD1: "add_device.helmet.title",
    English: "Activate your colla",
    French: "Enregistrer votre traceur colla",
    German: "colla Register Tracker",
    Spanish: "Rastreador de registros colla",
    Italian: "Registro di tracciamento colla",
  },
  {
    FIELD1: "add_device.button.purchase",
    English: "Purchase Subscription",
    French: "Acheter un abonnement",
    German: "Kauf Abomment",
    Spanish: "Comprar suscripción",
    Italian: "Acquista un abbonamento",
  },
  {
    FIELD1: "add_device.main.title",
    English: "Activate Your Colla",
    French: "Activer votre colla",
    German: "colla aktivieren",
    Spanish: "Activar tu colla",
    Italian: "Attiva il tuo colla",
  },
  {
    FIELD1: "add_device.main.subheading",
    English: "Your first steps to a safer, happier pet!",
    French:
      "Vos premiers pas vers un animal de compagnie plus sûr et plus heureux !",
    German:
      "Ihre ersten Schritte zu einem sichereren und glücklicheren Haustier!",
    Spanish: "¡Tus primeros pasos hacia una mascota más segura y feliz!",
    Italian:
      "I tuoi primi passi verso un animale domestico più sicuro e felice!",
  },
  {
    FIELD1: "add_device.button.redirecting",
    English: "Pairing Tracker",
    French: "Suivi de l'appariement",
    German: "Tracker miteinander verkoppeln ",
    Spanish: "Emparejando rastreador",
    Italian: "Collegando il tracker",
  },
  {
    FIELD1: "add_device.button.success",
    English: "Redirecting to Checkout",
    French: "Redirection vers la caisse",
    German: "Zum Checkout umleiten",
    Spanish: "Redirigiendo a la caja",
    Italian: "Reindirizzamento al checkout",
  },
  {
    FIELD1: "add_device.error.general",
    English: "Something went wrong, please try again later.",
    French: "Un problème est survenu, veuillez réessayer plus tard.",
    German: "Etwas ist schiefgelaufen, bitte versuchen Sie es später nochmal.",
    Spanish: "Algo salió mal, por favor inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto, riprovare più tardi.",
  },
  {
    FIELD1: "add_device.error.too_many_requests",
    English: "Too many attempts, please retry in a few minutes",
    French: "Trop de tentatives, veuillez réessayer dans quelques minutes.",
    German:
      "Sie haben zu viele falsche Versuche, bitte versuchen Sie es in ein paar Minuten noch einmal.",
    Spanish:
      "Demasiados intentos, por favor vuelva a intentarlo en unos minutos",
    Italian: "Troppi tentativi, riprovare tra qualche minuto",
  },
  {
    FIELD1: "add_device.error.already_registered",
    English:
      "It looks like you've already registered and activated your tracker, you can find it on the 'Manage collas' page.",
    French:
      "Il semble que vous ayez déjà enregistré et activé votre tracker, vous pouvez le trouver sur la page 'Gérer les collections'.",
    German:
      "Es scheint, dass Sie Ihren Tracker bereits registriert und aktiviert haben. Sie finden ihn auf der Seite 'Kollektionen verwalten'.",
    Spanish:
      "Parece que ya has registrado y activado tu rastreador, puedes encontrarlo en la página 'Gestionar colecciones'.",
    Italian:
      "Sembra che tu abbia già registrato e attivato il tuo tracker, puoi trovarlo nella pagina 'Gestisci collezioni'.",
  },
  {
    FIELD1: "add_device.error.already_added",
    English:
      "Your tracker was added to your account, but we're having some trouble setting up your subscription. Please try again later by pressing the Activate Button on your tracker on the 'Manage collas' page.",
    French:
      "Votre traqueur a été ajouté à votre compte, mais nous rencontrons des difficultés pour configurer votre abonnement. Veuillez réessayer plus tard en appuyant sur le bouton Activer sur votre traqueur dans la page 'Gérer les colis'.",
    German:
      "Ihr Tracker wurde Ihrem Konto hinzugefügt, aber wir haben Schwierigkeiten bei der Einrichtung Ihres Abonnements. Bitte versuchen Sie es später erneut, indem Sie auf der Seite 'Pakete verwalten' auf die Aktivieren-Schaltfläche Ihres Trackers drücken.",
    Spanish:
      "Su rastreador se ha añadido a su cuenta, pero estamos teniendo problemas para configurar su suscripción. Por favor, inténtelo de nuevo más tarde pulsando el botón Activar en su rastreador en la página 'Gestionar paquetes'.",
    Italian:
      "Il tuo tracker è stato aggiunto al tuo account, ma stiamo riscontrando alcuni problemi nell'impostazione del tuo abbonamento. Per favore, riprova più tardi premendo il pulsante Attiva sul tuo tracker nella pagina 'Gestisci pacchi'.",
  },
  {
    FIELD1: "add_device.error.not_found",
    English:
      "This Tracker could not be found, please check that you have entered it correctly, or contact support.",
    French:
      "Ce traceur n'a pas pu être trouvé, veuillez vérifier que vous l'avez saisi correctement, ou contactez le support.",
    German:
      "Dieser Tracker konnte nicht gefunden werden. Bitte überprüfen Sie, ob Sie ihn korrekt eingegeben haben, oder wenden Sie sich an den Support.",
    Spanish:
      "No se ha podido encontrar este rastreador, compruebe que lo ha introducido correctamente o póngase en contacto con el servicio de asistencia.",
    Italian:
      "Questo Dispositivo non è stato trovato, verificare che sia stato inserito correttamente o contattare l'assistenza.",
  },
  {
    FIELD1: "add_device.error.paired",
    English:
      "This Tracker is already registered to an account, please check that you have entered it correctly, or contact support.",
    French:
      "Ce traceur est déjà enregisté sur un compte. Veuillez verifier que vous l'avez inscrit correctement ou contactez l'assistance.",
    German:
      "Dieser Tracjer ist schon angemeldet, bitte prüfen ob du es richtig eingegeben hast oder kontaktiere den Support",
    Spanish:
      "Este rastreador ya está registrado en una cuenta, verifique que lo haya introducido correctamente o póngase en contacto con soporte.",
    Italian:
      "Questo Dispositivo è già registrato a un account, verificare che sia stato inserito correttamente o contattare l'assistenza.",
  },
  {
    FIELD1: "add_device.error.contact_step",
    English:
      "Désolé, ce traceur necessite une étape d'activation nécessaire. Veuillez nous contacter à help@collatracking.com",
    French:
      "Désolé, ce traceur necessite une étape d'activation nécessaire. Veuillez nous contacter à help@collatracking.com",
    German:
      "Entschuldigung dieser Tracker braucht zusätzliche Aktivierungsschritte, bitte kontaktiere uns unter help@collatracking.com",
    Spanish:
      "Lo sentimos, este Rastreador requiere un paso de activación adicional, por favor contáctenos a través de help@collatracking.com",
    Italian:
      "Désolé, ce traceur necessite une étape d'activation nécessaire. Veuillez nous contacter à help@collatracking.com",
  },
  {
    FIELD1: "add_device.error.contact_plans",
    English:
      "Sorry, we are unable to retrieve the subscription plans for this tracker, please contact us at help@collatracking.com",
    French:
      "Désolé, ce Tracker nécessite une étape d'activation supplémentaire, veuillez nous contacter à help@collatracking.com",
    German:
      "Entschuldigung, dieser Tracker erfordert einen zusätzlichen Aktivierungsschritt, bitte kontaktieren Sie uns unter help@collatracking.com",
    Spanish:
      "Lo sentimos, no podemos recuperar los planes de suscripción para este rastreador, por favor contáctenos en help@collatracking.com",
    Italian:
      "Sorry, we are unable to retrieve the subscription plans for this tracker, please contact us at help@collatracking.com",
  },
  {
    FIELD1: "add_device.error.length",
    English: "The Tracker PIN should be X digits long",
    French: "Le PIN du traceur doit comporter au maximum X chiffres",
    German: "Die Tracker PIN sollte maximal X Ziffern lang sein",
    Spanish: "El PIN del rastreador debe tener un máximo de X dígitos.",
    Italian: "Il PIN del Dispositivo deve essere di massimo X cifre.",
  },
  {
    FIELD1: "add_device.error.min2",
    English: "Tracker names have to be 2 letters or over.",
    French: "Les noms des traceurs doivent être de 2 lettres ou plus.",
    German: "Tracker-Namen müssen mindestens 2 Buchstaben lang sein.",
    Spanish: "Los nombres de los rastreadores deben tener 2 letras o más.",
    Italian: "I nomi dei dispositivi devono essere di 2 lettere o più.",
  },
  {
    FIELD1: "add_device.error.max16",
    English: "Tracker names have to be under 16 letters long.",
    French: "Les noms des traceurs doivent comporter moins de 16 lettres.",
    German: "Tracker-Namen müssen weniger als 16 Buchstaben lang sein.",
    Spanish: "Los nombres de los rastreadores deben tener menos de 16 letras.",
    Italian: "Tracker names have to be under 16 letters long.",
  },
  {
    FIELD1: "add_device.main.title1",
    English: "Activate",
    French: "Activer",
    German: "Aktivieren",
    Spanish: "Activar",
    Italian: "Attiva",
  },
  {
    FIELD1: "add_device.main.title2",
    English: "Activate Tracker",
    French: "Activer le traceur",
    German: "Tracker aktivieren",
    Spanish: "Activar rastreador",
    Italian: "Attiva il tracker",
  },
  {
    FIELD1: "add_device.main.trackerPresent",
    English:
      "It looks like this tracker is already in your account, so you can use the below form to activate it. You will be redirected to stripe to purchase a subscription and activate your tracker.",
    French:
      "Il semble que ce traceur soit déjà dans votre compte, vous pouvez donc utiliser le formulaire ci-dessous pour l'activer. Vous serez redirigé vers Stripe pour acheter un abonnement et activer votre traceur.",
    German:
      "Es sieht so aus, als ob dieser Tracker bereits in Ihrem Konto vorhanden ist, also können Sie das untenstehende Formular verwenden, um ihn zu aktivieren. Sie werden zu Stripe weitergeleitet, um ein Abonnement zu erwerben und Ihren Tracker zu aktivieren.",
    Spanish:
      "Parece que este rastreador ya está en su cuenta, así que puede utilizar el siguiente formulario para activarlo. Será redirigido a Stripe para comprar una suscripción y activar su rastreador.",
    Italian:
      "Sembra che questo dispositivo sia già presente nel tuo account, quindi potrai utilizzare il modulo sottostante per attivarlo. Verrai reindirizzato a stripe per acquistare un abbonamento e attivare il dispositivo.",
  },
  {
    FIELD1: "add_device.main.trackerNotPresent",
    English:
      "Fill out the below form to add your new tracker to your account. You will be redirected to stripe to purchase a subscription and activate your tracker.",
    French:
      "Remplissez le formulaire ci-dessous pour ajouter votre nouveau traceur à votre compte. Vous serez redirigé vers stripe pour acheter un abonnement et activer votre traceur.",
    German:
      "Füllen Sie das untenstehende Formular aus, um Ihren neuen Tracker zu Ihrem Konto hinzuzufügen. Sie werden dann zu Stripe weitergeleitet, um ein Abonnement zu erwerben und Ihren Tracker zu aktivieren.",
    Spanish:
      "Rellene el siguiente formulario para añadir su nuevo rastreador a su cuenta. Será redirigido a Stripe para comprar una suscripción y activar su rastreador.",
    Italian:
      "Compila il modulo sottostante per aggiungere il nuovo dispositivo al tuo account. Verrai reindirizzato a stripe per acquistare un abbonamento e attivare il dispositivo.",
  },
  {
    FIELD1: "add_device.main.tracker_imei",
    English: "PIN Number",
    French: "Numéro PIN",
    German: "PIN-Nummer",
    Spanish: "Número PIN",
    Italian: "Numero PIN",
  },
  {
    FIELD1: "add_device.main.imei_tooltip",
    English:
      "This is a unique XX digit code located on a sticker on your tracker.",
    French:
      "Il s'agit d'un code unique à XX chiffres situé sur un autocollant apposé sur votre traceur.",
    German:
      "Dies ist ein einzigartiger XX-stelliger Code, der sich auf einem Aufkleber auf Ihrem Tracker befindet.",
    Spanish:
      "Se trata de un código único de XX dígitos que se encuentra en una calcomanía en su rastreador.",
    Italian:
      "Si tratta di un codice univoco di XX cifre che si trova su un adesivo del dispositivo.",
  },
  {
    FIELD1: "add_device.main.breed_tooltip",
    English:
      "Missing your pet's breed? Sorry about that! Just choose Mixed Breed, and if you'd like, send us a message to let us know so we can add it!",
    French:
      "Vous manquez la race de votre animal de compagnie ? Désolé pour ça ! Choisissez simplement 'Race Mixte', et si vous le souhaitez, envoyez-nous un message pour nous le faire savoir afin que nous puissions l'ajouter !",
    German:
      "Fehlt Ihnen die Rasse Ihres Haustieres? Das tut uns leid! Wählen Sie einfach 'Mischling' und senden Sie uns eine Nachricht, wenn Sie möchten, damit wir es hinzufügen können!",
    Spanish:
      "¿Te falta la raza de tu mascota? ¡Lo sentimos! Simplemente elige 'Raza Mixta' y, si lo deseas, envíanos un mensaje para hacérnoslo saber y poder añadirla.",
    Italian:
      "Ti manca la razza del tuo animale domestico? Ci dispiace! Scegli semplicemente 'Razza Mista' e, se lo desideri, inviaci un messaggio per farci sapere in modo che possiamo aggiungerla!",
  },
  {
    FIELD1: "add_device.main.tracker_name",
    English: "Your Pet's Name",
    French: "Le nom de votre animal de compagnie",
    German: "Der Name Ihres Haustieres",
    Spanish: "El nombre de tu mascota",
    Italian: "Il nome del tuo animale domestico",
  },
  {
    FIELD1: "add_device.main.img_preview",
    English: "Enter a valid IMEI to preview the image.",
    French: "Entrez un IMEI valide pour prévisualiser l'image.",
    German: "Geben Sie eine gültige IMEI ein, um das Bild anzuzeigen.",
    Spanish: "Ingrese un IMEI válido para previsualizar la imagen.",
    Italian:
      "Inserisci un IMEI valido per visualizzare in anteprima l'immagine.",
  },
  {
    FIELD1: "add_device.main.name_tooltip",
    English:
      "This is a friendly name of your choice, to help you identify your tracker.",
    French:
      "Il s'agit d'un nom amical de votre choix, pour vous aider à identifier votre traceur.",
    German:
      "Dies ist ein freundlicher Name Ihrer Wahl, mit dem Sie Ihren Tracker identifizieren können.",
    Spanish:
      "Se trata de un nombre amigable de su elección, para ayudarle a identificar su rastreador.",
    Italian:
      "Si tratta di un nome amichevole scelto da te, per aiutarti a identificare il tuo dispositivo.",
  },
  {
    FIELD1: "add_device.main.coverage_plan",
    English: "Coverage Plan",
    French: "Forfait de couverture",
    German: "Abdeckungsplan",
    Spanish: "Plan de cobertura",
    Italian: "Piano di copertura",
  },
  {
    FIELD1: "add_device.main.option1",
    English: "Enter a valid Tracker IMEI...",
    French: "Saisir un IMEI valide pour le traceur...",
    German: "Geben Sie eine gültige Tracker IMEI ein...",
    Spanish: "Introduzca un IMEI de rastreador válido...",
    Italian: "Inserire un IMEI valido per il dispositivo...",
  },
  {
    FIELD1: "add_device.main.option2",
    English: "Select a Coverage Plan",
    French: "Sélectionner un forfait de couverture",
    German: "Wählen Sie einen Abdeckungsplan aus...",
    Spanish: "Seleccione un plan de cobertura",
    Italian: "Seleziona un piano di copertura",
  },
  {
    FIELD1: "add_device.main.learn_more",
    English: "Want to learn more about coverage zones?",
    French: "Vous voulez en savoir plus sur les zones de couverture ?",
    German: "Wollen Sie mehr über die Abdeckungszonen lernen?",
    Spanish: "¿Quieres saber más sobre las zonas de cobertura?",
    Italian: "Vuoi scoprire di più sulle zone di copertura?",
  },
  {
    FIELD1: "add_device.main.map",
    English: "Map",
    French: "Carte",
    German: "Karte",
    Spanish: "Mapa",
    Italian: "Mappa",
  },
  {
    FIELD1: "add_device.main.countries",
    English: "Countries",
    French: "Pays",
    German: "Länder",
    Spanish: "Países",
    Italian: "Paesi",
  },
  {
    FIELD1: "add_device.main.enter_imei",
    English: "Enter a valid Tracker IMEI...",
    French: "Saisir un IMEI valide pour le traceur...",
    German: "Geben Sie eine gültige Tracker IMEI ein...",
    Spanish: "Introduzca un IMEI de rastreador válido...",
    Italian: "Inserisci un IMEI valido per il dispositivo...",
  },
  {
    FIELD1: "add_device.main.select_plan",
    English: "Select a Coverage Plan",
    French: "Sélectionner un forfait de couverture",
    German: "Wählen Sie einen Abdeckungsplan aus...",
    Spanish: "Seleccione un plan de cobertura",
    Italian: "Seleziona un piano di copertura",
  },
  {
    FIELD1: "add_device.plans.track1",
    English: "/ Tracker / Month",
    French: "/ Traceur / Mois",
    German: "/ Tracker / Monat",
    Spanish: "/ Rastreador / Mes",
    Italian: "/localizzatore / Mese",
  },
  {
    FIELD1: "add_device.plans.billed_monthly",
    English: "automatically billed Monthly",
    French: "automatiquement facturé au mois",
    German: "automatisch monatlich abgerechnet",
    Spanish: "facturado automáticamente mensualmente",
    Italian: "fatturazione automatica mensile",
  },
  {
    FIELD1: "add_device.plans.billed_quarterly",
    English: "automatically billed Quarterly",
    French: "automatiquement facturé trimestriellement",
    German: "automatisch vierteljährlich abgerechnet",
    Spanish: "facturado automáticamente trimestralmente",
    Italian: "fatturazione automatica trimestrale",
  },
  {
    FIELD1: "add_device.plans.billed_annually",
    English: "automatically billed Annually",
    French: "automatiquement facturé annuellement",
    German: "automatisch jährlich abgerechnet",
    Spanish: "facturado automáticamente anualmente",
    Italian: "fatturazione automatica annuale",
  },
  {
    FIELD1: "add_device.plans.title",
    English: "Select a Billing Cycle",
    French: "Sélectionnez un cycle de facturation",
    German: "Wählen Sie einen Abrechnungszyklus",
    Spanish: "Seleccione un ciclo de facturación",
    Italian: "Seleziona un ciclo di fatturazione",
  },
  {
    FIELD1: "add_device.plans.monthly",
    English: "1 Month",
    French: "1 Mois",
    German: "1 Monat",
    Spanish: "1 Mes",
    Italian: "1 Month",
  },
  {
    FIELD1: "add_device.plans.per_month",
    English: "per month",
    French: "per mois",
    German: "per monat",
    Spanish: "per mes",
    Italian: "per month",
  },
  {
    FIELD1: "add_device.plans.per_year",
    English: "per year",
    French: "par an",
    German: "pro Jahr",
    Spanish: "por año",
    Italian: "all'anno",
  },
  {
    FIELD1: "add_device.plans.billed_at",
    English: "Billed at",
    French: "Facturé à",
    German: "In Rechnung gestellt an",
    Spanish: "Facturado a",
    Italian: "Fatturato a",
  },
  {
    FIELD1: "add_device.plans.new_price",
    English: "New price",
    French: "Nouveau prix",
    German: "Neuer Preis",
    Spanish: "Nuevo precio",
    Italian: "Nuovo prezzo",
  },
  {
    FIELD1: "add_device.plans.feature_1",
    English: "Live GPS Tracking – See your pet’s location in real-time",
    French:
      "Suivi GPS en direct – Voir l'emplacement de votre animal en temps réel",
    German:
      "Live GPS-Tracking – Sehen Sie den Standort Ihres Haustieres in Echtzeit",
    Spanish:
      "Seguimiento GPS en vivo – Ver la ubicación de tu mascota en tiempo real",
    Italian:
      "Monitoraggio GPS in tempo reale – Vedi la posizione del tuo animale domestico in tempo reale",
  },
  {
    FIELD1: "add_device.plans.feature_2",
    English: "Unlimited Range with included SIM",
    French: "Portée illimitée avec SIM incluse",
    German: "Unbegrenzte Reichweite mit inkludierter SIM",
    Spanish: "Alcance ilimitado con SIM incluida",
    Italian: "Raggio illimitato con SIM inclusa",
  },
  {
    FIELD1: "add_device.plans.feature_3",
    English: "Activity and sleep monitoring",
    French: "Surveillance de l'activité et du sommeil",
    German: "Aktivitäts- und Schlafüberwachung",
    Spanish: "Monitoreo de actividad y sueño",
    Italian: "Monitoraggio dell'attività e del sonno",
  },
  {
    FIELD1: "add_device.plans.feature_5",
    English: "Family Sharing as Standard",
    French: "Partage familial comme standard",
    German: "Familienfreigabe als Standard",
    Spanish: "Uso compartido familiar como estándar",
    Italian: "Condivisione familiare come standard",
  },
  {
    FIELD1: "add_device.plans.feature_6",
    English: "Coverage in 107 Countries",
    French: "Couverture dans 107 pays",
    German: "Abdeckung in 107 Ländern",
    Spanish: "Cobertura en 107 países",
    Italian: "Copertura in 107 paesi",
  },
  {
    FIELD1: "add_device.plans.feature_4",
    English: "365 Days location History",
    French: "Historique des emplacements 365 jours",
    German: "365 Tage Standortverlauf",
    Spanish: "Historial de ubicaciones de 365 días",
    Italian: "Cronologia delle posizioni di 365 giorni",
  },
  {
    FIELD1: "add_device.plans.feature_7",
    English: "Multiple Virtual Fences",
    French: "Clôtures Virtuelles Multiples",
    German: "Mehrere virtuelle Zäune",
    Spanish: "Cercas Virtuales Múltiples",
    Italian: "Recinzioni Virtuali Multiple",
  },
  {
    FIELD1: "add_device.plans.pro_title",
    English: "Why choose our pro plan?",
    French: "Pourquoi choisir notre plan pro ?",
    German: "Warum unseren Pro-Plan wählen?",
    Spanish: "¿Por qué elegir nuestro plan pro?",
    Italian: "Perché scegliere il nostro piano pro?",
  },
  {
    FIELD1: "add_device.plans.pro_feature_1",
    English: "Colla Care",
    French: "Colla Care",
    German: "Colla Care",
    Spanish: "Colla Care",
    Italian: "Colla Care",
  },
  {
    FIELD1: "add_device.plans.pro_feature_1_text",
    English: "Lifetime warranty for your tracker",
    French: "Garantie à vie pour votre traceur",
    German: "Lebenslange Garantie für Ihren Tracker",
    Spanish: "Garantía de por vida para su rastreador",
    Italian: "Garanzia a vita per il tuo tracker",
  },
  {
    FIELD1: "add_device.plans.pro_feature_2",
    English: "Worldwide coverage",
    French: "Couverture mondiale",
    German: "Weltweite Abdeckung",
    Spanish: "Cobertura mundial",
    Italian: "Copertura mondiale",
  },
  {
    FIELD1: "add_device.plans.pro_feature_2_text",
    English: "See full list",
    French: "Voir la liste complète",
    German: "Vollständige Liste ansehen",
    Spanish: "Ver la lista completa",
    Italian: "Visualizza l'elenco completo",
  },
  {
    FIELD1: "add_device.plans.pro_feature_3",
    English: "Connect to 2x as many 4G networks",
    French: "Connectez-vous à 2 fois plus de réseaux 4G",
    German: "Verbinden Sie sich mit 2x so vielen 4G-Netzwerken",
    Spanish: "Conéctese a 2 veces más redes 4G",
    Italian: "Collegati a 2 volte più reti 4G",
  },
  {
    FIELD1: "add_device.plans.pro_feature_4",
    English: "Family sharing",
    French: "Partage familial",
    German: "Familienfreigabe",
    Spanish: "Compartir en familia",
    Italian: "Condivisione in famiglia",
  },
  {
    FIELD1: "add_device.plans.charged_monthly",
    English: "Automatically charged Monthly",
    French: "Prélèvement automatique mensuel",
    German: "Automatisch monatlich abgebucht",
    Spanish: "Facturación automática mensual",
    Italian: "Automatically charged Monthly",
  },
  {
    FIELD1: "add_device.plans.best_value",
    English: "Best Value",
    French: "Meilleure offre",
    German: "Bester Wert",
    Spanish: "Mejor precio",
    Italian: "Miglior offerta",
  },
  {
    FIELD1: "add_device.plans.best_value_quarterly",
    English: " off",
    French: " de réduction",
    German: " Rabatt",
    Spanish: " de descuento",
    Italian: "Sconto del 5%",
  },
  {
    FIELD1: "add_device.plans.annually",
    English: "1 Year",
    French: "1 An",
    German: "1 Jahr",
    Spanish: "1 Año",
    Italian: "1 Year",
  },
  {
    FIELD1: "add_device.plans.charged_annually",
    English: "Automatically charged Annually",
    French: "Prélèvement automatique annuel",
    German: "wird jährlich abgebucht",
    Spanish: "Facturación automática anual",
    Italian: "Automaticamente addebitato mensilmente",
  },
  {
    FIELD1: "add_device.plans.quarterly",
    English: "3 Months",
    French: "3 mois",
    German: "3 Monate",
    Spanish: "3 meses",
    Italian: "3 Mesi",
  },
  {
    FIELD1: "add_device.plans.charged_quarterly",
    English: "Automatically charged every 3 Months",
    French: "Recharge automatique tous les 3 mois",
    German: "Wird automatisch alle 3 Monate geändert",
    Spanish: "Facturación automática cada 3 meses",
    Italian: "Automaticamente addebitato ogni 3 mesi",
  },
  {
    FIELD1: "add_device.plans.trial",
    English: "7 Day Free Trial",
    French: "7 jours d'essai gratuit",
    German: "7 Tage kostenlose Testversion",
    Spanish: "7 días de prueba gratuita",
    Italian: "7 giorni di prova gratuita",
  },
  {
    FIELD1: "add_device.plan_type.title",
    English: "Plan",
    French: "Plan",
    German: "Plan",
    Spanish: "Plan",
    Italian: "Piano",
  },
  {
    FIELD1: "add_device.plan_type.pro",
    English: "Pro",
    French: "Pro",
    German: "Pro",
    Spanish: "Pro",
    Italian: "Pro",
  },
  {
    FIELD1: "add_device.plan_type.basic",
    English: "Basic",
    French: "De base",
    German: "Grundlegend",
    Spanish: "Básico",
    Italian: "Base",
  },
  {
    FIELD1: "add_device.plan_type.basic_unavailable",
    English:
      'According to your registration information, your country is only included on the Pro plan\'s coverage. If you think this is an error, please contact us using the "Help" widget.',
    French:
      "Selon les informations de votre inscription, votre pays est uniquement inclus dans le plan Pro. Si vous pensez qu'il s'agit d'une erreur, veuillez nous contacter en utilisant le widget \"Aide\".",
    German:
      'Laut Ihren Registrierungsinformationen ist Ihr Land nur im Pro-Plan enthalten. Wenn Sie der Meinung sind, dass dies ein Fehler ist, kontaktieren Sie uns bitte über das "Hilfe"-Widget.',
    Spanish:
      'Según la información de su registro, su país solo está incluido en el plan Pro. Si cree que se trata de un error, contáctenos utilizando el widget "Ayuda".',
    Italian:
      'Secondo le informazioni di registrazione, il tuo paese è incluso solo nel piano Pro. Se ritieni che si tratti di un errore, contattaci utilizzando il widget "Aiuto".',
  },
  {
    FIELD1: "add_device.plan_type.downgrade_error",
    English:
      "If you would like to downgrade your plan, please cancel it at the end of the cycle and reactivate on your desired plan.",
    French:
      "Si vous souhaitez rétrograder votre plan, veuillez l'annuler à la fin du cycle et le réactiver sur votre plan souhaité.",
    German:
      "Wenn Sie Ihren Plan downgraden möchten, kündigen Sie ihn bitte am Ende des Zyklus und reaktivieren Sie ihn auf Ihrem gewünschten Plan.",
    Spanish:
      "Si desea degradar su plan, cancele al final del ciclo y vuelva a activarlo en el plan deseado.",
    Italian:
      "Se desideri eseguire il downgrade del tuo piano, annullalo alla fine del ciclo e riattivalo sul piano desiderato.",
  },
  {
    FIELD1: "add_device.main.accept",
    English: "I accept the",
    French: "J’accepte les",
    German: "Ich akzeptiere die ",
    Spanish: "Acepto los",
    Italian: "Accetto i",
  },
  {
    FIELD1: "add_device.main.tos",
    English: "Terms of Service",
    French: "Conditions d'utilisation",
    German: "Nutzungsbestimmungen",
    Spanish: "Términos del Servicio",
    Italian: "Termini e Condizioni",
  },
  {
    FIELD1: "add_device.main.purchase",
    English: "Purchase Subscription",
    French: "Acheter un abonnement",
    German: "Kaur von Abomment",
    Spanish: "Suscripción de compra",
    Italian: "Acquista abbonamento",
  },
  {
    FIELD1: "add_device.main.trial",
    English: "Trial",
    French: "Procès",
    German: "Prozess",
    Spanish: "Juicio",
    Italian: "Processo",
  },
  {
    FIELD1: "add_device.main.monthly",
    English: "Monthly",
    French: "Mensuel",
    German: "Monatlich",
    Spanish: "Mensual",
    Italian: "Mensilmente",
  },
  {
    FIELD1: "add_device.main.quarterly",
    English: "Quarterly",
    French: "Trimestriel",
    German: "Pro Quartal",
    Spanish: "Trimestral",
    Italian: "Trimestralmente",
  },
  {
    FIELD1: "add_device.main.yearly",
    English: "Yearly",
    French: "Annuel",
    German: "Jährlich",
    Spanish: "Anual",
    Italian: "Annuale",
  },
  {
    FIELD1: "navigation.main.home",
    English: "Home",
    French: "Page d'accueil",
    German: "Home",
    Spanish: "Inicio",
    Italian: "Home",
  },
  {
    FIELD1: "navigation.main.shop",
    English: "Shop",
    French: "Boutique",
    German: "Shop",
    Spanish: "Tienda",
    Italian: "Negozio",
  },
  {
    FIELD1: "navigation.main.shop_trackers",
    English: "Shop Trackers",
    French: "Acheter traceurs",
    German: "Shop Tracker",
    Spanish: "Comprar rastreadores",
    Italian: "Acquista dispositivi",
  },
  {
    FIELD1: "navigation.main.wired",
    English: "Wired Vehicle Trackers",
    French: "Traceur de véhicule filaire",
    German: "Fahrzeug-Tracker mit Kabel",
    Spanish: "Seguimiento de vehículos cableados",
    Italian: "Localizzatore di veicoli cablato",
  },
  {
    FIELD1: "navigation.main.asset",
    English: "Asset Tracking",
    French: "Suivi des actifs",
    German: "Asset-Verfolgung",
    Spanish: "Seguimiento de activos",
    Italian: "Tracciamento delle attività",
  },
  {
    FIELD1: "navigation.main.wireless",
    English: "Wireless Vehicle Trackers",
    French: "Traceur de véhicule sans fil",
    German: "Kabelloser Fahrzeug-Tracker",
    Spanish: "Rastreador de vehículos inalámbrico",
    Italian: "Tracker wireless per veicoli",
  },
  {
    FIELD1: "navigation.main.catalogue",
    English: "Tracker Catalogue",
    French: "Catalogue des traceurs",
    German: "Tracker Katalog",
    Spanish: "Catálogo Tracker",
    Italian: "Catalogo del dispositivo",
  },
  {
    FIELD1: "navigation.main.wired_mobile",
    English: "Wired Vehicle Trackers",
    French: "Traceur de véhicule filaire",
    German: "Fahrzeug-Tracker mit Kabel",
    Spanish: "Seguimiento de vehículos cableados",
    Italian: "Localizzatore di veicoli cablato",
  },
  {
    FIELD1: "navigation.main.wireless_mobile",
    English: "Wireless Vehicle Trackers",
    French: "Traceur de véhicule sans fil",
    German: "Kabelloser Fahrzeug-Tracker",
    Spanish: "Rastreador de vehículos inalámbrico",
    Italian: "Tracker wireless per veicoli",
  },
  {
    FIELD1: "navigation.main.our_app",
    English: "Our App",
    French: "Notre application",
    German: "Unsere App",
    Spanish: "Nuestra Aplicación",
    Italian: "La nostra app",
  },
  {
    FIELD1: "navigation.main.plans",
    English: "Plans",
    French: "Plans d'abonnement",
    German: "Pläne",
    Spanish: "Planes",
    Italian: "Piani",
  },
  {
    FIELD1: "navigation.main.b2b",
    English: "For Business",
    French: "Pour les entreprises",
    German: "Für Unternehmen",
    Spanish: "Para Empresas",
    Italian: "Per le aziende",
  },
  {
    FIELD1: "navigation.main.support",
    English: "Support",
    French: "Soutien",
    German: "Unterstützung",
    Spanish: "Soporte",
    Italian: "Supporto",
  },
  {
    FIELD1: "navigation.main.login",
    English: "Login",
    French: "Connexion",
    German: "Anmelden",
    Spanish: "Iniciar sesión",
    Italian: "Login",
  },
  {
    FIELD1: "navigation.main.register",
    English: "Register",
    French: "S’enregistrer",
    German: "Registrieren",
    Spanish: "Registro",
    Italian: "Registrazione",
  },
  {
    FIELD1: "navigation.main.devices",
    English: "My Trackers",
    French: "Mes traceurs",
    German: "Meine Tracker",
    Spanish: "Mis Seguidores",
    Italian: "I Miei Dispositivi",
  },
  {
    FIELD1: "navigation.main.add_tracker",
    English: "Add Trackers",
    French: "Ajouter des traceurs",
    German: "Tracker hinzufügen",
    Spanish: "Añadir seguidores",
    Italian: "Aggiungi dispositivi",
  },
  {
    FIELD1: "navigation.main.account",
    English: "Account Settings",
    French: "Compte",
    German: "Konto",
    Spanish: "Cuenta",
    Italian: "Account",
  },
  {
    FIELD1: "navigation.main.logout",
    English: "Logout",
    French: "Déconnexion",
    German: "Logout",
    Spanish: "Cerrar sesión",
    Italian: "Esci",
  },
  {
    FIELD1: "navigation.main.tracking",
    English: "Tracking",
    French: "Localisation",
    German: "Verfolgen",
    Spanish: "Seguimiento de",
    Italian: "Tracciamento",
  },
  {
    FIELD1: "navigation.main.live",
    English: "Live View",
    French: "Visualisation en direct",
    German: "Live verfolgen",
    Spanish: "Vista en directo",
    Italian: "In diretta",
  },
  {
    FIELD1: "navigation.main.history",
    English: "History",
    French: "Historique",
    German: "Verlauf",
    Spanish: "Historial",
    Italian: "Cronologia",
  },
  {
    FIELD1: "navigation.main.dashboard",
    English: "Dashboard",
    French: "Tableau de bord",
    German: "Armaturenbrett",
    Spanish: "Panel",
    Italian: "Pannello di controllo",
  },
  {
    FIELD1: "navigation.main.geofences",
    English: "Geofences",
    French: "Géofences",
    German: "Geofences",
    Spanish: "Geocercas",
    Italian: "Geofence",
  },
  {
    FIELD1: "navigation.main.manage",
    English: "Manage collas",
    French: "Gérer",
    German: "Verwalten ",
    Spanish: "Gestionar",
    Italian: "Gestisci",
  },
  {
    FIELD1: "navigation.main.referral",
    English: "Referral Program",
    French: "Programme de Parrainage",
    German: "Empfehlungsprogramm",
    Spanish: "Programa de Referidos",
    Italian: "Programma di Referral",
  },
  {
    FIELD1: "navigation.main.activate",
    English: "Activate colla",
    French: "Activer la collaboration",
    German: "Zusammenarbeit aktivieren",
    Spanish: "Activar la colaboración",
    Italian: "Attivare la collaborazione",
  },
  {
    FIELD1: "my_devices.helmet.title",
    English: "Manage collas",
    French: "Gérer les collisions",
    German: "Kollisionen verwalten",
    Spanish: "Gestionar colisiones",
    Italian: "Gestire le collisioni",
  },
  {
    FIELD1: "my_devices.helmet.desc",
    English: "Manage your furry friend's trackers",
    French: "Gérez les traqueurs de votre ami à fourrure",
    German: "Verwalten Sie die Tracker Ihres pelzigen Freundes",
    Spanish: "Administra los rastreadores de tu amigo peludo",
    Italian: "Gestisci i tracker del tuo amico peloso",
  },
  {
    FIELD1: "my_devices.error.general",
    English: "Something went wrong, please try again later.",
    French: "Un problème s'est produit, veuillez réessayer plus tard.",
    German:
      "Etwas ist schief gelaufen, bitte versuchen Sie es später noch einmal.",
    Spanish: "Algo salió mal, inténtelo de nuevo más tarde.",
    Italian: "Qualcosa è andato storto. Riprovare più tardi.",
  },
  {
    FIELD1: "my_devices.battery.unavailable",
    English: "Unavailable",
    French: "Non disponible",
    German: "Nicht verfügbar",
    Spanish: "No disponible",
    Italian: "Non disponibile",
  },
  {
    FIELD1: "my_devices.battery.none",
    English: "None (0%)",
    French: "Aucune (0%)",
    German: "Gar nicht (0%)",
    Spanish: "Ninguno (0%)",
    Italian: "Assente (0%)",
  },
  {
    FIELD1: "my_devices.battery.ext_low",
    English: "Extremely Low (1-15%)",
    French: "Extrêmement Faible (1-15%)",
    German: "Extrem niedrig (1-15%)",
    Spanish: "Extremadamente bajo (1-15%)",
    Italian: "Estremamente bassa (1-15%)",
  },
  {
    FIELD1: "my_devices.battery.very_low",
    English: "Very Low (16-30%)",
    French: "Très Faible (16-30%)",
    German: "Sehr niedrig ( 16-30%)",
    Spanish: "Muy bajo (16-30%)",
    Italian: "Molto bassa (16-30%)",
  },
  {
    FIELD1: "my_devices.battery.low",
    English: "Low (31-45%)",
    French: "Faible (31-45%)",
    German: "Niedrig (31-45%)",
    Spanish: "Bajo (31-45%)",
    Italian: "Bassa (31-45%)",
  },
  {
    FIELD1: "my_devices.battery.medium",
    English: "Medium (46-60%)",
    French: "Moyenne (46-60 %)",
    German: "Mittel (46-60%)",
    Spanish: "Medio (46-60%)",
    Italian: "Media (46-60%)",
  },
  {
    FIELD1: "my_devices.battery.high",
    English: "High (61-75%)",
    French: "Élevée (61-75%)",
    German: "Hoch (61-75%)",
    Spanish: "Alto (61-75%)",
    Italian: "Alta (61-75%)",
  },
  {
    FIELD1: "my_devices.battery.very_high",
    English: "Very High (76-100%)",
    French: "Très élevée (76-100%)",
    German: "Sehr hoch (76%-100%)",
    Spanish: "Muy Alto (76-100%)",
    Italian: "Molto Alta (76-100%)",
  },
  {
    FIELD1: "my_devices.error.not_found",
    English: "This Tracker ID could not be found.",
    French: "Ce numéro de traceur n'a pas pu être trouvé.",
    German: "Diese Tracker ID konnte nicht gefunden werden. ",
    Spanish: "No se pudo encontrar este ID de rastreador.",
    Italian: "Non è stato possibile trovare l'ID di questo dispositivo.",
  },
  {
    FIELD1: "my_devices.error.cancellation",
    English:
      "Your subscription cancellation was not successful, please contact support.",
    French:
      "L'annulation de votre abonnement n'a pas abouti, veuillez contacter le service support.",
    German:
      "Ihre Abooment Künidiguung war nicht erfolgreich, bitte kontaktieren Sie den Support.",
    Spanish:
      "La cancelación de su suscripción no se realizó correctamente, comuníquese con soporte.",
    Italian:
      "La cancellazione dell'abbonamento non è andata a buon fine, si prega di contattare l'assistenza.",
  },
  {
    FIELD1: "my_devices.main.title",
    English: "My collas",
    French: "Mes collas",
    German: "Meine collas",
    Spanish: "Mis collas",
    Italian: "I Miei collas",
  },
  {
    FIELD1: "my_devices.main.subheading",
    English: "Manage and track your furry friends",
    French: "Gérez et suivez vos amis à fourrure",
    German: "Verwalten und verfolgen Sie Ihre pelzigen Freunde",
    Spanish: "Administra y rastrea a tus amigos peludos",
    Italian: "Gestisci e monitora i tuoi amici pelosi",
  },
  {
    FIELD1: "my_devices.main.subscription",
    English: "Subscription",
    French: "Abonnement",
    German: "Abonnement",
    Spanish: "Suscripción",
    Italian: "Abbonamento",
  },
  {
    FIELD1: "my_devices.main.no_trackers",
    English:
      "It looks like you don’t have any trackers associated with your account. <br /> Please press “Activate Tracker” at the top of the page to get started.",
    French:
      "Il semble que vous n'ayez pas de traceurs associés à votre compte. <br /> Veuillez appuyer sur “Activer le traceur” en haut de la page pour commencer.",
    German:
      'Es sieht so aus, als hätten Sie noch keine Tracker mit Ihrem Konto verknüpft. <br /> Bitte klicken Sie oben auf der Seite auf "Tracker aktivieren", um zu beginnen.',
    Spanish:
      'Parece que no tiene rastreadores asociados con su cuenta. Por favor, presione "Activar rastreador" en la parte superior de la página para comenzar.',
    Italian:
      'Sembra che non ci siano localizzatori associati al tuo account. <br /> Per iniziare, premere "Attiva il tracker" nella parte superiore della pagina.',
  },
  {
    FIELD1: "my_devices.button.add",
    English: "Activate your colla",
    French: "Activez votre colla",
    German: "Aktivieren Sie Ihre Colla",
    Spanish: "Active su colla",
    Italian: "Attiva la tua colla",
  },
  {
    FIELD1: "my_devices.button.email_support",
    English: "Email Support",
    French: "Support par e-mail",
    German: "E-Mail Support",
    Spanish: "Soporte por correo electrónico",
    Italian: "Email Support",
  },
  {
    FIELD1: "my_devices.button.contact_support",
    English: "Contact Support now",
    French: "Contactez le support maintenant",
    German: "Kontaktieren Sie jetzt den Support",
    Spanish: "Contacte con el soporte ahora",
    Italian: "Contatta il supporto ora",
  },
  {
    FIELD1: "my_devices.desc.email_support",
    English:
      "If you are having an issue with your tracker, please reach out to our dedicated support team, who will be happy to help you within 12 hours.",
    French:
      "Si vous rencontrez un problème avec votre traceur, veuillez joindre notre équpe d'assistance dédiée, qui se fera un plaisir de vous aider dans un délai de 12 heures.",
    German:
      "Falls du ein Problem mit deinem Tracker hast, kontaktier3 unser Team, es wird dir innerhalb von 12 Stunden antworten.",
    Spanish:
      "Si tiene algún problema con su rastreador, póngase en contacto con nuestro equipo de soporte, que estará encantado de ayudarle en un plazo de 12 horas.",
    Italian:
      "Se stai riscontrando un problema con il tuo dispositivo, contatta il nostro team di supporto dedicato, che sarà lieto di aiutarti entro 12 ore.",
  },
  {
    FIELD1: "my_devices.main.deactivated",
    English: "Deactivated",
    French: "Désactivé",
    German: "Wurde deaktiviert.",
    Spanish: "Desactivado",
    Italian: "Disattivato",
  },
  {
    FIELD1: "my_devices.main.awaiting_calibration",
    English: "Uncalibrated",
    French: "Non calibré",
    German: "Unkalibriert",
    Spanish: "Descalibrado",
    Italian: "Non calibrato",
  },
  {
    FIELD1: "my_devices.main.unavailable",
    English: "Unavailable",
    French: "Non disponible",
    German: "Nicht verfügbar",
    Spanish: "No disponible",
    Italian: "Non disponibile",
  },
  {
    FIELD1: "my_devices.subs.trial",
    English: "Trialing",
    French: "Essai",
    German: "Erproben",
    Spanish: "Probando",
    Italian: "In prova",
  },
  {
    FIELD1: "my_devices.subs.active",
    English: "Active",
    French: "Actif",
    German: "Aktiv",
    Spanish: "Activo",
    Italian: "Attivo",
  },
  {
    FIELD1: "my_devices.subs.registered",
    English: "Registered",
    French: "Enregistré",
    German: "Registiert",
    Spanish: "Registrado",
    Italian: "Registrato",
  },
  {
    FIELD1: "my_devices.subs.failed",
    English: "Payment Failed",
    French: "Échec du paiement",
    German: "Die Zahlung ist fehlgeschlagen",
    Spanish: "Pago fallido",
    Italian: "Pagamento non riuscito",
  },
  {
    FIELD1: "my_devices.subs.overdue",
    English: "Overdue",
    French: "En retard",
    German: "Fällig",
    Spanish: "Atrasado",
    Italian: "In ritardo",
  },
  {
    FIELD1: "my_devices.subs.incomplete",
    English: "Incomplete Payment",
    French: "Paiement incomplet",
    German: "Nicht beendete Zahlung",
    Spanish: "Pago incompleto",
    Italian: "Pagamento incompleto",
  },
  {
    FIELD1: "my_devices.subs.cancelled",
    English: "Cancelled",
    French: "Annulé",
    German: "Gekündigt",
    Spanish: "Cancelado",
    Italian: "Cancellato",
  },
  {
    FIELD1: "my_devices.update.dismiss",
    English: "Don't alert me about late payments again.",
    French: "Ne m'alertez pas encore au sujet des derniers paiement",
    German: "Alarmieren Sie mich nicht mehr wegen verspäteter Zahlungen.",
    Spanish: "No me avisen sobre retrasos en los pagos otra vez.",
    Italian: "Non avvisatemi più dei ritardi nei pagamenti.",
  },
  {
    FIELD1: "my_devices.button.cancel",
    English: "Cancel",
    French: "Annuler",
    German: "Kündigen",
    Spanish: "Cancelar",
    Italian: "Cancella",
  },
  {
    FIELD1: "my_devices.button.manage",
    English: "Upgrade Plan",
    French: "Gérer l'abonnement",
    German: "Abonnement verwalten",
    Spanish: "Gestionar plan",
    Italian: "Gestisci piano",
  },
  {
    FIELD1: "my_devices.button.complete",
    English: "Complete",
    French: "Complet",
    German: "Vollständig",
    Spanish: "Completar",
    Italian: "Completa",
  },
  {
    FIELD1: "my_devices.button.activate",
    English: "Activate",
    French: "Activer",
    German: "Aktivieren",
    Spanish: "Activar",
    Italian: "Attiva",
  },
  {
    FIELD1: "my_devices.button.reactivate",
    English: "Reactivate",
    French: "Réactiver",
    German: "Wieder Aktivieren",
    Spanish: "Reactivar",
    Italian: "Riattiva",
  },
  {
    FIELD1: "my_devices.button.saving",
    English: "Saving...",
    French: "Sauvegarde...",
    German: "Speichern...",
    Spanish: "Guardando...",
    Italian: "Salvando...",
  },
  {
    FIELD1: "my_devices.button.save",
    English: "Save",
    French: "Sauvegarder",
    German: "Speichern",
    Spanish: "Guardar",
    Italian: "Salva",
  },
  {
    FIELD1: "my_devices.button.redirecting",
    English: "Redirecting",
    French: "Redirection",
    German: "Umleitung",
    Spanish: "Redireccionando",
    Italian: "Reindirizzamento",
  },
  {
    FIELD1: "my_devices.button.manage_billing",
    English: "Manage Billing",
    French: "Gérer la facturation",
    German: "Rechnungen verwalten",
    Spanish: "Gestionar facturación",
    Italian: "Gestire la fatturazione",
  },
  {
    FIELD1: "my_devices.button.confirming",
    English: "Confirming",
    French: "Confirmation",
    German: "Bestätigung",
    Spanish: "Confirmando",
    Italian: "In conferma",
  },
  {
    FIELD1: "my_devices.button.confirm",
    English: "Confirm",
    French: "Confirmer",
    German: "bestätigen",
    Spanish: "Confirmar",
    Italian: "Conferma",
  },
  {
    FIELD1: "my_devices.popup.label_tracker",
    English: "Enter Your Tracker's Name",
    French: "Saisir le nom de votre traceur",
    German: "Geben Sie den Namen ihres Trackers ein",
    Spanish: "Introduzca el nombre de su rastreador",
    Italian: "Inserisci il nome del dispositivo",
  },
  {
    FIELD1: "my_devices.popup.placeholder_tracker",
    English: "Tracker Name",
    French: "Nom du traceur",
    German: "Trackername",
    Spanish: "Nombre del rastreador",
    Italian: "Nome del dispositivo",
  },
  {
    FIELD1: "my_devices.popup.payments_failed",
    English:
      "It looks like you have one or more failed subscription payments. Please update your payment method to continue using your tracker(s).",
    French:
      "Il semble qu'une ou plusieurs tentatives de paiement de votre abonnement aient échoué. Veuillez mettre à jour votre méthode de paiement pour continuer à utiliser votre/vos tracker(s).",
    German:
      "Es sieht so aus, als ob Sie eine oder mehrere fehlgeschlagene Abonnementzahlungen haben. Bitte aktualisieren Sie Ihre Zahlungsmethode, um Ihre (n) Tracker weiterhin zu verwenden.",
    Spanish:
      "Parece que ha fallado uno o más pagos de suscripción. Por favor, actualice su método de pago para continuar utilizando su(s) rastreador(es).",
    Italian:
      "Sembra che uno o più pagamenti dell'abbonamento non siano andati a buon fine. Aggiorna il metodo di pagamento per continuare a utilizzare i tracker.",
  },
  {
    FIELD1: "my_devices.popup.remove_tracker",
    English:
      "Would you like to remove this Tracker? This will cancel the associated subscription and remove all related data from your account.",
    French:
      "Souhaitez-vous supprimer ce traceur ? Cela annulera l'abonnement associé et supprimera toutes les données correspondantes de votre base de données.",
    German:
      "Möchten Sie diesen Tracker entfernen? Dadurch wird das zugehörige Abonnement gekündigt und alle zugehörigen Daten aus Ihrem",
    Spanish:
      "¿Desea eliminar este rastreador? Esto cancelará la suscripción asociada y eliminará todos los datos relacionados de su\n             ",
    Italian:
      "Desideri rimuovere questo Dispositivo? In questo modo si annullerà l'abbonamento associato e si rimuoveranno tutti i dati relativi dal tuo",
  },
  {
    FIELD1: "my_devices.popup.cancel_subs",
    English:
      "Would you like to cancel your subscription plan? This will suspend all tracker tracking capabilities and remove all associated data from your account.",
    French:
      "Souhaitez-vous annuler votre abonnement ? Cela suspendra toutes les capacités de localisation des traceurs et supprimera toutes les données associées de votre compte.",
    German:
      "Möchten Sie Ihr Abonnement kündigen? Dadurch werden alle Tracking-Funktionen ausgesetzt und alle zugehörigen Daten aus Ihrem Konto entfernt.",
    Spanish:
      "¿Desea cancelar su plan de suscripción? Esto suspenderá todas las funciones de seguimiento y eliminará todos los datos asociados de su cuenta.",
    Italian:
      "Desideri annullare il tuo abbonamento? Questo sospenderà tutte le funzionalità di tracciamento del dispositivo e rimuoverà tutti i dati associati dal tuo account.",
  },
  {
    FIELD1: "my_devices.button.next",
    English: "Next Bill",
    French: "Prochaine Facture",
    German: "Nächste Rechnung",
    Spanish: "Siguiente factura",
    Italian: "Fattura successiva",
  },
  {
    FIELD1: "my_devices.button.last_bill",
    English: "Cancels on",
    French: "Annule le",
    German: "Kündigt am",
    Spanish: "Cancela el",
    Italian: "Annulla il",
  },
  {
    FIELD1: "my_devices.button.close",
    English: "Close",
    French: "Fermer",
    German: "Schließen",
    Spanish: "Cerrar",
    Italian: "Chiudi",
  },
  {
    FIELD1: "my_devices.submodal.success",
    English: "Success",
    French: "Succès",
    German: "Erfolg",
    Spanish: "Éxito",
    Italian: "Fatto",
  },
  {
    FIELD1: "my_devices.submodal.plan",
    English: "Plan",
    French: "Plan d'abonnement",
    German: "Plan",
    Spanish: "Plan de cobertura",
    Italian: "Piano",
  },
  {
    FIELD1: "my_devices.submodal.coverage_zones",
    English: "Update Coverage Zone",
    French: "Mettre à jour la zone de couverture",
    German: "Abdeckungszone aktualisieren",
    Spanish: "Actualizar zona de cobertura",
    Italian: "Aggiorna la zona di copertura",
  },
  {
    FIELD1: "my_devices.submodal.billing_cycle",
    English: "Update Billing Cycle",
    French: "Mise à jour du cycle de facturation",
    German: "Zahlungszyklen aktualisieren",
    Spanish: "Intervalo de facturación",
    Italian: "Aggiorna il ciclo di fatturazione",
  },
  {
    FIELD1: "my_devices.submodal.new_price",
    English: "New Price",
    French: "Nouveau prix",
    German: "Der neue Preis",
    Spanish: "Nuevo precio",
    Italian: "Prezzo nuovo",
  },
  {
    FIELD1: "my_devices.submodal.new_price_desc",
    English:
      "When you are next billed, any remaining time on your current subscription term will be subtracted.",
    French:
      "Lors de la prochaine facturation, la durée restante de l'abonnement en cours sera déduite.",
    German:
      "Bei der nächsten Abrechnung wird die verbleibende Zeit Ihrer aktuellen Abonnementlaufzeit abgezogen.",
    Spanish:
      "La próxima vez que se le facture, se le restará el tiempo restante del periodo de suscripción actual.",
    Italian:
      "Al momento della prossima fatturazione, verrà sottratto il tempo residuo del periodo di abbonamento in corso.",
  },
  {
    FIELD1: "my_devices.submodal.update_plan",
    English: "Update Plan",
    French: "Mise à jour du plan d'abonnement",
    German: "Den plan aktualisieren",
    Spanish: "Actualizar plan",
    Italian: "Aggiorna il tuo abbonamento",
  },
  {
    FIELD1: "my_devices.submodal.subscription_error",
    English:
      "Sorry, we encountered an error while retrieving your subscription details. Please contact support, who will be glad to help.",
    French:
      "Désolé, nous avons rencontré une erreur lors de la récupération des détails de votre abonnement. Veuillez contacter l’assistance, qui se fera un plaisir de vous aider.",
    German:
      "Beim Abrufen Ihrer Abonnementdetails ist leider ein Fehler aufgetreten. Bitte wenden Sie sich an den Support, der Ihnen gerne weiterhilft.",
    Spanish:
      "Lo sentimos, hemos encontrado un error al recuperar los detalles de su suscripción. Póngase en contacto con el servicio de asistencia, que estará encantado de ayudarle.",
    Italian:
      "Siamo spiacenti, si è verificato un errore durante il recupero dei dati dell'abbonamento. Sei pregato di contattare l'assistenza, che sarà lieta di aiutarti.",
  },
  {
    FIELD1: "my_devices.submodal.submit_error",
    English:
      "Sorry, we encountered an error while updating your subscription details. Please contact support, who will be glad to help.",
    French:
      "Désolé, nous avons rencontré une erreur lors de la mise à jour des détails de votre abonnement. Veuillez contacter l’assistance, qui se fera un plaisir de vous aider.",
    German:
      "Beim Aktualisieren Ihrer Abonnementdetails ist leider ein Fehler aufgetreten. Bitte wenden Sie sich an den Support, der Ihnen gerne weiterhilft.",
    Spanish:
      "Lo sentimos, hemos encontrado un error al actualizar sus datos de suscripción. Póngase en contacto con el servicio de asistencia, que estará encantado de ayudarle.",
    Italian:
      "Spiacenti, si è verificato un errore durante l'aggiornamento dei dati dell'abbonamento. Sei pregato di contattare l'assistenza, che sarà lieta di aiutarti.",
  },
  {
    FIELD1: "my_devices.submodal.billed_monthly",
    English: "Billed Monthly",
    French: "Facturation mensuelle",
    German: "Monatliche Rechnung",
    Spanish: "Facturación mensual",
    Italian: "Fatturato mensilmente",
  },
  {
    FIELD1: "my_devices.submodal.billed_3_months",
    English: "Billed Every 3 Months",
    French: "Facturation tous les 3 mois",
    German: "Alle 3 Monate",
    Spanish: "Facturación trimestral",
    Italian: "Fatturato ogni 3 mesi",
  },
  {
    FIELD1: "my_devices.submodal.billed_yearly",
    English: "Billed Yearly",
    French: "Facturation annuelle",
    German: "Jährliche Rechnung",
    Spanish: "Facturación anual",
    Italian: "Fatturato annualmente",
  },
  {
    FIELD1: "my_devices.submodal.updating",
    English: "Updating",
    French: "Mise à jour",
    German: "Aktualisieren",
    Spanish: "Actualizando",
    Italian: "Aggiornamento",
  },
  {
    FIELD1: "my_devices.cancel_reason.title",
    English: "Please select a cancellation reason",
    French: "Veuillez sélectionner un motif d'annulation",
    German: "Bitte wählen Sie einen Stornierungsgrund",
    Spanish: "Seleccione un motivo de cancelación",
    Italian: "Sei pregato di specificare un motivo di cancellazione",
  },
  {
    FIELD1: "my_devices.cancel_reason.too_expensive",
    English: "It’s too expensive",
    French: "C'est trop cher",
    German: "Es ist zu teuer",
    Spanish: "Es demasiado caro",
    Italian: "È troppo costoso",
  },
  {
    FIELD1: "my_devices.cancel_reason.missing_features",
    English: "Some features are missing",
    French: "Certaines fonctionnalités sont manquantes",
    German: "Es fehlen einige Funktionen",
    Spanish: "Faltan algunas funciones",
    Italian: "Mancano alcune funzioni",
  },
  {
    FIELD1: "my_devices.cancel_reason.switched_service",
    English: "I’m switching to a different service",
    French: "Je change de service",
    German: "Ich wechsle zu einem anderen Dienst",
    Spanish: "Cambiaré de proveedor de servicio.",
    Italian: "Sto passando a un altro servizio",
  },
  {
    FIELD1: "my_devices.cancel_reason.unused",
    English: "I don’t use the service enough",
    French: "Je n'utilise pas suffisamment le service",
    German: "Ich nutze den Service nicht genug",
    Spanish: "No utilizo el servicio lo suficiente",
    Italian: "Non uso il servizio a sufficienza",
  },
  {
    FIELD1: "my_devices.cancel_reason.customer_service",
    English: "Customer service was less than expected",
    French: "Le service clientèle n'a pas été à la hauteur des attentes",
    German: "Der Kundenservice war weniger als erwartet",
    Spanish: "El nivel de atención al cliente es inferior al esperado",
    Italian: "Il servizio clienti ha deluso le mie aspettative",
  },
  {
    FIELD1: "my_devices.cancel_reason.too_complex",
    English: "Ease of use was less than expected",
    French: "La facilité d'utilisation n'a pas été à la hauteur des attentes",
    German: "Die Benutzerfreundlichkeit war geringer als erwartet",
    Spanish: "La facilidad de uso es inferior a la esperado",
    Italian: "Mi aspettavo che il servizio fosse più facile da adoperare",
  },
  {
    FIELD1: "my_devices.cancel_reason.low_quality",
    English: "Quality was less than expected",
    French: "La qualité a été inférieure aux attentes",
    German: "Die Qualität war schlechter als erwartet",
    Spanish: "La calidad es inferior a la esperada",
    Italian: "Il servizio, in generale, era di bassa qualità",
  },
  {
    FIELD1: "my_devices.cancel_reason.other",
    English: "Other Reason",
    French: "Autre raison",
    German: "Anderer Grund",
    Spanish: "Otras razones",
    Italian: "Altre ragioni",
  },
  {
    FIELD1: "welcome.main.title",
    English: "Welcome to colla! Please confirm your country and language:",
    French:
      "Bienvenue à colla ! Veuillez confirmer votre pays et votre langue ",
    German:
      "Willkommen bei colla! Bitte bestätigen Sie Ihr Land und Ihre Sprache:",
    Spanish: "Bienvenido a colla Por favor, confirme su país e idioma:",
    Italian: "Benvenuto su colla! Conferma il paese e la lingua:",
  },
  {
    FIELD1: "welcome.main.country",
    English: "Country:",
    French: "Pays:",
    German: "Land:",
    Spanish: "País:",
    Italian: "Paese:",
  },
  {
    FIELD1: "welcome.main.language",
    English: "Language:",
    French: "Langue:",
    German: "Sprache:",
    Spanish: "Idioma:",
    Italian: "Lingua:",
  },
  {
    FIELD1: "welcome.main.button",
    English: "OK!",
    French: "OK!",
    German: "OK!",
    Spanish: "¡OK!",
    Italian: "Ok!",
  },
  {
    FIELD1: "localization.languages.en",
    English: "English",
    French: "Anglais",
    German: "Englisch",
    Spanish: "Inglés",
    Italian: "English",
  },
  {
    FIELD1: "localization.languages.fr",
    English: "French",
    French: "Français",
    German: "Französisch",
    Spanish: "Francés",
    Italian: "French",
  },
  {
    FIELD1: "localization.languages.de",
    English: "German",
    French: "Allemand",
    German: "Deutsch",
    Spanish: "Alemán",
    Italian: "German",
  },
  {
    FIELD1: "localization.languages.es",
    English: "Spanish",
    French: "Espagnol",
    German: "Spanisch",
    Spanish: "Español",
    Italian: "Spanish",
  },
  {
    FIELD1: "localization.languages.it",
    English: "Italian",
    French: "italien",
    German: "italienisch",
    Spanish: "italiano",
    Italian: "italiano",
  },
  {
    FIELD1: "notifications.permission.denied",
    English: "The notification permission is required. Turn on notifications.",
    French:
      "L'autorisation pour les notifications est nécessaire. Activez les notifications.",
    German:
      "Eine Benachrichtigungserlaubnis wird benötigt. Nachrichten anschalten.",
    Spanish:
      "El permiso de notificación es necesario. Active las notificaciones.",
    Italian:
      "L'autorizzazione alle notifiche è necessaria. Attiva le notifiche.",
  },
  {
    FIELD1: "notifications.permission.denied2",
    English:
      "Notification setup failed. Please grant the notification permission. (See the FAQs for guidance)",
    French:
      "Réglage des notifications échoué. Veuillez autoriser les notifications. (Consultez la FAQ pour être guidé)",
    German:
      "Die Nachrichteneinstellung hat nicht funktioniert. Bitte genehmigen die Benachrichtigungserlaubnis.( Siehe die FAGs als Anleitung)",
    Spanish:
      "Error en la configuración de las notificaciones. Por favor, otorgue el permiso de notificaciones. (Consulte las preguntas frecuentes para más información)",
    Italian:
      "Impostazione delle notifiche non riuscita. Si prega di concedere l'autorizzazione alle notifiche. (Accedere alle FAQ per visualizzare una guida)",
  },
  {
    FIELD1: "notifications.enable.success",
    English: "Successfully registered for notifications",
    French: "Inscription aux notifications réussie",
    German: "Nachrichten wurden erfolgreich registriert",
    Spanish: "Registro de notificaciones exitoso",
    Italian: "Registrazione riuscita per le notifiche",
  },
  {
    FIELD1: "notifications.enable.demo",
    English: "This button enables desktop alerts",
    French: "Ce bouton permet d'activer les alertes de bureau",
    German: "Diese Schaltfläche aktiviert Desktop-Benachrichtigungen",
    Spanish: "Este botón activa las alertas de escritorio",
    Italian: "Questo tasto abilita le notifiche sul desktop",
  },
  {
    FIELD1: "notifications.enable.failure",
    English: "Notification registration failed, please contact support.",
    French:
      "Insctiption aux notifications échouée. Veuillez contacter l'assistance.",
    German:
      "Die Anmeldung der Benachrichtungen ist fehlgeschlagen, bitte kontaktiere den Suport.",
    Spanish:
      "El registro de notificaciones ha fallado, por favor póngase en contacto con soporte.",
    Italian:
      "La registrazione della notifica non è riuscita, contattare l'assistenza.",
  },
  {
    FIELD1: "notifications.disable.success",
    English: "Successfully disabled notifications",
    French: "Désactivation des notifications réussie",
    German: "Die Benachrichtigungen wurden erfolgreich deaktiviert",
    Spanish: "Notificaciones desactivadas exitosamente",
    Italian: "Notifiche disattivate con successo",
  },
  {
    FIELD1: "notifications.disable.failure",
    English: "Notification deregistration failed, please contact support.",
    French:
      "Désactivation des notifications échouée. Veuillez contacter l'assistance.",
    German:
      "Die Deaktivierung der Nachrichten hat nicht funktioniert, bitte kontaktiere den Support.",
    Spanish:
      "No se ha podido dar de baja la notificación, póngase en contacto con soporte.",
    Italian:
      "La deregistrazione delle notifiche non è riuscita, contattare l'assistenza.",
  },
  {
    FIELD1: "t('notifications.permission.denied')",
    English: "The notification permission is required. Turn on notifications.",
    French:
      "L'autorisation de notification est nécessaire. Activez les notifications",
    German:
      "Die Benachrichtigungsberechtigung ist erforderlich. Schalten Sie Benachrichtigungen ein.",
    Spanish:
      "Es necesario el permiso de notificaciones. Active las notificaciones.",
    Italian: "The notification permission is required. Turn on notifications.",
  },
  {
    FIELD1: "t('notifications.enable.success')",
    English: "Successfully registered for notifications",
    French: "Enregistrement des notifications réussie",
    German: "Erfolgreich für Benachrichtigungen registriert",
    Spanish: "Registro de notificaciones correcto",
    Italian: "Successfully registered for notifications",
  },
  {
    FIELD1: "t('notifications.enable.failure')",
    English: "Notification registration failed, please contact support.",
    French:
      "Enregistrement des notifications échouée, veuillez contacter le service d'assistance.",
    German:
      "Registrierung der Benachrichtigung fehlgeschlagen, bitte kontaktieren Sie den Support.",
    Spanish:
      "Falló el registro de notificaciones, póngase en contacto con el servicio de asistencia.",
    Italian: "Notification registration failed, please contact support.",
  },
  {
    FIELD1: "t('notifications.disable.success')",
    English: "Successfully disabled notifications",
    French: "Désactivation des notifications réussie",
    German: "Benachrichtigungen erfolgreich deaktiviert",
    Spanish: "Notificaciones desactivadas correctamente",
    Italian: "Successfully disabled notifications",
  },
  {
    FIELD1: "t('notifications.disable.failure')",
    English: "Notification deregistration failed, please contact support.",
    French:
      "Désactivation des notifications échouée, veuillez contacter le service d'assistance.",
    German:
      "Die Deregistrierung der Benachrichtigung ist fehlgeschlagen, bitte kontaktieren Sie den Support.",
    Spanish:
      "No se ha podido dar de baja la notificación, póngase en contacto con el servicio de asistencia.",
    Italian: "Notification deregistration failed, please contact support.",
  },
  {
    FIELD1: "t('notifications.permission.denied2')",
    English:
      "Notification setup failed. Please grant the notification permission. (See the FAQs for guidance)",
    French:
      "Configuration des notifications échouée. Veuillez accorder l'autorisation des notifications. (Consultez la FAQ pour être guidé)",
    German:
      "Einrichtung der Benachrichtigung fehlgeschlagen. Bitte erteilen Sie die Berechtigung zur Benachrichtigung. (Siehe die FAQs für eine Anleitung)",
    Spanish:
      "Error en la configuración de las notificaciones. Por favor, conceda el permiso de notificación. (Consulte las preguntas frecuentes)",
    Italian:
      "Notification setup failed. Please grant the notification permission. (See the FAQs for guidance)",
  },
  {
    FIELD1: "forget_password.main.code_required",
    English: "Confirmation Code is Required",
    French: "Le code de confirmation est requis",
    German: "Bestätigungscode ist erforderlich",
    Spanish: "Se requiere código de confirmación",
    Italian: "Il codice di conferma è obbligatorio",
  },
  {
    FIELD1: "forget_password.main.password_required",
    English: "Password is Required",
    French: "Le mot de passe est requis",
    German: "Passwort ist erforderlich",
    Spanish: "Se requiere contraseña",
    Italian: "La password è obbligatoria",
  },
  {
    FIELD1: "forget_password.main.error_password_complexity",
    English: "Combine upper and lowercase letters and numbers.",
    French:
      "Combinez des lettres majuscules et minuscules ainsi que des chiffres.",
    German: "Kombinieren Sie Groß- und Kleinbuchstaben sowie Zahlen.",
    Spanish: "Combina letras mayúsculas y minúsculas y números.",
    Italian: "Combina lettere maiuscole e minuscole e numeri.",
  },
  {
    FIELD1: "forget_password.main.error_resend_code",
    English: "Verification Code Resent",
    French: "Code de vérification renvoyé",
    German: "Bestätigungscode erneut gesendet",
    Spanish: "Código de verificación reenviado",
    Italian: "Codice di verifica rinviato",
  },
  {
    FIELD1: "forget_password.main.error_resend_code",
    English:
      "Couldn't resend the code, please try again later, then contact support.",
    French:
      "Impossible de renvoyer le code, veuillez réessayer ultérieurement, puis contacter le support.",
    German:
      "Der Code konnte nicht erneut gesendet werden. Bitte versuchen Sie es später erneut und wenden Sie sich dann an den Support.",
    Spanish:
      "No se pudo reenviar el código, por favor inténtelo de nuevo más tarde, luego contacte al soporte.",
    Italian:
      "Impossibile inviare nuovamente il codice, riprova più tardi, quindi contatta il supporto.",
  },
  {
    FIELD1: "add_device.main.step1_title",
    English: "Tracker Details",
    French: "Détails du Tracker",
    German: "Tracker-Details",
    Spanish: "Detalles del rastreador",
    Italian: "Dettagli del tracker",
  },
  {
    FIELD1: "add_device.main.step1_desc",
    English: "Enter your Tracker IMEI and give it a friendly name",
    French: "Entrez votre IMEI de Tracker et donnez-lui un nom convivial",
    German:
      "Geben Sie Ihre Tracker IMEI ein und geben Sie ihm einen freundlichen Namen",
    Spanish: "Ingrese su IMEI de rastreador y asígnele un nombre amigable",
    Italian:
      "Inserisci il tuo IMEI del tracker e assegnagli un nome amichevole",
  },
  {
    FIELD1: "add_device.main.step2_title",
    English: "Choose your plan",
    French: "Choisissez votre plan",
    German: "Wählen Sie Ihren Tarif",
    Spanish: "Elige tu plan",
    Italian: "Scegli il tuo piano",
  },
  {
    FIELD1: "add_device.main.step2_desc",
    English: "Select a coverage zone, and a billing frequency",
    French:
      "Sélectionnez une zone de couverture et une fréquence de facturation",
    German: "Wählen Sie eine Abdeckungszone und eine Abrechnungsfrequenz aus",
    Spanish: "Seleccione una zona de cobertura y una frecuencia de facturación",
    Italian: "Seleziona una zona di copertura e una frequenza di fatturazione",
  },
  {
    FIELD1: "add_device.main.step3_title",
    English: "Confirm your choices",
    French: "Confirmez vos choix",
    German: "Bestätigen Sie Ihre Auswahl",
    Spanish: "Confirma tus elecciones",
    Italian: "Conferma le tue scelte",
  },
  {
    FIELD1: "add_device.main.step3_desc",
    English: "Please check your tracker PIN, name, and billing plan choices",
    French:
      "Veuillez vérifier le nom de votre PIN de tracker et les choix de plan de facturation",
    German:
      "Bitte überprüfen Sie den Namen Ihres Tracker PIN und die Auswahl des Abrechnungsplans",
    Spanish:
      "Por favor, verifique el nombre de su PIN de rastreador y las opciones del plan de facturación",
    Italian:
      "Si prega di verificare il nome del tuo PIN del tracker e le scelte del piano di fatturazione",
  },
  {
    FIELD1: "add_device.button.step_prev",
    English: "Previous",
    French: "précédente",
    German: "Schritt",
    Spanish: "anterior",
    Italian: "precedente",
  },
  {
    FIELD1: "add_device.button.step_next",
    English: "Next",
    French: "suivante",
    German: "Schritt",
    Spanish: "paso",
    Italian: "successivo",
  },
  {
    FIELD1: "add_device.main.refresh_label",
    English: "Refresh Tier",
    French: "Niveau de rafraîchissement",
    German: "Aktualisierungsstufe",
    Spanish: "Nivel de actualización",
    Italian: "Livello di aggiornamento",
  },
  {
    FIELD1: "add_device.main.refresh_desc",
    English: "This is how often your tracker will update its location",
    French:
      "C'est la fréquence à laquelle votre tracker mettra à jour sa position",
    German: "So oft wird Ihr Tracker seinen Standort aktualisieren",
    Spanish:
      "Esta es la frecuencia con la que su rastreador actualizará su ubicación",
    Italian:
      "Questo è quanto spesso il tuo tracker aggiornerà la sua posizione",
  },
  {
    FIELD1: "add_device.main.step3_imei",
    English: "Tracker IMEI",
    French: "IMEI du tracker",
    German: "Tracker IMEI",
    Spanish: "IMEI del rastreador",
    Italian: "IMEI del tracker",
  },
  {
    FIELD1: "add_device.main.step3_name",
    English: "Tracker Name",
    French: "Nom du tracker",
    German: "Tracker-Name",
    Spanish: "Nombre del rastreador",
    Italian: "Nome del tracker",
  },
  {
    FIELD1: "add_device.main.step3_zone",
    English: "Coverage Zone",
    French: "Zone de couverture",
    German: "Abdeckungszone",
    Spanish: "Zona de cobertura",
    Italian: "Zona di copertura",
  },
  {
    FIELD1: "add_device.main.step3_plan",
    English: "Billing Plan",
    French: "Plan de facturation",
    German: "Abrechnungsplan",
    Spanish: "Plan de facturación",
    Italian: "Piano di fatturazione",
  },
  {
    FIELD1: "add_device.main.accept_terms_1",
    English: "By clicking the “Purchase Subscription” button, ",
    French: "En cliquant sur le bouton “Acheter l'abonnement”, ",
    German: "Durch Klicken auf die Schaltfläche „Abonnement kaufen“, ",
    Spanish: "Al hacer clic en el botón “Comprar suscripción”, ",
    Italian: "Cliccando sul pulsante “Acquista abbonamento”, ",
  },
  {
    FIELD1: "add_device.main.accept_terms_2",
    English: "I agree to the Terms of Service",
    French: "J'accepte les conditions d'utilisation",
    German: "Ich stimme den Nutzungsbedingungen zu",
    Spanish: "Acepto los Términos de Servicio",
    Italian: "Accetto i Termini di Servizio",
  },
  {
    FIELD1: "add_device.option.refresh_rate",
    English: "Second Refresh Rate",
    French: "Second Taux de rafraîchissement",
    German: "Sekunde Aktualisierungsrate",
    Spanish: "Segundo nivel de actualización",
    Italian: "Aggiornamento in pochi secondi",
  },
  {
    FIELD1: "add_device.main.step3_refresh",
    English: "Refresh Tier",
    French: "Niveau de rafraîchissement",
    German: "Stufe aktualisieren",
    Spanish: "Nivel de actualización",
    Italian: "Aggiorna il livello",
  },
  {
    FIELD1: "add_device.main.step3_billed_every",
    English: "billed every",
    French: "facturés toutles les",
    German: "wird alle ",
    Spanish: "facturado cada",
    Italian: "fatturati ogni",
  },
  {
    FIELD1: "add_device.main.step2_standard",
    English: "Standard",
    French: "Standard",
    German: "Standard",
    Spanish: "Estándar",
    Italian: "Standard",
  },
  {
    FIELD1: "add_device.main.step2_pro",
    English: "Pro",
    French: "Pro",
    German: "Pro",
    Spanish: "Pro",
    Italian: "Pro",
  },
  {
    FIELD1: "add_device.main.step2_plus",
    English: "Plus",
    French: "Plus",
    German: "Plus",
    Spanish: "Plus",
    Italian: "Plus",
  },
  {
    FIELD1: "add_device.option.refresh_rate_warning",
    English:
      "Please allow 24 hours for this refresh rate upgrade to take effect and ensure your device is online.",
    French:
      "Veuillez prévoir 24 heures pour que cette mise à niveau du taux de rafraîchissement prenne effet et pour vous assurer que votre appareil est en ligne.",
    German:
      "Bitte warten Sie 24 Stunden, bis das Upgrade der Aktualisierungsrate wirksam wird, und stellen Sie sicher, dass Ihr Gerät online ist.",
    Spanish:
      "Por favor, espere 24 horas para que el cambio de frecuencia de actualización surta efecto y asegúrese de que su dispositivo está en línea.",
    Italian:
      "Si consiglia di attendere 24 ore affinché l'aggiornamento della velocità di aggiornamento abbia effetto e di assicurarsi che il dispositivo sia online.",
  },
  {
    FIELD1: "add_device.error.cov",
    English:
      "Please select the coverage zone you would like to use your tracker in.",
    French:
      "Veuillez sélectionner la zone de couverture dans laquelle vous souhaitez utiliser votre traceur.",
    German:
      "Bitte wählen Sie die Abdeckungszone aus, in der Sie Ihren Tracker verwenden möchten.",
    Spanish:
      "Por favor, seleccione la zona de cobertura en la que desea utilizar su rastreador.",
    Italian:
      "Seleziona la zona di copertura nella quale si desidera utilizzare il dispositivo.",
  },
  {
    FIELD1: "my_devices.main.zone_not_found",
    English: "Coverage zone not found. Please contact support to upgrade.",
    French:
      "Zone de couverture introuvable. Veuillez contacter le support pour une mise à niveau.",
    German:
      "Abdeckungsbereich nicht gefunden. Bitte kontaktieren Sie den Support, um ein Upgrade durchzuführen.",
    Spanish:
      "Zona de cobertura no encontrada. Por favor, contacte con soporte para actualizar.",
    Italian:
      "Zona di copertura non trovata. Si prega di contattare il supporto per un aggiornamento.",
  },
  {
    FIELD1: "my_devices.main.empty_image_tip",
    English: "Tip: Use the mobile app to upload your pet’s photo",
    French:
      "Conseil : utilisez l'application mobile pour télécharger la photo de votre animal de compagnie",
    German:
      "Tipp: Verwenden Sie die mobile App, um das Foto Ihres Haustieres hochzuladen",
    Spanish:
      "Consejo: use la aplicación móvil para subir la foto de su mascota",
    Italian:
      "Suggerimento: utilizza l'app mobile per caricare la foto del tuo animale domestico",
  },
  {
    FIELD1: "add_device.main.step3_trail",
    English: "7 day trial, then",
    French: "7 jours d'essai, puis",
    German: "7 Tage testen, dann ",
    Spanish: "Prueba de 7 días, luego",
    Italian: "7 giorni di prova gratuita, poi",
  },
  {
    FIELD1: "add_device.main.step2_pro",
    English: "Pro",
    French: "Pro",
    German: "Pro",
    Spanish: "Pro",
    Italian: "Pro",
  },
  {
    FIELD1: "add_device.main.step2_plus",
    English: "Plus",
    French: "Plus",
    German: "Plus",
    Spanish: "Plus",
    Italian: "Plus",
  },
  {
    FIELD1: "add_device.main.pet_information",
    English: "Pet Information",
    French: "Informations sur l'animal de compagnie",
    German: "Informationen über Haustiere",
    Spanish: "Información sobre mascotas",
    Italian: "Informazioni sugli animali domestici",
  },
  {
    FIELD1: "add_device.main.device_information",
    English: "Device Information",
    French: "Informations sur l'appareil",
    German: "Geräteinformationen",
    Spanish: "Información del dispositivo",
    Italian: "Informazioni sul dispositivo",
  },
  {
    FIELD1: "add_device.main.subsription_plan",
    English: "Subscription Plan",
    French: "Plan d'abonnement",
    German: "Abonnementplan",
    Spanish: "Plan de suscripción",
    Italian: "Piano di abbonamento",
  },
  {
    FIELD1: "add_device.main.basic_plan",
    English: "Basic plan",
    French: "Plan de base",
    German: "Grundplan",
    Spanish: "Plan básico",
    Italian: "Piano base",
  },
  {
    FIELD1: "add_device.main.basic_plan_desc",
    English: "The essential features you need to keep track of your pet",
    French:
      "Les caractéristiques essentielles dont vous avez besoin pour suivre votre animal de compagnie",
    German:
      "Die wesentlichen Funktionen, die Sie benötigen, um Ihr Haustier zu verfolgen",
    Spanish:
      "Las características esenciales que necesitas para seguir a tu mascota",
    Italian:
      "Le caratteristiche essenziali di cui hai bisogno per tenere traccia del tuo animale domestico",
  },
  {
    FIELD1: "add_device.main.pro_plan",
    English: "Pro Plan - All Features",
    French: "Plan Pro - Toutes les Fonctionnalités",
    German: "Pro-Plan - Alle Funktionen",
    Spanish: "Plan Pro - Todas las Características",
    Italian: "Piano Pro - Tutte le Funzionalità",
  },
  {
    FIELD1: "add_device.main.pro_plan_desc",
    English: "Keep your pet healthy & safe, wherever they are",
    French:
      "Gardez votre animal de compagnie en bonne santé et en sécurité, où qu'il soit",
    German:
      "Halten Sie Ihr Haustier gesund und sicher, egal wo es sich befindet",
    Spanish: "Mantén a tu mascota saludable y segura, dondequiera que esté",
    Italian:
      "Mantieni il tuo animale domestico sano e al sicuro, ovunque si trovi",
  },
  {
    FIELD1: "add_device.main.trial",
    English: "Trial",
    French: "Procès",
    German: "Prozess",
    Spanish: "Juicio",
    Italian: "Processo",
  },
  {
    FIELD1: "add_device.main.billing_cycle",
    English: "Billing Cycle",
    French: "Cycle de facturation",
    German: "Abrechnungszyklus",
    Spanish: "Ciclo de facturación",
    Italian: "Ciclo di fatturazione",
  },
  {
    FIELD1: "add_device.main.selected",
    English: "Selected",
    French: "Choisi",
    German: "Ausgewählt",
    Spanish: "Seleccionado",
    Italian: "Selezionato",
  },
  {
    FIELD1: "add_device.main.pet_name",
    English: "Pet Name",
    French: "Nom de l'animal de compagnie",
    German: "Haustiername",
    Spanish: "Nombre de la mascota",
    Italian: "Nome dell'animale domestico",
  },
  {
    FIELD1: "add_device.main.pet_breed",
    English: "Pet Breed",
    French: "Race de chien",
    German: "Hunderasse",
    Spanish: "Raza de perro",
    Italian: "Razza di cane",
  },
  {
    FIELD1: "add_device.main.pet_age",
    English: "Age",
    French: "Age",
    German: "Alter",
    Spanish: "Edad",
    Italian: "Età",
  },
  {
    FIELD1: "add_device.main.checkout",
    English: "Proceed to Checkout",
    French: "Procéder au paiement",
    German: "Zur Kasse gehen",
    Spanish: "Proceder al pago",
    Italian: "Procedere al pagamento",
  },
  {
    FIELD1: "add_device.main.checkout_m",
    English: "Checkout",
    French: "Paiement",
    German: "Kasse",
    Spanish: "Caja",
    Italian: "Cassa",
  },
  {
    FIELD1: "add_device.main.stripe_error",
    English:
      "Something went wrong, please contact our support team who will be able to activate your tracker in a jiffy!",
    French:
      "Quelque chose s'est mal passé, veuillez contacter notre équipe d'assistance qui pourra activer votre tracker en un rien de temps !",
    German:
      "Irgendetwas ist schief gelaufen, bitte kontaktieren Sie unser Support-Team, das Ihren Tracker im Handumdrehen aktivieren kann!",
    Spanish:
      "¡Algo salió mal, por favor contacta a nuestro equipo de soporte que podrá activar tu rastreador en un santiamén!",
    Italian:
      "Qualcosa è andato storto, contatta il nostro team di supporto che sarà in grado di attivare il tuo tracker in un batter d'occhio!",
  },
  {
    FIELD1: "add_device.main.your_pet",
    English: "Your Pet",
    French: "Votre Animal de Compagnie",
    German: "Ihr Haustier",
    Spanish: "Tu Mascota",
    Italian: "Il Tuo Animale Domestico",
  },
  {
    FIELD1: "add_device.main.optional",
    English: "Optional",
    French: "Optionnel",
    German: "Optional",
    Spanish: "Opcional",
    Italian: "Opzionale",
  },
  {
    FIELD1: "add_device.main.kind_of_animal",
    English: "What kind of animal is ",
    French: "Quel type d'animal est",
    German: "Welche Art von Tier ist",
    Spanish: "Qué tipo de animal es",
    Italian: "Che tipo di animale è",
  },
  {
    FIELD1: "add_device.main.breed",
    English: "Breed",
    French: "race",
    German: "rasse",
    Spanish: "raza",
    Italian: "razza",
  },
  {
    FIELD1: "add_device.main.birthday",
    English: "Birthday",
    French: "Anniversaire",
    German: "Geburtstag",
    Spanish: "Cumpleaños",
    Italian: "Compleanno",
  },
  {
    FIELD1: "add_device.main.birthday_placeholder",
    English: "Please enter your pet's birthday",
    French: "Veuillez entrer l'anniversaire de votre animal de compagnie",
    German: "Bitte geben Sie den Geburtstag Ihres Haustieres ein",
    Spanish: "Por favor, introduzca el cumpleaños de su mascota",
    Italian: "Si prega di inserire il compleanno del proprio animale domestico",
  },
  {
    FIELD1: "forget_password.main.code_required",
    English: "Confirmation Code is Required",
    French: "Le code de confirmation est obligatoire",
    German: "Bestätigungscode ist erforderlich",
    Spanish: "Se requiere código de confirmación",
    Italian: "È necessario un codice di conferma",
  },
  {
    FIELD1: "forget_password.main.password_required",
    English: "Password is Required",
    French: "Le mot de passe est obligatoire",
    German: "Passwort ist erforderlich",
    Spanish: "Se requiere contraseña",
    Italian: "È richiesta la password",
  },
  {
    FIELD1: "my_devices.refresh_rate.label",
    English: "Sec. Refresh",
    French: "Sec. rafraîchir",
    German: "Sek. Aktualisieren",
    Spanish: "Actualizar seg.",
    Italian: "Secondo aggiornamento",
  },
  {
    FIELD1: "my_devices.cancel.feedback",
    English: "Can you tell us more? Your feedback is important to us...",
    French:
      "Pouvez-vous nous en dire plus ? Vos commentaires sont importants pour nous...",
    German: "Können Sie uns mehr sagen? Ihr Feedback ist wichtig für uns...",
    Spanish:
      "¿Puede contarnos más? Sus comentarios son importantes para nosotros...",
    Italian: "Puoi dirci di più? Il tuo feedback è importante per noi...",
  },
  {
    FIELD1: "my_devices.retention.title",
    English: "Are you sure you would like to cancel?",
    French: "Êtes-vous sûr de vouloir annuler ?",
    German: "Sind Sie sicher, dass Sie stornieren möchten?",
    Spanish: "¿Seguro que quiere darse de baja?",
    Italian: "Sei sicuro di voler cancellare?",
  },
  {
    FIELD1: "my_devices.retention.message",
    English:
      "We'd love to offer you a more competitive plan if this would tempt you to stay.",
    French:
      "Nous serions ravis de vous proposer un plan plus compétitif si cela peut vous inciter à rester.",
    German:
      "Wir würden Ihnen gerne einen günstigeren Tarif anbieten, wenn Sie das zum Bleiben verleiten würde.",
    Spanish:
      "Nos encantaría ofrecerle un plan más competitivo si esto le tienta a quedarse.",
    Italian:
      "Saremo lieti di offrirti un abbonamento più conveniente se questo ti invoglierà a restare con noi.",
  },
  {
    FIELD1: "my_devices.retention.claim",
    English: "Claim offer",
    French: "Offre de réclamation",
    German: "Angebot beanspruchen",
    Spanish: "Reclamar oferta",
    Italian: "Richiedi l'offerta",
  },
  {
    FIELD1: "my_devices.retention.new_price",
    English: "New one time price",
    French: "Nouveau prix unique",
    German: "Neuer einmaliger Preis",
    Spanish: "Nuevo precio único",
    Italian: "Nuovo prezzo unico",
  },
  {
    FIELD1: "my_devices.retention.special_offer",
    English: "Special Offer",
    French: "Offre Spéciale",
    German: "Sonderangebot",
    Spanish: "Oferta Especial",
    Italian: "Offerta Speciale",
  },
  {
    FIELD1: "my_devices.retention.pt1",
    English: "One-time special price",
    French: "Prix spécial unique",
    German: "Einmaliger Sonderpreis",
    Spanish: "Precio especial único",
    Italian: "Prezzo speciale una tantum",
  },
  {
    FIELD1: "my_devices.retention.pt2",
    English: "All your existing features included",
    French: "Toutes vos fonctionnalités existantes incluses",
    German: "Alle Ihre vorhandenen Funktionen enthalten",
    Spanish: "Todas sus características existentes incluidas",
    Italian: "Tutte le funzionalità esistenti incluse",
  },
  {
    FIELD1: "my_devices.button.dismiss",
    English: "Dismiss",
    French: "Rejeter",
    German: "Ablehnen",
    Spanish: "Rechazar",
    Italian: "Respingere",
  },
  {
    FIELD1: "my_devices.update.title",
    English: "Subscription Overdue",
    French: "Abonnement en retard",
    German: "Abonnement überfällig",
    Spanish: "Suscripción vencida",
    Italian: "Abbonamento scaduto",
  },
  {
    FIELD1: "my_devices.activation.title",
    English: "Activate your first colla!",
    French: "Activez votre premier colla!",
    German: "Aktiviere deinen ersten colla!",
    Spanish: "¡Activa tu primer colla!",
    Italian: "Attiva il tuo primo colla!",
  },
  {
    FIELD1: "my_devices.activation.subheading",
    English: "Stay connected and know where your pet is, anytime",
    French:
      "Restez connecté et sachez où se trouve votre animal de compagnie, à tout moment",
    German:
      "Bleiben Sie verbunden und wissen Sie jederzeit, wo sich Ihr Haustier befindet",
    Spanish:
      "Manténgase conectado y sepa dónde está su mascota, en todo momento",
    Italian:
      "Rimani connesso e saprai dove si trova il tuo animale domestico, in qualsiasi momento",
  },
  {
    FIELD1: "my_devices.activation.button",
    English: "Go to activation",
    French: "Allez à l'activation",
    German: "Gehen Sie zur Aktivierung",
    Spanish: "Vaya a la activación",
    Italian: "Vai all'attivazione",
  },
  {
    FIELD1: "my_devices.update.subheading",
    English: "Renew now to keep your collas active",
    French: "Renouvelez maintenant pour garder vos collas actifs",
    German: "Erneuern Sie jetzt, um Ihre Collas aktiv zu halten",
    Spanish: "Renueve ahora para mantener sus collas activas",
    Italian: "Rinnova ora per mantenere i tuoi collas attivi",
  },
  {
    FIELD1: "my_devices.empty.title",
    English: "No Pets Added Yet",
    French: "Aucun animal de compagnie ajouté pour l'instant",
    German: "Noch keine Haustiere hinzugefügt",
    Spanish: "Aún no se han agregado mascotas",
    Italian: "Ancora nessun animale domestico aggiunto",
  },
  {
    FIELD1: "my_devices.empty.subheading",
    English: "Manage and track your furry friends",
    French: "Gérez et suivez vos amis à fourrure",
    German: "Verwalten und verfolgen Sie Ihre pelzigen Freunde",
    Spanish: "Gestiona y rastrea a tus amigos peludos",
    Italian: "Gestisci e traccia i tuoi amici pelosi",
  },
  {
    FIELD1: "my_devices.empty.button",
    English: "Activate your colla",
    French: "Activez votre colla",
    German: "Aktivieren Sie Ihre Colla",
    Spanish: "Active su colla",
    Italian: "Attiva la tua colla",
  },
  {
    FIELD1: "my_devices.retention.offer",
    English: "Offer",
    French: "Offre",
    German: "Angebot",
    Spanish: "Oferta",
    Italian: "Offerta",
  },
  {
    FIELD1: "my_devices.retention.save",
    English: "Save",
    French: "Économiser",
    German: "Sparen Sie",
    Spanish: "Guardar",
    Italian: "Salva",
  },
  {
    FIELD1: "my_devices.retention.cancel",
    English: "No thanks",
    French: "Non merci",
    German: "Nein danke",
    Spanish: "No, gracias",
    Italian: "No grazie",
  },
  {
    FIELD1: "my_devices.retention.success",
    English: "Offer Redeemed!",
    French: "Offre acceptée !",
    German: "Angebot eingelöst!",
    Spanish: "Oferta canjeada",
    Italian: "Offerta riscattata!",
  },
  {
    FIELD1: "my_devices.retention.error",
    English: "Coupon couldn't be applied, please get in touch!",
    French: "Le coupon n'a pas pu être appliqué, veuillez nous contacter !",
    German:
      "Der Coupon konnte nicht angewendet werden, bitte kontaktieren Sie uns.",
    Spanish:
      "No se ha podido aplicar el cupón, por favor, póngase en contacto con nosotros.",
    Italian: "Il coupon non è stato applicato, contattaci!",
  },
  {
    FIELD1: "my_devices.delete.title",
    English: "Remove Tracker",
    French: "Supprimer le Tracker",
    German: "Tracker entfernen",
    Spanish: "Eliminar el Tracker",
    Italian: "Rimuovi Tracker",
  },
  {
    FIELD1: "my_devices.delete.subheading",
    English:
      "Removing this tracker will permanently delete it from your account, and you will no longer be able to track or manage it.",
    French:
      "La suppression de ce traceur entraînera sa suppression permanente de votre compte, et vous ne pourrez plus suivre ni gérer ce traceur.",
    German:
      "Die Entfernung dieses Trackers führt zu seiner permanenten Löschung aus Ihrem Konto, und Sie werden nicht mehr in der Lage sein, ihn zu verfolgen oder zu verwalten.",
    Spanish:
      "La eliminación de este rastreador borrará permanentemente su cuenta, y ya no podrá rastrear ni administrar este rastreador.",
    Italian:
      "La rimozione di questo tracker comporterà la sua eliminazione permanente dal tuo account, e non sarai più in grado di monitorarlo o gestirlo.",
  },
  {
    FIELD1: "my_devices.delete.warning_title",
    English: "Warning",
    French: "Avertissement",
    German: "Warnung",
    Spanish: "Advertencia",
    Italian: "Avvertimento",
  },
  {
    FIELD1: "my_devices.delete.warning_subheading",
    English: "Are you sure you want to remove this tracker? This will:",
    French: "Êtes-vous sûr de vouloir supprimer ce tracker ? Cela entraînera :",
    German:
      "Sind Sie sicher, dass Sie diesen Tracker entfernen möchten? Dies führt dazu:",
    Spanish:
      "¿Está seguro de que desea eliminar este tracker? Esto resultará en:",
    Italian: "Sei sicuro di voler rimuovere questo tracker? Questo comporterà:",
  },
  {
    FIELD1: "my_devices.delete.warning_line1",
    English: "Cancel the associated subscription (if active).",
    French: "Annuler l'abonnement associé (s'il est actif).",
    German: "Stornieren Sie das zugehörige Abonnement (falls aktiv).",
    Spanish: "Cancelar la suscripción asociada (si está activa).",
    Italian: "Annulla l'abbonamento associato (se attivo).",
  },
  {
    FIELD1: "my_devices.delete.warning_line2",
    English: "Delete all related data from your account permanently.",
    French:
      "Supprimez toutes les données liées de votre compte de manière permanente.",
    German: "Löschen Sie alle zugehörigen Daten aus Ihrem Konto dauerhaft.",
    Spanish:
      "Elimine todos los datos relacionados de su cuenta de forma permanente.",
    Italian:
      "Elimina tutti i dati correlati dal tuo account in modo permanente.",
  },
  {
    FIELD1: "my_devices.cancel.title",
    English: "Cancel Subscription",
    French: "Annuler l'abonnement",
    German: "Abonnement kündigen",
    Spanish: "Cancelar suscripción",
    Italian: "Cancellare l'abbonamento",
  },
  {
    FIELD1: "my_devices.cancel.subheading",
    English: "Are you really want to cancel Subscriptions ",
    French: "Voulez-vous vraiment annuler les abonnements",
    German: "Möchten Sie die Abonnements wirklich kündigen",
    Spanish: "¿Realmente quieres cancelar las suscripciones",
    Italian: "Vuoi davvero annullare gli abbonamenti",
  },
  {
    FIELD1: "my_devices.manage.title",
    English: "Manage colla",
    French: "Gérer la collaboration",
    German: "Zusammenarbeit verwalten",
    Spanish: "Gestionar la colaboración",
    Italian: "Gestire la collaborazione",
  },
  {
    FIELD1: "my_devices.manage.subheading",
    English: "Manage your subscription",
    French: "Gérez votre abonnement",
    German: "Verwalten Sie Ihr Abonnement",
    Spanish: "Administra tu suscripción",
    Italian: "Gestisci il tuo abbonamento",
  },
  {
    FIELD1: "my_devices.manage.subs_status",
    English: "Subscription Status",
    French: "Statut de l'abonnement",
    German: "Abonnementstatus",
    Spanish: "Estado de la suscripción",
    Italian: "Stato dell'abbonamento",
  },
  {
    FIELD1: "my_devices.manage.subs_start",
    English: "Billing Cycle start Date",
    French: "Date de début du cycle de facturation",
    German: "Anfangsdatum des Abrechnungszeitraums",
    Spanish: "Fecha de inicio del ciclo de facturación",
    Italian: "Data di inizio del ciclo di fatturazione",
  },
  {
    FIELD1: "my_devices.manage.subs_end",
    English: "Billing Cycle start Date",
    French: "Date de début du cycle de facturation",
    German: "Startdatum des Abrechnungszeitraums",
    Spanish: "Fecha de inicio del ciclo de facturación",
    Italian: "Data di inizio del ciclo di fatturazione",
  },
  {
    FIELD1: "my_devices.manage.plan_title",
    English: "Your plan",
    French: "Votre plan",
    German: "Ihr Plan",
    Spanish: "Su plan",
    Italian: "Il tuo piano",
  },
  {
    FIELD1: "my_devices.manage.plan_subheading",
    English: "One flat price with everything included.",
    French: "Un prix forfaitaire avec tout inclus.",
    German: "Ein Pauschalpreis mit allem inklusive.",
    Spanish: "Un precio fijo con todo incluido.",
    Italian: "Un prezzo fisso con tutto incluso.",
  },
  {
    FIELD1: "my_devices.manage.per_month",
    English: "per month",
    French: "par mois",
    German: "pro Monat",
    Spanish: "al mes",
    Italian: "al mese",
  },
  {
    FIELD1: "my_devices.manage.billing_cycle",
    English: "Change billing cycle",
    French: "Changer le cycle de facturation",
    German: "Abrechnungszyklus ändern",
    Spanish: "Cambiar el ciclo de facturación",
    Italian: "Cambiare il ciclo di fatturazione",
  },
  {
    FIELD1: "my_devices.manage.new_price",
    English: "New Price",
    French: "Nouveau prix",
    German: "Neuer Preis",
    Spanish: "Nuevo precio",
    Italian: "Nuovo prezzo",
  },
  {
    FIELD1: "my_devices.manage.upgrade",
    English: "Upgrade Plan",
    French: "Plan de mise à niveau",
    German: "Upgrade-Plan",
    Spanish: "Plan de actualización",
    Italian: "Piano di aggiornamento",
  },
  {
    FIELD1: "my_devices.button.cancel_sm",
    English: "Cancel Current Plan",
    French: "Annuler le plan actuel",
    German: "Aktuellen Plan abbrechen",
    Spanish: "Cancelar el plan actual",
    Italian: "Annulla il piano attuale",
  },
  {
    FIELD1: "my_devices.cancel.processing",
    English: "Your cancellation is being processed, please check back later.",
    French:
      "Votre annulation est en cours de traitement, veuillez vérifier ultérieurement.",
    German:
      "Ihre Stornierung wird bearbeitet, bitte überprüfen Sie später erneut.",
    Spanish:
      "Su cancelación está siendo procesada, por favor, vuelva a verificar más tarde.",
    Italian:
      "La sua cancellazione è in fase di elaborazione, per favore controlli di nuovo più tardi.",
  },
  {
    FIELD1: "track.sidebar.acc_on",
    English: "Ignition On",
    French: "Allumage",
    German: "Zündung an",
    Spanish: "Encendido",
    Italian: "Accensione",
  },
  {
    FIELD1: "track.sidebar.acc_off",
    English: "Ignition Off",
    French: "Arrêt",
    German: "Zündung aus",
    Spanish: "Apagado",
    Italian: "Spegnimento",
  },
  {
    FIELD1: "navigation.main.history_management",
    English: "Manage Data",
    French: "Gérer les données",
    German: "Daten verwalten ",
    Spanish: "Administrar datos",
    Italian: "Gestire i dati",
  },
  {
    FIELD1: "history_management.main.heading",
    English: "Your Tracker's History",
    French: "Historique de notre traqueur",
    German: "die Geschichte unseres Trackers",
    Spanish: "Historial de nuestro rastreador",
    Italian: "La cronologia del nostro localizzatore",
  },
  {
    FIELD1: "history_management.main.subheading",
    English: "View or delete the location history for your trackers.",
    French:
      "Afficher ou supprimer l'historique de localisation de vos traceurs.",
    German:
      "Zeigen Sie den Standortverlauf für Ihre Tracker an oder löschen Sie ihn.",
    Spanish: "Vea o elimine el historial de localización de sus rastreadores.",
    Italian:
      "Visualizza o elimina la cronologia delle posizioni dei localizzatori.",
  },
  {
    FIELD1: "history_management.main.delete_history",
    English: "Delete History",
    French: "Supprimer l'historique",
    German: "Verlauf löschen",
    Spanish: "Borrar Historial",
    Italian: "Cancella cronologia",
  },
  {
    FIELD1: "history_management.main.select_label",
    English: "Select a Tracker",
    French: "Sélectionner un traceur",
    German: "Wählen Sie einen Tracker",
    Spanish: "Seleccione un Rastreador",
    Italian: "Selezionare un dispositivo di tracciamento",
  },
  {
    FIELD1: "history_management.main.download_history",
    English: "Download History",
    French: "Télécharger l'historique",
    German: "Geschichte herunterladen",
    Spanish: "Descargar historial",
    Italian: "Scarica cronologia",
  },
  {
    FIELD1: "history_management.delete.title",
    English: "Delete tracker history",
    French: "Supprimer l'historique du traceur",
    German: "Tracker-Verlauf löschen",
    Spanish: "Eliminar el historial del rastreador",
    Italian: "Elimina la cronologia del localizzatore",
  },
  {
    FIELD1: "history_management.delete.message",
    English: "Are you sure you want to remove the tracker history for",
    French: "Êtes-vous sûr de vouloir supprimer l'historique du traceur pour",
    German: "Sind Sie sicher, dass Sie den Trackerverlauf für",
    Spanish:
      "¿Estás seguro de que desea eliminar el historial del rastreador para",
    Italian:
      "Sei sicuro di voler rimuovere la cronologia del localizzatore per",
  },
  {
    FIELD1: "history_management.delete.irreversible",
    English: "This action is irreversible",
    French: "Cette action est irréversible",
    German: "Diese Aktion ist unumkehrbar",
    Spanish: "Esta acción es irreversible",
    Italian: "Questa azione è irreversibile",
  },
  {
    FIELD1: "history_management.delete.irreversible_mobile",
    English:
      "This action will permanently delete all location history for this tracker, including all data ever recorded.",
    French:
      "Cette action supprimera définitivement tout l'historique de localisation de ce traceur, y compris toutes les données précédemment enregistrées.",
    German:
      "Diese Aktion löscht dauerhaft den gesamten Standortverlauf für diesen Tracker, einschließlich aller jemals aufgezeichneten Daten.",
    Spanish:
      "Esta acción eliminará permanentemente todo el historial de ubicación de este rastreador, incluyendo todos los datos registrados.",
    Italian:
      "Questa azione eliminerà definitivamente tutta la cronologia di localizzazione di questo dispositivo di localizzazione, compresi tutti i dati mai registrati.",
  },
  {
    FIELD1: "history_management.delete.success",
    English: "Your history was successfully deleted",
    French: "Votre historique a été supprimé avec succès",
    German: "Ihr Verlauf wurde erfolgreich gelöscht",
    Spanish: "Su historial se ha eliminado correctamente",
    Italian: "La cronologia è stata cancellata con successo",
  },
  {
    FIELD1: "history_management.delete.error",
    English: "An error occurred with deletion. Please contact support.",
    French:
      "Une erreur s'est produite lors de la suppression. Veuillez contacter l'assistance.",
    German:
      "Bei der Löschung ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Support.",
    Spanish:
      "Se ha producido un error al eliminarlo. Por favor, póngase en contacto con el servicio de asistencia.",
    Italian:
      "Si è verificato un errore di cancellazione. Contattare l'assistenza.",
  },
  {
    FIELD1: "history_management.download.title",
    English: "Download tracker history",
    French: "Télécharger l'historique du traceur",
    German: "Tracker-Verlauf herunterladen",
    Spanish: "Descargar el historial del rastreador",
    Italian: "Scarica la cronologia del dispositivo",
  },
  {
    FIELD1: "history_management.download.message",
    English: "Select the dates to download the location history for",
    French:
      "Sélectionnez les dates pour lesquelles vous souhaitez télécharger l'historique",
    German:
      "Wählen Sie die Daten aus, für die Sie den Standortverlauf herunterladen möchten",
    Spanish:
      "Seleccione las fechas para las que desea descargar el historial de localizaciones",
    Italian:
      "Seleziona le date per cui scaricare la cronologia della posizione",
  },
  {
    FIELD1: "history_management.download.start_date",
    English: "Start date",
    French: "Date de début",
    German: "Startdatum",
    Spanish: "Fecha de inicio",
    Italian: "Data di inizio",
  },
  {
    FIELD1: "history_management.download.end_date",
    English: "End date",
    French: "Date de fin",
    German: "Enddatum",
    Spanish: "Fecha de finalización",
    Italian: "Data di fine",
  },
  {
    FIELD1: "history_management.download.no_data",
    English:
      "No location data for the selected dates. Try selecting different dates.",
    French:
      "Aucune donnée de localisation pour les dates sélectionnées. Essayez de sélectionner d'autres dates.",
    German:
      "Keine Standortdaten für die ausgewählten Daten. Versuchen Sie, andere Daten auszuwählen.",
    Spanish:
      "No hay datos de ubicación para las fechas seleccionadas. Intente seleccionar fechas diferentes.",
    Italian:
      "Non ci sono dati relativi alla posizione per le date selezionate. Prova a selezionare date diverse.",
  },
  {
    FIELD1: "history_management.download.travelled",
    English: "traveled in the selected dates",
    French: "a voyagé dans les dates sélectionnées",
    German: "in den ausgewählten Daten gereist sind",
    Spanish: "viajado en las fechas seleccionadas",
    Italian: "viaggiato nelle date selezionate",
  },
  {
    FIELD1: "history_management.main.download",
    English: "Download",
    French: "Télécharger",
    German: "Herunterladen",
    Spanish: "Descargar",
    Italian: "Scaricamento",
  },
  {
    FIELD1: "account.users.title",
    English: "Account Sharing",
    French: "Partage de compte",
    German: "Gemeinsame Nutzung eines Kontos",
    Spanish: "Compartir Cuenta",
    Italian: "Condivisione del conto",
  },
  {
    FIELD1: "account.users.subheading",
    English: "Share access to your account with other users in the platform",
    French:
      "partager l'accès à votre compte avec d'autres utilisateurs de la plateforme",
    German:
      "Teilen Sie den Zugang zu Ihrem Konto mit anderen Nutzern der Plattform",
    Spanish: "Comparta acceso a su cuenta con otros usuarios en la plataforma",
    Italian:
      "Condividere l'accesso al proprio account con altri utenti della piattaforma",
  },
  {
    FIELD1: "account.users.no_members",
    English: "You’re currently not sharing your account with any other users.",
    French: "Vous ne partagez pas votre compte avec d'autres utilisateurs.",
    German: "Sie teilen Ihr Konto derzeit nicht mit anderen Benutzern.",
    Spanish:
      "Actualmente no está compartiendo su cuenta con ningún otro usuario.",
    Italian:
      "Al momento non stai condividendo il tuo account con altri utenti.",
  },
  {
    FIELD1: "account.users.add",
    English: "Add Member",
    French: "Ajouter un membre",
    German: "Mitglied hinzufügen",
    Spanish: "Agregar Miembro",
    Italian: "Aggiungi membro",
  },
  {
    FIELD1: "account.users.adding",
    English: "Adding",
    French: "Ajout",
    German: "Hinzufügen",
    Spanish: "Agregando",
    Italian: "Aggiunta di",
  },
  {
    FIELD1: "account.users.add_label",
    English: "Search for an Email",
    French: "Recherche d'un e-mail",
    German: "Suche nach einer E-Mail",
    Spanish: "Buscar un Correo Electrónico",
    Italian: "Cerca un'e-mail",
  },
  {
    FIELD1: "account.users.add_placeholder",
    English: "Enter Email Address",
    French: "Entrer l'adresse e-mail",
    German: "E-Mail-Adresse eingeben",
    Spanish: "Ingrese la Dirección de Correo Electrónico",
    Italian: "Inserire l'indirizzo e-mail",
  },
  {
    FIELD1: "account.users.no_user",
    English: "No user was found for the entered email",
    French: "Aucun utilisateur n'a été trouvé pour l'e-mail saisi",
    German: "Es wurde kein Benutzer für die eingegebene E-Mail gefunden",
    Spanish:
      "No se encontró ningún usuario para el correo electrónico ingresado",
    Italian: "Non è stato trovato alcun utente per l'e-mail inserita",
  },
  {
    FIELD1: "account.users.remove_title",
    English: "Remove User",
    French: "Supprimer l'utilisateur",
    German: "Benutzer entfernen",
    Spanish: "Eliminar usuario",
    Italian: "Rimuovi utente",
  },
  {
    FIELD1: "account.users.remove_message",
    English: "Are you sure you want to remove this user?",
    French: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    German: "Sind Sie sicher, dass Sie diesen Benutzer entfernen möchten?",
    Spanish: "¿Está seguro de que quiere eliminar a este usuario?",
    Italian: "Sei sicuro di voler rimuovere questo utente?",
  },
  {
    FIELD1: "account.users.remove",
    English: "Remove User",
    French: "Supprimer l'utilisateur",
    German: "Benutzer entfernen",
    Spanish: "Eliminar Usuario",
    Italian: "Rimuovi utente",
  },
  {
    FIELD1: "account.users.removing",
    English: "Removing",
    French: "Suppression",
    German: "Entfernung",
    Spanish: "Eliminando",
    Italian: "Rimozione",
  },
  {
    FIELD1: "account.users.access",
    English: "People with access",
    French: "Personnes ayant accès",
    German: "Personen mit Zugang",
    Spanish: "Personas con acceso",
    Italian: "Utenti con accesso",
  },
  {
    FIELD1: "account.users.viewer",
    English: "Viewer",
    French: "Consultation",
    German: "Betrachter",
    Spanish: "Visor",
    Italian: "Visualizzazione",
  },
  {
    FIELD1: "account.users.editor",
    English: "Admin",
    French: "Administrateur",
    German: "Admin",
    Spanish: "Administrador",
    Italian: "Admin",
  },
  {
    FIELD1: "account.users.validation1",
    English: "Please enter a valid email address",
    French: "Veuillez saisir une adresse e-mail valide",
    German: "Bitte geben Sie eine gültige E-Mail Adresse ein",
    Spanish: "Por favor, ingrese una dirección de correo electrónico válida",
    Italian: "Inserire un indirizzo e-mail valido",
  },
  {
    FIELD1: "account.users.validation2",
    English: "You can't add yourself as a member",
    French: "Vous ne pouvez pas vous ajouter comme membre",
    German: "Sie können sich nicht selbst als Mitglied hinzufügen",
    Spanish: "No puede agregarse a usted mismo como miembro",
    Italian: "Non è possibile aggiungersi come membri",
  },
  {
    FIELD1: "account.users.add_success",
    English: "User successfully invited",
    French: "L'utilisateur a été invité avec succès",
    German: "Der Nutzer wurde erfolgreich hinzugefügt",
    Spanish: "Usuario invitado con éxito",
    Italian: "L'utente è stato invitato con successo",
  },
  {
    FIELD1: "account.users.add_error",
    English:
      "You cannot invite this user, please try again later or contact support.",
    French:
      "Vous ne pouvez pas inviter cet utilisateur, veuillez réessayer plus tard ou contacter le support.",
    German:
      "Sie können diesen Nutzer nicht einladen, bitte versuchen Sie es später nochmal oder kontaktieren Sie den Support",
    Spanish:
      "No puede invitar a este usuario, por favor intente nuevamente más tarde o contacte al soporte.",
    Italian:
      "Non è possibile invitare questo utente, riprovare più tardi o contattare l'assistenza.",
  },
  {
    FIELD1: "account.users.add_error1",
    English: "already added or invited to an account",
    French: "déjà ajouté ou invité à un compte",
    German: "bereits zu einem Konto hinzugefügt oder eingeladen",
    Spanish: "ya añadido o invitado a una cuenta",
    Italian: "già aggiunto o invitato a un account",
  },
  {
    FIELD1: "account.users.add_error2",
    English: "You cannot invite a user with an existing account",
    French: "Vous ne pouvez pas inviter un utilisateur ayant déjà un compte",
    German: "Sie können keinen Nutzer mit einem existierenden Konto einladen",
    Spanish: "No puede invitar a un usuario con una cuenta existente",
    Italian:
      "Non è possibile invitare un utente che abbia un account esistente",
  },
  {
    FIELD1: "account.users.update_success",
    English: "Successfully updated",
    French: "Mise à jour réussie",
    German: "Es wurde erfolgreich aktualisiert",
    Spanish: "Actualización exitosa",
    Italian: "Aggiornato con successo",
  },
  {
    FIELD1: "account.users.update_error",
    English: "Couldn't update user, please try again later or contact support",
    French:
      "Impossible de mettre à jour l'utilisateur, veuillez réessayer plus tard ou contacter l'assistance.",
    German:
      "Der Nutzer konnte nicht aktualisiert werden, bitte versuchen Sie es später nochtmal oder kontaktieren Sie den Support",
    Spanish:
      "No se pudo actualizar el usuario, por favor intente nuevamente más tarde o contacte al soporte",
    Italian:
      "Impossibile aggiornare l'utente, riprovare più tardi o contattare l'assistenza.",
  },
  {
    FIELD1: "account.users.delete_success",
    English: "Successfully deleted",
    French: "Supprimé avec succès",
    German: "Es wurde erfolgreich gelöscht",
    Spanish: "Eliminado con éxito",
    Italian: "Eliminato con successo",
  },
  {
    FIELD1: "account.users.delete_error",
    English: "Couldn't delete user, please try again later or contact support",
    French:
      "Impossible de supprimer l'utilisateur, veuillez réessayer plus tard ou contacter l'assistance.",
    German:
      "Der Nutzer konnte nicht gelöscht werden, bitte versuchen Sie es später nochmal oder kontaktieren Sie den Support",
    Spanish:
      "No se pudo eliminar al usuario, por favor intente nuevamente más tarde o contacte al soporte",
    Italian:
      "Impossibile eliminare l'utente, riprovare più tardi o contattare l'assistenza.",
  },
  {
    FIELD1: "account.users.invite_pending",
    English: "Invite Pending",
    French: "Invitation en attente",
    German: "Die Einladung läuft",
    Spanish: "Invitación pendiente",
    Italian: "In attesa di invito",
  },
  {
    FIELD1: "account.referral.title",
    English: "Referrals - Earn Free Tracking",
    French: "Parrainage - Gagnez un suivi gratuit",
    German: "Empfehlungen - Verdienen Sie eine kostenlose Fortsetzung",
    Spanish: "Referencias - Gane un seguimiento gratuito",
    Italian: "Referenza - Guadagnare il tracciamento gratuito",
  },
  {
    FIELD1: "account.referral.dollars",
    English: "Amount",
    French: "Montant",
    German: "Betrag",
    Spanish: "Cantidad",
    Italian: "Importo",
  },
  {
    FIELD1: "account.referral.desc1",
    English:
      "Share your peace of mind, and when they sign up, they get 10% off their first year's subscription, and you get 10% of every payment they make.",
    French:
      "Partagez votre tranquillité d'esprit, et lorsqu'ils s'inscrivent, vous recevez 10 % de chaque paiement qu'ils effectuent.",
    German:
      "Teilen Sie Ihren Seelenfrieden, und wenn er sich anmeldet, erhalten Sie 10 % von jeder Zahlung, die er tätigt.",
    Spanish:
      "Comparta su tranquilidad y, cuando se suscriban, obtendrá el 10% de cada pago que realicen.",
    Italian:
      "Condividi con gli altri ciò che ti fa stare bene e, quando si iscrivono, ricevi il 10% di ogni pagamento che effettuano.",
  },
  {
    FIELD1: "account.referral.desc2",
    English:
      "Every month/quarter/year that your referee makes a subscription payment, we’ll apply 10% of the value of their payment to your account as subscription credit, which will be deducted from your next subscription payment, up to 100%!",
    French:
      "Chaque mois/trimestre/année où votre filleul effectue un paiement d'abonnement, nous verserons 10 % de la valeur de son paiement sur votre compte en tant que crédit d'abonnement, qui sera déduit de votre prochain paiement d'abonnement, jusqu'à atteindre 100 % !",
    German:
      "Jeden Monat/jedes Quartal/Jahr, in dem Ihr Schiedsrichter eine Abo-Zahlung leistet, schreiben wir Ihrem Konto 10 % des Wertes seiner Zahlung als Abo-Guthaben gut, das von Ihrer nächsten Abo-Zahlung abgezogen wird, bis zu 100 %!",
    Spanish:
      "Cada mes/trimestre/año que su referido realice un pago de suscripción, aplicaremos el 10% del valor de su pago a su cuenta como crédito de suscripción, que se deducirá de su próximo pago de suscripción, ¡hasta el 100%!",
    Italian:
      "Ogni mese/trimestre/anno in cui il tuo referente paga un abbonamento, applicheremo il 10% del valore del suo pagamento al tuo account come credito, che verrà detratto dal pagamento del tuo abbonamento successivo, fino al 100%!",
  },
  {
    FIELD1: "account.referral.learn",
    English: "Learn more about the referral system",
    French: "En savoir plus sur le système d'orientation",
    German: "Erfahren Sie mehr über das Empfehlungssystem",
    Spanish: "Más información sobre el sistema de recomendación",
    Italian: "Per saperne di più sul sistema di referenza",
  },
  {
    FIELD1: "account.referral.balance",
    English: "Your credit balance",
    French: "Votre solde de crédit",
    German: "Ihr Guthaben",
    Spanish: "Su saldo acreedor",
    Italian: "Il saldo del credito",
  },
  {
    FIELD1: "account.referral.link_title",
    English: "Your referral link",
    French: "Votre lien de parrainage",
    German: "Ihr Empfehlungslink",
    Spanish: "Su enlace de recomendación",
    Italian: "Il tuo link di referenza",
  },
  {
    FIELD1: "account.referral.link_desc",
    English:
      "Share your referal link by copying and sending it or through your social media",
    French:
      "Partagez votre lien de parrainage en le copiant et en l'envoyant ou par le biais de vos médias sociaux.",
    German:
      "Teilen Sie Ihren Empfehlungslink, indem Sie ihn kopieren und versenden oder über Ihre sozialen Medien.",
    Spanish:
      "Comparta su enlace de recomendación copiándolo y enviándolo o a través de sus redes sociales",
    Italian:
      "Condividi il tuo link di referenza copiandolo e inviandolo o attraverso i tuoi social media.",
  },
  {
    FIELD1: "account.referral.link_btn1",
    English: "Copy link",
    French: "Copier le lien",
    German: "Link kopieren",
    Spanish: "Copiar enlace",
    Italian: "Copia link",
  },
  {
    FIELD1: "account.referral.link_btn2",
    English: "Share",
    French: "Partager",
    German: "Teilen",
    Spanish: "Compartir",
    Italian: "Condividi",
  },
  {
    FIELD1: "account.referral.invite_title",
    English: "Invite via email",
    French: "Inviter par courrier électronique",
    German: "Per E-Mail einladen",
    Spanish: "Invitar por correo electrónico",
    Italian: "Invita tramite email",
  },
  {
    FIELD1: "account.referral.invite_desc",
    English:
      "Insert your an email address to send them an invitation to use colla!",
    French:
      "Insérez votre adresse e-mail pour leur envoyer une invitation à utiliser colla !",
    German:
      "Geben Sie Ihre E-Mail-Adresse ein, um Ihnen eine Einladung zur Nutzung von colla zu senden!",
    Spanish:
      "Introduzca su dirección de correo electrónico para enviarles una invitación para utilizar colla.",
    Italian:
      "Inserisci il tuo indirizzo e-mail per inviargli un invito ad utilizzare colla!",
  },
  {
    FIELD1: "account.referral.invite_btn",
    English: "Send Invite",
    French: "Envoyer l'invitation",
    German: "Einladung senden",
    Spanish: "Enviar invitación",
    Italian: "Manda l'invito",
  },
  {
    FIELD1: "account.referral.invite_placeholder",
    English: "Email address",
    French: "Adresse e-mail",
    German: "E-Mail-Adresse",
    Spanish: "Dirección de correo electrónico",
    Italian: "Indirizzo e-mail",
  },
  {
    FIELD1: "account.referral.tooltip",
    English:
      "Your current referral balance and your total claimed referral value. Please note your current balance may include credit applied by our support team for various reasons.",
    French:
      "Votre solde actuel de parrainage et votre valeur totale de parrainage réclamée. Veuillez noter que votre solde actuel peut inclure un crédit appliqué par notre équipe d'assistance pour diverses raisons.",
    German:
      "Ihr aktuelles Empfehlungsguthaben und den gesamten beanspruchten Empfehlungswert. Bitte beachten Sie, dass Ihr aktuelles Guthaben enthalten kann, das von unserem Support-Team aus verschiedenen Gründen gewährt wurde.",
    Spanish:
      "Su saldo actual de referidos y el valor total de referidos reclamado. Tenga en cuenta que su saldo actual puede incluir crédito aplicado por nuestro equipo de soporte por diversas razones.",
    Italian:
      "Il saldo attuale del programma di referenza e il valore totale del programma di referenza richiesto. Si prega di notare che il saldo attuale può includere crediti applicati dal nostro team di assistenza per vari motivi.",
  },
  {
    FIELD1: "account.referral.link_copied",
    English: "Copied to clipboard",
    French: "Copié dans le presse-papiers",
    German: "In die Zwischenablage kopiert",
    Spanish: "Copiado al portapapeles",
    Italian: "Copiato negli appunti",
  },
  {
    FIELD1: "account.referral.email_error",
    English: "Please enter a valid email address",
    French: "Veuillez saisir une adresse e-mail valide",
    German: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    Spanish: "Introduzca una dirección de correo electrónico válida",
    Italian: "Inserire un indirizzo e-mail valido",
  },
  {
    FIELD1: "account.referral.limit_error",
    English: "You can only send 5 email invitations each day",
    French: "Vous ne pouvez envoyer que 5 invitations par jour.",
    German: "Sie können nur 5 E-Mail-Einladungen pro Tag versenden",
    Spanish: "Sólo puede enviar 5 invitaciones por correo electrónico al día",
    Italian: "È possibile inviare solo 5 inviti via e-mail al giorno.",
  },
  {
    FIELD1: "account.referral.already_error",
    English: "This email address belongs to an existing colla user",
    French: "Cette adresse e-mail appartient à un utilisateur colla existant",
    German: "Diese E-Mail-Adresse gehört zu einem bestehenden colla Benutzer",
    Spanish:
      "Esta dirección de correo electrónico pertenece a un usuario existente de colla",
    Italian: "Questo indirizzo e-mail appartiene a un utente colla esistente",
  },
  {
    FIELD1: "account.referral.other_error",
    English: "Email couldn't be sent, please share a link with them instead.",
    French:
      "L'e-mail n'a pas pu être envoyé, veuillez partager un lien avec eux à la place.",
    German:
      "Die E-Mail konnte nicht gesendet werden. Bitte teilen Sie ihnen stattdessen einen Link mit.",
    Spanish:
      "No se ha podido enviar el correo electrónico, por favor comparta un enlace con ellos en su lugar.",
    Italian:
      "Non è stato possibile inviare l'e-mail, si prega di condividere un link.",
  },
  {
    FIELD1: "account.referral.success",
    English: "Email sent successfully!",
    French: "E-mail envoyé avec succès !",
    German: "E-Mail erfolgreich gesendet!",
    Spanish: "Correo electrónico enviado correctamente",
    Italian: "Email inviata con successo!",
  },
  {
    FIELD1: "account.referral.read_more",
    English: "Read more",
    French: "En savoir plus",
    German: "Mehr lesen",
    Spanish: "Leer más",
    Italian: "Per saperne di più",
  },
  {
    FIELD1: "account.referral.read_less",
    English: "Read less",
    French: "Lire moins",
    German: "Weniger lesen",
    Spanish: "Leer menos",
    Italian: "Leggi di meno",
  },
  {
    FIELD1: "account.referral.share_text",
    English: "Join colla Tracking using my referral link",
    French: "Rejoignez colla Tracking en utilisant mon lien de référence",
    German: "Trete dem colla Tracking bei, indem du meinen Link benutzt. ",
    Spanish: "Únase a colla Tracking usando mi enlace de referencia",
    Italian:
      "Iscriviti a colla Tracking utilizzando il mio link di riferimento",
  },
  {
    FIELD1: "account.main.password_reset",
    English:
      "Looking to reset your password? Log out and go to the login page to find the link.",
    French:
      "Vous souhaitez réinitialiser votre mot de passe ? Déconnectez-vous et rendez-vous sur la page de connexion pour trouver le lien.",
    German:
      "Möchten Sie Ihr Passwort zurücksetzen? Melden Sie sich ab und gehen Sie zur Anmeldeseite, um den Link zu finden.",
    Spanish:
      "¿Quieres restablecer tu contraseña? Cierra sesión y ve a la página de inicio de sesión para encontrar el enlace.",
    Italian:
      "Vuoi reimpostare la tua password? Esci e vai alla pagina di accesso per trovare il collegamento.",
  },
  {
    FIELD1: "track.sidebar.tooltip_troubleshoot",
    English: "Your tracker’s offline?<br/>Click here to troubleshoot",
    French:
      "Votre traceur n'est pas en ligne ?<br/>Cliquez ici pour le dépannage",
    German:
      "Ihr Tracker ist offline?<br/>Klicken Sie hier, um das Problem zu beheben",
    Spanish:
      "¿Su rastreador está sin conexión?<br/>Haga clic aquí para solucionar problemas",
    Italian:
      "Il localizzatore è offline? <br/>Clicca qui per risolvere i problemi",
  },
  {
    FIELD1: "support.trackers.bottom",
    English:
      "Please wait a few minutes after following these steps for your tracker to reconnect to our network...",
    French:
      "Veuillez attendre quelques minutes après avoir suivi ces étapes pour que votre traceur se reconnecte à notre réseau...",
    German:
      "Bitte warten Sie nach diesen Schritten einige Minuten, bis sich Ihr Tracker wieder mit unserem Netzwerk verbunden hat...",
    Spanish:
      "Espere unos minutos después de seguir estos pasos para que su rastreador se vuelva a conectar a nuestra red...",
    Italian:
      "Attendi qualche minuto dopo aver seguito questi passaggi affinché il localizzatore si riconnetta alla nostra rete...",
  },
  {
    FIELD1: "support.trackers.contact",
    English: "Couldn't get it to work?",
    French: "Vous n'arrivez pas à le faire fonctionner ?",
    German: "Sie konnten es nicht zum Laufen bringen?",
    Spanish: "¿No pudo hacerlo funcionar?",
    Italian: "Il problema persiste?",
  },
  {
    FIELD1: "support.trackers.contactbtn",
    English: "Contact Support",
    French: "Contacter le support",
    German: "Kontakt Unterstützung",
    Spanish: "Contacte al Soporte",
    Italian: "Contatta l'assistenza",
  },
  {
    FIELD1: "track.link_sharing.button",
    English: "Share",
    French: "Partager",
    German: "Teilen",
    Spanish: "Compartir",
    Italian: "Condividi",
  },
  {
    FIELD1: "track.link_sharing.title_main",
    English: "Share your tracker's locations",
    French: "Partagez les emplacements de vos traceurs",
    German: "Teile die Standorte deines  Trackers",
    Spanish: "Comparta las ubicaciones de su rastreador",
    Italian: "Condividi le posizioni del tuo tracker",
  },
  {
    FIELD1: "track.link_sharing.title_create",
    English: "New share",
    French: "Nouveau partage",
    German: "Neue Freigabe",
    Spanish: "Nueva compartición",
    Italian: "Nuova condivisione",
  },
  {
    FIELD1: "track.link_sharing.title_view",
    English: "View share",
    French: "Afficher le partage",
    German: "Freigabe anschauen",
    Spanish: "Ver compartición",
    Italian: "Visualizza condivisione",
  },
  {
    FIELD1: "track.link_sharing.title_edit",
    English: "Edit share",
    French: "Modifier le partage",
    German: "Bearbeitung teilen",
    Spanish: "Editar compartición",
    Italian: "Modifica condivisione",
  },
  {
    FIELD1: "track.link_sharing.title_delete",
    English: "Delete share",
    French: "Supprimer le partage",
    German: "Freigabe löschen",
    Spanish: "Eliminar compartición",
    Italian: "Cancella condivisione",
  },
  {
    FIELD1: "track.link_sharing.title_success",
    English: "Share created",
    French: "Partage créé",
    German: "Das Teilen wurde erstellt",
    Spanish: "Compartición creada",
    Italian: "Condivisione creata",
  },
  {
    FIELD1: "track.link_sharing.toast_success",
    English: "Share Link created successfully",
    French: "Lien de partage créé avec succès",
    German: "Freigabelink wurde erfolgreich erstellt",
    Spanish: "Enlace de compartición creado con éxito",
    Italian: "Link di condivisione creato con successo",
  },
  {
    FIELD1: "track.link_sharing.toast_update",
    English: "Share Link updated successfully",
    French: "Lien de partage mis à jour avec succès",
    German: "Freigabelink wurde erfolgreich hochgeladen",
    Spanish: "Enlace de compartición actualizado con éxito",
    Italian: "Link di condivisione aggiornato con successo",
  },
  {
    FIELD1: "track.link_sharing.toast_delete",
    English: "Share Link delete successfully",
    French: "Lien de partage supprimé avec succès",
    German: "Freigabelink wurde erfolgreich gelöscht",
    Spanish: "Enlace de compartición eliminado con éxito",
    Italian: "Condivisione link cancellata con successo",
  },
  {
    FIELD1: "track.link_sharing.toast_copied",
    English: "Share Link copied to clipboard",
    French: "Lien de partage copié dans le presse-papiers",
    German: "Freigabelink wurde erfolgreich in die Zwischenablage kopiert",
    Spanish: "Enlace de compartición copiado al portapapeles",
    Italian: "Link da condividere copiato negli appunti",
  },
  {
    FIELD1: "track.link_sharing.label_name",
    English: "Name",
    French: "Nom",
    German: "Name",
    Spanish: "Nombre",
    Italian: "Nome",
  },
  {
    FIELD1: "track.link_sharing.label_trackers",
    English: "Trackers",
    French: "Traceurs",
    German: "Tracker",
    Spanish: "Rastreadores",
    Italian: "Dispositivo",
  },
  {
    FIELD1: "track.link_sharing.label_expiry",
    English: "Expiry",
    French: "Expiration",
    German: "Ablaufdatum ",
    Spanish: "Vencimiento",
    Italian: "Scadenza",
  },
  {
    FIELD1: "track.link_sharing.label_share",
    English: "Share Link",
    French: "Partager le lien",
    German: "Freigabelink",
    Spanish: "Enlace de compartición",
    Italian: "Condividi link",
  },
  {
    FIELD1: "track.link_sharing.message_success",
    English: "Share your tracker with this link",
    French: "Partagez votre traceur avec ce lien",
    German: "Teile deinen Tracker mit diesem Link",
    Spanish: "Comparta su rastreador con este enlace",
    Italian: "Condividi il tuo dispositivo con questo link",
  },
  {
    FIELD1: "track.link_sharing.message_delete",
    English: "Please confirm if you want to delete this share link",
    French: "Veuillez confirmer si vous souhaitez supprimer ce lien de partage",
    German: "Bitte bestätige, ob du diesen Freigabelink löschen möchtest",
    Spanish:
      "Por favor, confirme si desea eliminar este enlace de compartición",
    Italian: "Confermare se si desidera eliminare questo link di condivisione",
  },
  {
    FIELD1: "track.link_sharing.placeholder_all",
    English: "Select All",
    French: "Sélectionner tout",
    German: "Alle auswählen",
    Spanish: "Seleccionar todo",
    Italian: "Seleziona tutto",
  },
  {
    FIELD1: "track.link_sharing.placeholder_search",
    English: "Search Trackers or IMEI",
    French: "Recherche de traceurs ou d'IMEI",
    German: "Tracker oder IMEI auswählen",
    Spanish: "Buscar rastreadores o IMEI",
    Italian: "Ricerca di localizzatori o IMEI",
  },
  {
    FIELD1: "track.link_sharing.all",
    English: "All",
    French: "Tous",
    German: "Alle auswählen",
    Spanish: "Todo",
    Italian: "Tutto",
  },
  {
    FIELD1: "track.link_sharing.max40",
    English: "Max. 40 Chars",
    French: "Max. 40 caractères",
    German: "Max. 40 Char.",
    Spanish: "Máx. 40 caracteres",
    Italian: "Max. 40 caratteri",
  },
  {
    FIELD1: "track.link_sharing.expire",
    English: "Share will expire",
    French: "Le partage va expirer",
    German: "Die Freigabe läuft ab ",
    Spanish: "La compartición vencerá",
    Italian: "La condivisione sta per scadere",
  },
  {
    FIELD1: "track.link_sharing.expired",
    English: "Share expired",
    French: "Le partage a expiré",
    German: "Die Freigabe ist abgelaufen ",
    Spanish: "Compartición vencida",
    Italian: "Condivisione scaduta",
  },
  {
    FIELD1: "track.link_sharing.expire1",
    English: "Expires",
    French: "Expire",
    German: "Läuft bald ab",
    Spanish: "Vence",
    Italian: "In scadenza",
  },
  {
    FIELD1: "track.link_sharing.expired1",
    English: "Expired",
    French: "Expiré",
    German: "Ist abgelaufen ",
    Spanish: "Vencido",
    Italian: "Scaduti",
  },
  {
    FIELD1: "track.link_sharing.on",
    English: "on",
    French: "le",
    German: "auf",
    Spanish: "en",
    Italian: "su",
  },
  {
    FIELD1: "track.link_sharing.create",
    English: "Create",
    French: "Créer",
    German: "erstellen",
    Spanish: "Crear",
    Italian: "Crea",
  },
  {
    FIELD1: "track.link_sharing.cancel",
    English: "Cancel",
    French: "Annuler",
    German: "abbrechen",
    Spanish: "Cancelar",
    Italian: "Cancella",
  },
  {
    FIELD1: "track.link_sharing.edit",
    English: "Edit",
    French: "Modifier",
    German: "bearbeiten",
    Spanish: "Editar",
    Italian: "Modifica",
  },
  {
    FIELD1: "track.link_sharing.delete",
    English: "Delete",
    French: "Supprimer",
    German: "löschen",
    Spanish: "Eliminar",
    Italian: "Elimina",
  },
  {
    FIELD1: "track.link_sharing.done",
    English: "Done",
    French: "Terminé",
    German: "fertig",
    Spanish: "Hecho",
    Italian: "Fatto",
  },
  {
    FIELD1: "track.link_sharing.main_title",
    English: "Active Links",
    French: "Liens actifs",
    German: "aktive Links",
    Spanish: "Enlaces activos",
    Italian: "Link attivi",
  },
  {
    FIELD1: "track.link_sharing.limit",
    English: "Maximum limit reached",
    French: "Limite maximale atteinte",
    German: "Das maximale Limit wurde erreicht",
    Spanish: "Límite máximo alcanzado",
    Italian: "Limite massimo raggiunto",
  },
  {
    FIELD1: "track.link_sharing.new",
    English: "New Share",
    French: "Nouveau partage",
    German: "Neue Freigabe",
    Spanish: "Nueva compartición",
    Italian: "Nuova condivisione",
  },
  {
    FIELD1: "track.link_sharing.empty",
    English: "You’re currently not sharing any tracker’s location",
    French: "Vous ne partagez actuellement l'emplacement d'aucun traceur.",
    German: "Derzeit teilst du aktuell keinen keinen Standort eines Trackers",
    Spanish:
      "Actualmente no está compartiendo la ubicación de ningún rastreador",
    Italian:
      "Al momento non si sta condividendo la posizione di nessun tracker.",
  },
  {
    FIELD1: "mua.helmet.title",
    English: "Accept your colla Invite",
    French: "Accepter votre invitation colla",
    German: "Aktzeptieren Sie ihre colla Einladung",
    Spanish: "Acepte su invitación colla",
    Italian: "Accettare l'invito di colla",
  },
  {
    FIELD1: "default.helmet.title",
    English: "colla: Pet Tracking",
    French: "Suivi des animaux domestiques",
    German: "Haustier-Tracking",
    Spanish: "Seguimiento de mascotas",
    Italian: "Monitoraggio degli animali domestici",
  },
  {
    FIELD1: "footer.app.appstore",
    English: "/assets/app/download-on-app-store.png",
    French: "/assets/app/download-on-app-store-fr.png",
    German: "/assets/app/download-on-app-store-de.png",
    Spanish: "/assets/app/download-on-app-store-es.png",
    Italian: "/assets/app/download-on-app-store-it.png",
  },
  {
    FIELD1: "footer.app.playstore",
    English: "/assets/app/download-on-google-play-store.png",
    French: "/assets/app/download-on-google-play-store-fr.png",
    German: "/assets/app/download-on-google-play-store-de.png",
    Spanish: "/assets/app/download-on-google-play-store-es.png",
    Italian: "/assets/app/download-on-google-play-store-it.png",
  },
  {
    FIELD1: "share.helmet.title",
    English: "Colla Pet Tracking Link",
    French: "Lien de suivi Colla",
    German: "Colla Verfolgungslink",
    Spanish: "Enlace de seguimiento Colla",
    Italian: "Link per il tracciamento Colla",
  },
  {
    FIELD1: "share.main.error",
    English: "Link not found or expired",
    French: "Lien introuvable ou expiré",
    German: "Der Link wurde nicht gefunden oder ist abgelaufen ",
    Spanish: "Enlace no encontrado o vencido",
    Italian: "Link non trovato o scaduto",
  },
  {
    FIELD1: "share.main.error2",
    English: "No tracker data",
    French: "Pas de données sur le traceur",
    German: "Keine Tracker Daten ",
    Spanish: "Sin datos del rastreador",
    Italian: "Nessun dato del tracker",
  },
  {
    FIELD1: "share.main.error3",
    English:
      "This share has reached the maximum number of requests allowed within a short period. Please try again in 15 minutes.",
    French:
      "Ce partage a atteint le nombre maximum de demandes autorisées dans un court laps de temps. Veuillez réessayer dans 15 minutes.",
    German:
      "Diese Freigabe hat die maximale Anzahl and Anfragen innerhalb eines kurzen Zeitraums erreicht. Bitte versuche es in 15 Minuten erneut. ",
    Spanish:
      "Esta compartición ha alcanzado el número máximo de solicitudes permitidas en un corto período. Intente nuevamente en 15 minutos.",
    Italian:
      "Questa condivisione ha raggiunto il numero massimo di richieste consentite in un breve periodo. Riprovare tra 15 minuti.",
  },
  {
    FIELD1: "share.link.title",
    English: "Looking for a Pet tracker?",
    French: "Vous cherchez un traceur Pet ?",
    German: "Suchen Sie nach einem Pet Tracker?",
    Spanish: "¿ Busca un localizador Pet ?",
    Italian: "Sei alla ricerca di un localizzatore Pet?",
  },
  {
    FIELD1: "share.link.link",
    English: "Shop here",
    French: "Faites vos achats ici",
    German: "Hier einkaufen",
    Spanish: "Compre aquí",
    Italian: "Acquista qui",
  },
  {
    FIELD1: "lost.helmet.title",
    English: "Found a pet?",
    French: "Vous avez trouvé un animal ?",
    German: "Ein Haustier gefunden?",
    Spanish: "¿Has encontrado una mascota?",
    Italian: "Hai trovato un animale domestico?",
  },
  {
    FIELD1: "lost.helmet.desc",
    English:
      "Help reunite them with their owner by reporting where you found them.",
    French:
      "Aidez-le à retrouver son propriétaire en indiquant où vous l'avez trouvé.",
    German:
      "Helfen Sie dabei, es wieder mit seinem Besitzer zu vereinen, indem Sie angeben, wo Sie es gefunden haben.",
    Spanish: "Ayude a reunirla con su propietario indicando dónde la encontró.",
    Italian:
      "Aiuta a farlo ricongiungere al proprietario indicando dove lo hai trovato.",
  },
  {
    FIELD1: "lost.main.title",
    English: "Found a pet with a colla tracker?",
    French: "Vous avez trouvé un animal portant un traceur colla ?",
    German: "Haben Sie ein Haustier mit einem colla-Tracker gefunden?",
    Spanish: "¿Has encontrado una mascota con un localizador colla?",
    Italian: "Hai trovato un animale domestico con un tracker colla?",
  },
  {
    FIELD1: "lost.main.label_phone",
    English: "Phone",
    French: "Téléphone",
    German: "Telefon",
    Spanish: "Teléfono",
    Italian: "Telefono",
  },
  {
    FIELD1: "lost.main.input_placeholder",
    English: "e.g. 2910473",
    French: "ex. 2910473",
    German: "z. B. 2910473",
    Spanish: "p. ej. 2910473",
    Italian: "es. 2910473",
  },
  {
    FIELD1: "lost.main.subheading",
    English:
      "Help reunite them with their owner by reporting where you found them.",
    French:
      "Aidez-le à retrouver son propriétaire en indiquant où vous l'avez trouvé.",
    German:
      "Helfen Sie dabei, es wieder mit seinem Besitzer zu vereinen, indem Sie angeben, wo Sie es gefunden haben.",
    Spanish: "Ayude a reunirla con su propietario indicando dónde la encontró.",
    Italian:
      "Aiuta a farlo ricongiungere al proprietario indicando dove lo hai trovato.",
  },
  {
    FIELD1: "lost.main.label_pin",
    English: "Enter the PIN on the back of their tracker",
    French: "Saisissez le code PIN au dos du traceur",
    German: "Geben Sie die PIN auf der Rückseite des Trackers ein",
    Spanish:
      "Introduzca el PIN que aparece en la parte posterior del localizador",
    Italian: "Inserisci il PIN sul retro del tracker",
  },
  {
    FIELD1: "lost.main.button_submit",
    English: "Request owner information",
    French: "Demander les informations du propriétaire",
    German: "Informationen zum Besitzer anfordern",
    Spanish: "Solicitar información del propietario",
    Italian: "Richiedi le informazioni del proprietario",
  },
  {
    FIELD1: "lost.main.button_loading",
    English: "Requesting owner information",
    French: "Demande des informations du propriétaire",
    German: "Informationen zum Besitzer werden angefordert",
    Spanish: "Solicitando información del propietario",
    Italian: "Richiesta delle informazioni del proprietario",
  },
  {
    FIELD1: "lost.main.error1",
    English:
      "Sorry, we couldn’t find that tracker, please check it’s entered correctly",
    French:
      "Désolé, nous n'avons pas trouvé ce traceur. Veuillez vérifier qu'il est saisi correctement.",
    German:
      "Leider konnten wir diesen Tracker nicht finden. Bitte prüfen Sie, ob er korrekt eingegeben wurde.",
    Spanish:
      "Lo sentimos, no hemos podido encontrar ese localizador. Compruebe que lo ha introducido correctamente.",
    Italian:
      "Spiacenti, non siamo riusciti a trovare questo tracker. Verifica di averlo inserito correttamente.",
  },
  {
    FIELD1: "lost.main.error2",
    English:
      "If it is, local vet, animal shelter, or rescue organisation can help check for identification and assist with returning the pet to its owner.",
    French:
      "Si c'est bien le cas, un vétérinaire local, un refuge pour animaux ou une association de sauvetage peut aider à vérifier son identification et à le rendre à son propriétaire.",
    German:
      "Falls doch, kann ein örtlicher Tierarzt, ein Tierheim oder eine Tierschutzorganisation dabei helfen, die Identifizierung zu prüfen und das Tier seinem Besitzer zurückzubringen.",
    Spanish:
      "Si es así, un veterinario local, un refugio de animales o una organización de rescate pueden ayudar a comprobar su identificación y a devolver la mascota a su propietario.",
    Italian:
      "In tal caso, un veterinario locale, un rifugio per animali o un'organizzazione di soccorso possono aiutare a verificarne l'identificazione e a restituire l'animale al proprietario.",
  },
  {
    FIELD1: "lost.main.found_title",
    English: "Owner Found!",
    French: "Propriétaire trouvé !",
    German: "Besitzer gefunden!",
    Spanish: "¡Propietario encontrado!",
    Italian: "Proprietario trovato!",
  },
  {
    FIELD1: "lost.main.found_desc",
    English:
      "If the owner doesn’t respond, please consider contacting a local veterinarian, animal shelter, or animal rescue organisation. They can help check for identification and ensure the pet is cared for safely.",
    French:
      "Si le propriétaire ne répond pas, veuillez envisager de contacter un vétérinaire local, un refuge pour animaux ou une association de sauvetage. Ils pourront aider à vérifier son identification et s'assurer que l'animal est pris en charge en toute sécurité.",
    German:
      "Falls der Besitzer nicht reagiert, wenden Sie sich bitte an einen örtlichen Tierarzt, ein Tierheim oder eine Tierschutzorganisation. Dort kann man helfen, die Identifizierung zu prüfen und sicherzustellen, dass das Tier gut versorgt wird.",
    Spanish:
      "Si el propietario no responde, considere ponerse en contacto con un veterinario local, un refugio de animales o una organización de rescate. Ellos pueden ayudar a comprobar su identificación y garantizar que la mascota reciba atención de forma segura.",
    Italian:
      "Se il proprietario non risponde, valuta la possibilità di contattare un veterinario locale, un rifugio per animali o un'organizzazione di soccorso. Possono aiutare a verificarne l'identificazione e a garantire che l'animale riceva assistenza in sicurezza.",
  },
  {
    FIELD1: "lost.main.not_found_title",
    English: "Sorry, no details found",
    French: "Désolé, aucune information trouvée",
    German: "Leider wurden keine Angaben gefunden",
    Spanish: "Lo sentimos, no se han encontrado datos",
    Italian: "Spiacenti, nessun dettaglio trovato",
  },
  {
    FIELD1: "lost.main.not_found_desc1",
    English:
      "This means that the owner of this tracker has deleted their details, or they opted out of sharing them.",
    French:
      "Cela signifie que le propriétaire de ce traceur a supprimé ses informations, ou qu'il a choisi de ne pas les partager.",
    German:
      "Das bedeutet, dass der Besitzer dieses Trackers seine Angaben gelöscht hat oder der Weitergabe nicht zugestimmt hat.",
    Spanish:
      "Esto significa que el propietario de este localizador ha eliminado sus datos o ha decidido no compartirlos.",
    Italian:
      "Questo significa che il proprietario di questo tracker ha eliminato i propri dati oppure ha scelto di non condividerli.",
  },
  {
    FIELD1: "lost.main.not_found_desc2",
    English:
      "Unfortunately, there’s no way for us to contact them, so please consider contacting a local veterinarian, animal shelter, or animal rescue organisation. They can help check for identification and ensure the pet is cared for safely.",
    French:
      "Malheureusement, nous n'avons aucun moyen de les contacter. Veuillez donc envisager de contacter un vétérinaire local, un refuge pour animaux ou une association de sauvetage. Ils pourront aider à vérifier son identification et s'assurer que l'animal est pris en charge en toute sécurité.",
    German:
      "Leider gibt es für uns keine Möglichkeit, Kontakt aufzunehmen. Wenden Sie sich daher bitte an einen örtlichen Tierarzt, ein Tierheim oder eine Tierschutzorganisation. Dort kann man helfen, die Identifizierung zu prüfen und sicherzustellen, dass das Tier gut versorgt wird.",
    Spanish:
      "Lamentablemente, no tenemos forma de ponernos en contacto con esa persona, así que considere contactar con un veterinario local, un refugio de animales o una organización de rescate. Ellos pueden ayudar a comprobar su identificación y garantizar que la mascota reciba atención de forma segura.",
    Italian:
      "Purtroppo non abbiamo alcun modo di contattarlo, quindi valuta la possibilità di contattare un veterinario locale, un rifugio per animali o un'organizzazione di soccorso. Possono aiutare a verificarne l'identificazione e a garantire che l'animale riceva assistenza in sicurezza.",
  },
];

// const updatedTranslations = [];

// for (let i of translationData) {
//   const newT = newTranslations.find((t) => i.FIELD1.includes(t.FIELD1));
//   if (newT) {
//     updatedTranslations.push({ ...newT, FIELD1: i.FIELD1 });
//   } else {
//     updatedTranslations.push({
//       FIELD1: i.FIELD1,
//       English: i.English,
//       French: i.French,
//       German: i.German,
//       Spanish: i.Spanish,
//       Italian: i.Italian,
//     });
//   }
// }
// console.log(updatedTranslations);

function generateI18nData(language) {
  const i18nData = {};

  const countries = {
    FIELD1: "localization.main.countries",
    English: JSON.stringify(countryListEN),
    French: JSON.stringify(countryListFR),
    German: JSON.stringify(countryListDE),
    Spanish: JSON.stringify(countryListES),
    Italian: JSON.stringify(countryListIT),
  };

  [countries, ...translationData].forEach((obj) => {
    const [page, section, name] = obj.FIELD1.split(".");
    i18nData[page] ??= {};
    i18nData[page][section] ??= {};
    i18nData[page][section][name] = obj[language];
  });
  return i18nData;
}

export default generateI18nData;
